import { buildBpointExportRows } from '../../utils/bpointListinoExport';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import {
  GridFooterContainer,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  gridFilteredSortedRowIdsSelector,
  itIT,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";
import { PersistentDataGridPro as DataGridPro } from "../../components/DataGrid/PersistentDataGridPro";
import LinearProgress from "@mui/material/LinearProgress";
import { toast } from "react-toastify";
import * as XLSX from "xlsx-js-style";
import api from "../../api/api";
import { EXPORT_BUTTON_CLASS } from "../../utils/exportButtonStyle";
import { Autocomplete } from "../../components/Autocomplete";
import { Select } from "../../components/Select";
import { Input } from "../../components/Input";
import Modal from "../../components/Modal";
import { knowAcces } from "../../utils/utils";
import { ScontoGlobaleIIpay } from "./ScontoGlobaleIIpay";
import { formatItalianNumber } from "../../utils/formatItalianNumber";
import { isIntegrazioneSalariale, isZucchetti1237 } from "../../utils/bpoint1427";
import { isBpoint1439 } from "../../utils/bpoint1439";
import BpointListinoEditor from "./BpointListinoEditor";

const SETTORI = [
  { id: "PAGHE", name: "Paghe", settoreId: 3 },
  { id: "ASSUNZIONI", name: "Assunzioni", settoreId: 1 },
  { id: "CONSULENZA", name: "Consulenza", settoreId: 2 },
];

const SETTORE_SOLO_ADMIN = 4;
const SETTORE_TUTTI = 5;

const VIEWS = [
  { id: "cliente", name: "Cliente" },
  { id: "rate_card", name: "Rate card iiPay" },
  { id: "extra", name: "Extra" },
  { id: "bpoint_listino", name: "Fasce BPoint" },
  { id: "voci", name: "Voci listino" },
  { id: "master", name: "Master" },
];

const TIPOLOGIE_CLIENTE = [
  { id: "Z", name: "Zucchetti" },
  { id: "I", name: "iiPay" },
  { id: "B", name: "Bpoint" },
];

// Stesso schema colori usato in Clienti.js e Autocomplete.js
const TIPO_BADGE_CLASSES = {
  Z: "bg-blue-100 text-blue-700",
  I: "bg-green-100 text-green-700",
  B: "bg-purple-100 text-purple-700",
};


const DEFAULT_DETTAGLI_LISTINO = {
  tipologia_fatturazione: TIPOLOGIE_CLIENTE,
  appartenenza: [
    { id: 1, name: "Miller" },
    { id: 2, name: "Studio Albergoni" },
  ],
  settore: [
    { id: 1, name: "Assunzioni" },
    { id: 2, name: "Consulenza" },
    { id: 3, name: "Paghe" },
    { id: 4, name: "Solo admin" },
    { id: 5, name: "Tutti" },
  ],
  metodo_fatturazione: [
    { id: 1, name: "Libera" },
    { id: 2, name: "Libera" },
    { id: 3, name: "Listino" },
    { id: 4, name: "Forfait" },
    { id: 5, name: "Oraria" },
    { id: 6, name: "Tabella" },
    { id: 7, name: "Unitaria" },
    { id: 8, name: "Listino/Tabella" },
    { id: 9, name: "Listino/Forfait" },
  ],
};

const NUOVA_VOCE_DEFAULT = {
  codice: "",
  nuovo_codice_ago: "",
  tipologia_fatturazione: "Z",
  descrizione_voce_ago: "",
  descrizione_voce_crm: "",
  appartenenza: 1,
  settore: 3,
  metodo_fatturazione: 3,
  sezione_crm: "3",
  importo_default: "",
  note: "",
  richiesta: "",
  descrizione_obbligatoria: false,
  codice_ago_fallback: false,
  voce_particolare: false,
  quantita_obbligatoria: true,
  attivo: true,
  tutte_aziende: true,
  limitata_aziende: false,
  aziende_ammesse: [],
  iipay_a_fascia: false,
  fasce_prezzi: {},
  prezzo_decorrenza: "",
  iipay_importo_fisso_id: null,
  solo_admin: false,
  cigo_quota_base: 150,
  cigo_maltempo_quota_base: 75,
  quota_variabile: 2,
  fsba_coefficiente: 1.5,
  fsba_minimo: 50,
  tetto_massimo: 500,
  quota_fino_5000: 50,
  quota_5001_10000: 75,
  quota_10001_50000: 100,
  quota_oltre_50000: 150,
  quota_domanda_aggiuntiva: 25,
  importo_minimo: 100,
  quota_base_trimestrale: 50,
  quota_per_cedolino_edile: 1,
  quota_per_cedolino_dirigente: 9,
};

const isBpoint442 = (row) => String(row?.tipologia_fatturazione || '').toUpperCase() === 'B'
  && Number(String(row?.nuovo_codice_ago || row?.codice || '').replace(/^0+/, '')) === 442;
const isBpoint446 = (row) => String(row?.tipologia_fatturazione || '').toUpperCase() === 'B'
  && Number(String(row?.nuovo_codice_ago || row?.codice || '').replace(/^0+/, '')) === 446;

const LISTINO_CLIENTE_EDIT_DEFAULT = {
  row: null,
  importo: "",
  decorrenza: "",
  zucchettiCodice: null,
  zucchettiRows: [],
  zucchettiId: null,
  importoForfait: "",
  maxCedolini: "",
  costoExtra: "",
  periodicita: "mensile",
  periodicitaOriginale: "mensile",
  mesiModificati: false,
  mesiFatturazione: "",
  metodoFatturazioneCliente: "",
  aZero: false,
  applicato: false,
};

const PERIODICITA_CLIENTE_EDIT_DEFAULT = {
  open: false,
  periodicita: "mensile",
};

const ISTAT_CLIENTE_EDIT_DEFAULT = {
  open: false,
  applicato: false,
  decorrenza: "",
};

// Il "tipo" del cliente Zucchetti non e' un campo, e' la combinazione delle
// configurazioni in dati_parcellazione_zucchetti: forfait (tipologia_cliente 1),
// listino (0) o entrambe (ibrido).
const TIPO_ZUCCHETTI_OPTIONS = [
  { id: "listino", name: "Listino" },
  { id: "forfait", name: "Forfait" },
  { id: "ibrido", name: "Ibrido" },
];

const TIPOLOGIE_CLIENTE_ZUCCHETTI = {
  listino: [0],
  forfait: [1],
  ibrido: [0, 1],
};

const TIPO_ZUCCHETTI_EDIT_DEFAULT = {
  open: false,
  tipo: "listino",
  decorrenza: "",
};

const SCONTO_CLIENTE_EDIT_DEFAULT = {
  open: false,
  id: null,
  percentuale: "",
  meseInizio: "",
  meseInizioOriginale: "",
  meseFine: "",
  note: "",
};

const ISTAT_APPLICA_DEFAULT = {
  open: false,
  voce: null,
  percentuale: "",
  decorrenza: "",
  arrotondamento: null,
  loadingAnteprima: false,
  anteprima: [],
  selezionati: new Set(),
  search: "",
  applying: false,
};

const ISTAT_REPORT_DEFAULT = {
  open: false,
  annoDa: "",
  annoA: "",
};

const TIPOLOGIA_LABEL = {
  Z: "Zucchetti",
  I: "iiPay",
  B: "Bpoint",
};

const PERIODICITA_LABEL = {
  mensile: "Mensile",
  trimestrale: "Trimestrale",
  semestrale: "Semestrale",
  annuale: "Annuale",
  custom: "Personalizzata",
};

const PERIODICITA_OPTIONS = [
  { id: "mensile", name: "Mensile" },
  { id: "trimestrale", name: "Trimestrale" },
  { id: "semestrale", name: "Semestrale" },
  { id: "annuale", name: "Annuale" },
];
const PERIODICITA_OPTION_IDS = new Set(PERIODICITA_OPTIONS.map((option) => option.id));

const MESI_FATTURAZIONE_OPTIONS = [
  { id: 1, name: "Gen" },
  { id: 2, name: "Feb" },
  { id: 3, name: "Mar" },
  { id: 4, name: "Apr" },
  { id: 5, name: "Mag" },
  { id: 6, name: "Giu" },
  { id: 7, name: "Lug" },
  { id: 8, name: "Ago" },
  { id: 9, name: "Set" },
  { id: 10, name: "Ott" },
  { id: 11, name: "Nov" },
  { id: 12, name: "Dic" },
];

const parseMesiFatturazione = (value) =>
  String(value || "")
    .split(",")
    .map((m) => Number(String(m).trim()))
    .filter((m) => Number.isInteger(m) && m >= 1 && m <= 12);

const serializeMesiFatturazione = (months) =>
  [...new Set(months)]
    .sort((a, b) => a - b)
    .join(",");

// Mesi in cui la 186 viene effettivamente fatturata: la voce si emette nel mese
// successivo alla chiusura del periodo di competenza, quindi il trimestrale cade a
// gennaio/aprile/luglio/ottobre, il semestrale a gennaio/luglio e l'annuale ad aprile
// (stessa cadenza di _shouldBillZucchetti186ThisMonth lato backend).
const mesiFromPeriodicita = (periodicita, mesiFatturazione = "") => {
  if (periodicita === "trimestrale") return "1,4,7,10";
  if (periodicita === "semestrale") return "1,7";
  if (periodicita === "annuale") return "4";
  return mesiFatturazione || "";
};

const IIPAY_LISTINO_BASE_ID = "1";

const fmt = (v) =>
  v != null && v !== ""
    ? formatItalianNumber(v, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : "";

const parseImportoInput = (value) => {
  const raw = String(value ?? "").trim();
  if (!raw) return null;
  const normalized = raw.includes(",") ? raw.replace(/\./g, "").replace(",", ".") : raw;
  const num = Number(normalized);
  return Number.isFinite(num) ? num : null;
};

const sameImportoInput = (a, b) => {
  const first = parseImportoInput(a);
  const second = parseImportoInput(b);
  if (first == null && second == null) return true;
  if (first == null || second == null) return false;
  return Math.abs(first - second) <= 0.005;
};

const normalizeCodiceListino = (codice) => {
  const raw = String(codice || "").trim();
  if (!raw) return "";
  const normalized = raw.replace(/^0+(?=\d)/, "");
  return normalized || "0";
};

const codiceExportValue = (codice) => {
  const normalized = normalizeCodiceListino(codice);
  if (!normalized) return "";
  return /^\d+$/.test(normalized) ? Number(normalized) : normalized;
};

const formatSezioneCrm = (value) =>
  String(value || "")
    .split("//")
    .map((part) => part.trim())
    .filter(Boolean)
    .join("/");

const getSezioneSortValue = (value) => {
  const sezioni = String(value || "")
    .split(/\/\/|\//)
    .map((part) => Number(String(part).trim()))
    .filter((num) => Number.isFinite(num));
  if (!sezioni.length) return 99;
  return Math.min(...sezioni);
};

const includesSezioneCrm = (value, sezione) =>
  String(value || "")
    .split(/\/\/|\//)
    .map((part) => part.trim())
    .filter(Boolean)
    .includes(String(sezione));

// Una voce puo' appartenere a piu' sezioni insieme (es. "3//6"): in quel caso va
// mostrata sia nel listino sezione 3 sia in rate card, non solo in uno dei due.
const isSoloSezione3 = (value) => {
  const sezioni = String(value || "")
    .split(/\/\/|\//)
    .map((part) => part.trim())
    .filter(Boolean);
  return sezioni.length > 0 && sezioni.every((s) => s === "3");
};

const CR_CODE_IIPAY = new Set(["1243", "1005", "1236", "1238", "1245", "1447", "1446"]);
const getRateCardFlagIipay = (codice) => {
  const normalized = normalizeCodiceListino(codice);
  if (normalized === "1236") return "Sì";
  if (CR_CODE_IIPAY.has(normalized)) return "No";
  return "";
};

const getFasciaKey = (row) => `${row?.min_fascia ?? ""}:${row?.max_fascia ?? ""}`;
const isFasciaRow = (row) => row?.min_fascia != null || row?.max_fascia != null;

// Un salvataggio di una voce iiPay "Fisso"/"Tutte le aziende" scrive lo stesso
// prezzo in due tabelle (prezzo di default + rate card condivisa), generando due
// righe di storico per lo stesso salvataggio. Le uniamo in una sola riga se sono
// dello stesso utente, stesso importo nuovo, ed entro pochi secondi l'una dall'altra.
const GRUPPO_STORICO_SOGLIA_SEC = 30;
const groupStoricoRows = (rows = []) => {
  const groups = [];
  rows.forEach((row) => {
    const last = groups[groups.length - 1];
    // Stessa fascia (o entrambe senza fascia) e' condizione necessaria: due
    // fasce diverse che per caso ricevono lo stesso importo nello stesso
    // salvataggio non vanno unite, sono variazioni distinte.
    const stessaFascia = last && last.rows[0].min_fascia === row.min_fascia && last.rows[0].max_fascia === row.max_fascia;
    const stessoImporto = last && Number(last.rows[0].importo_nuovo) === Number(row.importo_nuovo) && last.rows[0].utente === row.utente;
    const entroSoglia = last && Math.abs(new Date(last.rows[0].data_modifica) - new Date(row.data_modifica)) / 1000 <= GRUPPO_STORICO_SOGLIA_SEC;
    if (stessaFascia && stessoImporto && entroSoglia) {
      last.rows.push(row);
    } else {
      groups.push({ rows: [row] });
    }
  });
  return groups.map((g) => {
    const ids = g.rows.map((r) => r.id);
    const conPrima = g.rows.find((r) => r.importo_precedente != null);
    return {
      ids,
      data_modifica: g.rows[0].data_modifica,
      importo_precedente: conPrima ? conPrima.importo_precedente : null,
      importo_nuovo: g.rows[0].importo_nuovo,
      min_fascia: g.rows[0].min_fascia,
      max_fascia: g.rows[0].max_fascia,
      data_decorrenza: g.rows[0].data_decorrenza,
      utente: g.rows[0].utente,
      origine: g.rows[0].origine,
      non_annullabile: g.rows.some((r) => Number(r.non_annullabile) === 1),
    };
  });
};

const getFasciaLabel = (row) => {
  const min = row?.min_fascia;
  const max = row?.max_fascia;
  if (min == null && max == null) return "Senza fascia";
  if (min != null && max != null) return `${min}-${max}`;
  if (min != null) return `da ${min}`;
  return `fino a ${max}`;
};

const isZucchettiForfaitListinoCode = (row) =>
  ["186", "187", "189"].includes(codiceAgoVoce(row));

const getZucchettiConfigLabel = (row) => {
  const tipo = Number(row?.tipologia_cliente) === 1 ? "186" : "189";
  const importo = Number(row?.tipologia_cliente) === 1 ? row?.importo_forfait : row?.costo_extra;
  const mesi = row?.periodicita === "custom" && row?.mesi_fatturazione
    ? ` mesi ${row.mesi_fatturazione}`
    : " tutti i mesi";
  return `${tipo} - ${fmt(importo)}${mesi}`;
};

const formatMeseAnno = (value) => {
  if (!value?.anno || !value?.mese) return "";
  return `${String(value.mese).padStart(2, "0")}/${value.anno}`;
};

const formatDateIt = (value) => {
  const raw = String(value || "").slice(0, 10);
  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : raw;
};

const formatMeseAnnoStr = (value) => {
  const match = String(value || "").match(/^(\d{4})-(\d{2})/);
  return match ? `${match[2]}/${match[1]}` : "";
};

// Quando un nuovo periodo di sconto si sovrappone a uno gia' programmato nel
// futuro, calcola l'ultimo mese utile come data fine (il mese prima
// dell'inizio del periodo futuro piu' vicino) da proporre in automatico
// invece di limitarsi a bloccare il salvataggio.
const suggerisciMeseFineMassimo = (rows, meseInizio, excludeId = null) => {
  const inizioStr = `${meseInizio}-01`;
  const futuri = rows
    .filter((r) => (excludeId == null || String(r.id) !== String(excludeId)) && r.data_inizio > inizioStr)
    .map((r) => r.data_inizio)
    .sort();
  if (!futuri.length) return null;
  const [anno, mese] = futuri[0].split("-").map(Number);
  const prevAnno = mese === 1 ? anno - 1 : anno;
  const prevMese = mese === 1 ? 12 : mese - 1;
  return `${prevAnno}-${String(prevMese).padStart(2, "0")}`;
};

const codiceVoce = (row) => normalizeCodiceListino(row?.nuovo_codice_ago || row?.codice);
const codiceAgoVoce = (row) => normalizeCodiceListino(row?.nuovo_codice_ago || row?.codice);

const codiceSortValue = (row) => {
  const codice = codiceVoce(row);
  const numeric = Number(codice);
  return Number.isFinite(numeric) ? numeric : codice;
};

const codiceAgoSortValue = (row) => {
  const codice = codiceAgoVoce(row);
  const numeric = Number(codice);
  return Number.isFinite(numeric) ? numeric : codice;
};

const settoreMatches = (row, settoreId) =>
  Number(row?.settore_listino_id) === settoreId ||
  Number(row?.settore_listino_id) === SETTORE_TUTTI ||
  Number(row?.settore_listino_id) === SETTORE_SOLO_ADMIN;

const requiresQuantita = (row) => {
  if (!row || row.voce_particolare) return false;
  if (row.quantita_obbligatoria !== undefined && row.quantita_obbligatoria !== null) {
    return Number(row.quantita_obbligatoria) === 1;
  }
  return ![1, 2, 6, 8].includes(Number(row.metodo_fatturazione));
};

const requiresDescrizione = (row) =>
  !!String(row?.richiesta || "").trim();

const isListinoLiberoOTabella = (row) => [1, 2, 6, 8].includes(Number(row?.metodo_fatturazione));

const isAZero = (row) => Number(row?.a_zero) === 1 || row?.a_zero === true;

const getMetodoBase = (row) => Number(row?.metodo_fatturazione_base ?? row?.metodo_fatturazione);

const isVoceDoppiaOpzione = (row) => [8, 9].includes(getMetodoBase(row));

const getMetodoDoppiaOpzioneOptions = (row) => {
  const base = getMetodoBase(row);
  if (base === 8) {
    return [
      { id: 3, name: "Fisso" },
      { id: 6, name: "Tabella" },
    ];
  }
  if (base === 9) {
    return [
      { id: 3, name: String(row?.codice) === "198" ? "A cedolino" : "Fisso" },
      { id: 4, name: "Forfait" },
    ];
  }
  return [];
};

const getMetodoClienteDoppiaOpzione = (row) => {
  const current = Number(row?.metodo_fatturazione_cliente ?? row?.metodo_fatturazione);
  if ([3, 4, 6].includes(current)) return current;
  const base = getMetodoBase(row);
  if (base === 8) return 6;
  if (base === 9) return 3;
  return current;
};

const isMetodoSenzaImportoFisso = (metodo) => [1, 2, 6, 8].includes(Number(metodo));

const isVoceForfait = (row) => {
  const metodo = Number(row?.metodo_fatturazione);
  const base = getMetodoBase(row);
  return metodo === 4 || base === 9;
};

// I forfait Zucchetti e BPOINT si gestiscono nelle rispettive sezioni,
// non dal listino cliente generico.
const getForfaitSection = (row, cliente) => {
  const codice = codiceAgoVoce(row);
  if (cliente?.tipologia_fatturazione === "Z" && codice === "1201") return 4;
  if (cliente?.tipologia_fatturazione === "Z" && codice === "1204") return 5;
  if (cliente?.tipologia_fatturazione === "B" && codice === "1429") return 4;
  if (cliente?.tipologia_fatturazione === "B" && codice === "1430") return 5;
  return null;
};

const isForfaitBloccato = (row, cliente) =>
  getForfaitSection(row, cliente) !== null;

const ForfaitBadge = () => (
  <span className="inline-flex shrink-0 whitespace-nowrap rounded border border-emerald-200 bg-emerald-50 px-1.5 py-0.5 text-[10px] font-semibold text-emerald-700">
    Forfait
  </span>
);

const DualChoiceBadge = () => (
  <span className="inline-flex shrink-0 whitespace-nowrap rounded border border-violet-200 bg-violet-50 px-1.5 py-0.5 text-[10px] font-semibold text-violet-700">
    2 scelte
  </span>
);

const IstatBadge = () => (
  <span className="inline-flex shrink-0 whitespace-nowrap rounded border border-orange-200 bg-orange-50 px-1.5 py-0.5 text-[10px] font-semibold text-orange-700">
    ISTAT
  </span>
);

// Per iiPay "Tabella" e "Fascia" condividono metodo_fatturazione = 6: la voce e' a
// fascia quando la rate card ha bande valorizzate (flag dal backend) o quando la riga
// cliente ha gia' una fascia applicata per il periodo. In quel caso il prezzo esiste
// (quello della fascia) e non va mostrata l'etichetta "Tabella".
const isVoceIipayAFascia = (row) =>
  Number(row?.iipay_ha_fascia) === 1 ||
  row?.iipay_ha_fascia === true ||
  row?.iipay_min_fascia_applicata != null ||
  row?.iipay_max_fascia_applicata != null;

const getListinoValue = (row) => {
  if (isAZero(row)) return "zero";
  if (String(row?.codice) === "198" && getMetodoClienteDoppiaOpzione(row) === 4) {
    if (row?.canone_forfait === null || row?.canone_forfait === undefined || row?.canone_forfait === "") return "NULL";
    if (Number(row.canone_forfait) === 0) return "zero";
    return fmt(row.canone_forfait);
  }
  const metodo = Number(row?.metodo_fatturazione);
  if (metodo === 1 || metodo === 2) return "Libero";
  // "Tabella" e "Fascia" condividono lo stesso metodo_fatturazione (6): una riga
  // con min/max fascia valorizzati è sempre a fascia, mai genericamente "tabella".
  if ([6, 8].includes(metodo) && !isFasciaRow(row)) return "Tabella";
  if (row?.importo === null || row?.importo === undefined || row?.importo === "") return "NULL";
  if (Number(row.importo) === 0) return "zero";
  return fmt(row.importo);
};

const getMetodoSenzaImportoLabel = (metodo, row = null, labelMap = null) => {
  const normalized = Number(metodo);
  if (normalized === 1 || normalized === 2) return "Libero";
  if ([6, 8].includes(normalized) && !isFasciaRow(row)) return "Tabella";
  return labelMap?.get(String(normalized)) || "";
};

const getListinoUnitarioValue = (row) => {
  if (!row) return "NULL";
  if (isAZero(row)) return "zero";
  // La 198 puo' essere valorizzata a cedolino (importo) oppure con un canone
  // forfait. Billing usa entrambe le colonne: la vista listino deve fare lo
  // stesso e non mostrare zero quando il canone e' presente.
  if (String(row.codice) === "198" && Number(row.canone_forfait) > 0 && Number(row.importo || 0) === 0) {
    return fmt(row.canone_forfait);
  }
  const metodo = Number(row.metodo_fatturazione);
  if (metodo === 1 || metodo === 2) return "Libero";
  const aFasciaIipay = isVoceIipayAFascia(row);
  if ([6, 8].includes(metodo) && !isFasciaRow(row) && !aFasciaIipay) return "Tabella";

  const candidates = [
    row.importo_unitario,
    row.prezzo_unitario,
    row.costo_unitario,
    row.importo_cedolino,
    row.costo_extra,
    row.importo,
  ];
  const value = candidates.find((candidate) => (
    candidate !== null &&
    candidate !== undefined &&
    candidate !== "" &&
    Number.isFinite(Number(candidate))
  ));
  if (value === undefined) return aFasciaIipay ? "A fascia" : "NULL";
  if (Number(value) === 0) return "zero";
  return fmt(value);
};

const getVoceListinoImportoValue = (row) => {
  if (!row) return "";
  const metodo = Number(row.metodo_fatturazione);
  if (metodo === 1 || metodo === 2) return "Libero";
  // Il controllo sulle fasce iiPay precede quello sul metodo: una voce a fascia usa
  // lo stesso metodo_fatturazione delle voci a tabella ma un prezzo ce l'ha.
  if (String(row.tipologia_fatturazione || "").toUpperCase() === "I") {
    if (isVoceIipayAFascia(row)) return "A fascia";
    if ([6, 8].includes(metodo)) return "Tabella";
    return fmt(row.iipay_importo_fisso ?? row.importo_default);
  }
  if ([6, 8].includes(metodo) && !isFasciaRow(row)) return "Tabella";
  return fmt(row.importo_default);
};

const getListinoFasciaLabel = (row) => {
  const min = row?.iipay_min_fascia_applicata;
  const max = row?.iipay_max_fascia_applicata;
  if (min == null && max == null) return "";
  return min != null && max != null ? `${min}-${max}` : min != null ? `da ${min}` : `fino a ${max}`;
};

const getListinoExportValue = (row) => {
  if (isAZero(row)) return 0;
  if (String(row?.codice) === "198" && Number(row?.canone_forfait) > 0 && Number(row?.importo || 0) === 0) {
    return Number(row.canone_forfait);
  }
  const metodo = Number(row?.metodo_fatturazione);
  if (metodo === 1 || metodo === 2) return "Libero";
  const aFasciaIipay = isVoceIipayAFascia(row);
  if ([6, 8].includes(metodo) && !isFasciaRow(row) && !aFasciaIipay) return "Tabella";
  if (row?.importo === null || row?.importo === undefined || row?.importo === "") {
    return aFasciaIipay ? "A fascia" : "NULL";
  }
  return Number(row.importo);
};

const isZeroListino = (row) =>
  !(String(row?.codice) === "198" && Number(row?.canone_forfait) > 0) &&
  (isAZero(row) || !isListinoLiberoOTabella(row)) &&
  (row?.importo === null || row?.importo === undefined || row?.importo === "" || Number(row.importo) === 0);

const sortListinoRows = (rows = []) =>
  [...rows].sort((a, b) =>
    String(codiceSortValue(a)).localeCompare(String(codiceSortValue(b)), "it", {
      sensitivity: "base",
      numeric: true,
    })
  );

const decorateTariffaRow = (row) => ({
  ...row,
  codice_visualizzato: normalizeCodiceListino(row.nuovo_codice_ago || row.prestazione),
  rate_card: getRateCardFlagIipay(row.nuovo_codice_ago || row.prestazione),
  importo_visualizzato: getListinoValue(row),
  tipo_importo: isFasciaRow(row) ? "A fascia" : "Fisso",
});

const compareTariffaRows = (a, b) => {
  const sezioneDiff = getSezioneSortValue(a.sezione_crm) - getSezioneSortValue(b.sezione_crm);
  if (sezioneDiff !== 0) return sezioneDiff;

  return String(a.codice_visualizzato || normalizeCodiceListino(a.nuovo_codice_ago || a.prestazione))
    .localeCompare(String(b.codice_visualizzato || normalizeCodiceListino(b.nuovo_codice_ago || b.prestazione)), "it", {
      sensitivity: "base",
      numeric: true,
  });
};

const sortTariffaRows = (rows = []) => [...rows].sort(compareTariffaRows);

const hasStoricoPrezzi = (row) => Number(row?.storico_count || 0) > 0
  || !!row?.tariffa_fascia_cliente
  || !!row?.tariffa_fascia_voce?.fasce?.length;

const storicoButtonClass = (enabled) =>
  enabled
    ? "rounded border border-gray-200 bg-white px-2 py-1 text-xs font-semibold text-gray-600 hover:bg-gray-50"
    : "cursor-not-allowed rounded border border-gray-200 bg-gray-100 px-2 py-1 text-xs font-semibold text-gray-400";

const EmptyState = ({ text }) => (
  <div className="text-sm text-gray-400 italic py-8 text-center border rounded-md bg-gray-50">
    {text}
  </div>
);

const Toolbar = ({ right }) => (
  <GridToolbarContainer>
    <div className="w-full flex items-center justify-between gap-3 px-1 py-1">
      <GridToolbarQuickFilter placeholder="Cerca..." />
      {right}
    </div>
  </GridToolbarContainer>
);

const ListiniGridFooter = () => {
  const apiRef = useGridApiContext();
  const visibleRows = useGridSelector(apiRef, gridFilteredSortedRowIdsSelector);
  const rowCount = visibleRows.length;

  return (
    <GridFooterContainer
      sx={{
        minHeight: 40,
        px: 2,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 1.5,
        flexWrap: "wrap",
      }}
    >
      <span className="text-sm font-medium text-gray-500">
        {rowCount} {rowCount === 1 ? "riga" : "righe"}
      </span>
      <div className="flex items-center gap-1">
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
      </div>
    </GridFooterContainer>
  );
};

export const Listini = ({ aziende = [], data }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [anno, mese] = data ? data.split("-").map(Number) : [null, null];
  const refDateIipay = anno && mese ? `${anno}-${String(mese).padStart(2, "0")}-01` : null;
  const initialView = VIEWS.some((item) => item.id === searchParams.get("listiniView"))
    ? searchParams.get("listiniView")
    : "cliente";
  const initialVociTipologia = TIPOLOGIE_CLIENTE.some((item) => item.id === searchParams.get("vociTipo"))
    ? new Set([searchParams.get("vociTipo")])
    : new Set();
  const isAdmin = knowAcces(["parc_admin"]);
  const canManageExtra = knowAcces(["parc_admin", "parc_team_leader"]);
  const visibleViews = useMemo(
    () => isAdmin ? VIEWS : VIEWS.filter((item) => ["cliente", "rate_card", "extra"].includes(item.id)),
    [isAdmin]
  );
  const [view, setView] = useState(initialView);
  const [clienti, setClienti] = useState([]);
  const [clientiCaricati, setClientiCaricati] = useState(false);
  const [clienteSel, setClienteSel] = useState(searchParams.get("cliente") || "");
  const [nuovoClienteParcellazione, setNuovoClienteParcellazione] = useState(null);
  const [savingNuovoClienteParcellazione, setSavingNuovoClienteParcellazione] = useState(false);
  const [listinoCliente, setListinoCliente] = useState([]);
  const [hideZero, setHideZero] = useState(false);
  const [includeCessati, setIncludeCessati] = useState(false);
  const [tipologieClienteFiltro, setTipologieClienteFiltro] = useState(new Set());
  const [settoreClienteTab, setSettoreClienteTab] = useState("PAGHE");
  const [loadingCliente, setLoadingCliente] = useState(false);
  const [exportingListiniAttivi, setExportingListiniAttivi] = useState(false);
  const [exportingReport186, setExportingReport186] = useState(false);
  const [report186Open, setReport186Open] = useState(false);
  const [report186Anno, setReport186Anno] = useState(anno || new Date().getFullYear());
  const [dettagliListino, setDettagliListino] = useState(DEFAULT_DETTAGLI_LISTINO);
  const [nuovaVoceOpen, setNuovaVoceOpen] = useState(false);
  const [nuovaVoce, setNuovaVoce] = useState(NUOVA_VOCE_DEFAULT);
  const [aziendeAmmesseSearch, setAziendeAmmesseSearch] = useState("");
  const [fasceStandardIipay, setFasceStandardIipay] = useState([]);
  const [fasceEsistentiIds, setFasceEsistentiIds] = useState({});
  const [fasceOriginali, setFasceOriginali] = useState({});
  const [loadingFasceIipay, setLoadingFasceIipay] = useState(false);
  const [storicoPrezziOpen, setStoricoPrezziOpen] = useState(false);
  const [storicoPrezziVoce, setStoricoPrezziVoce] = useState(null);
  const [storicoPrezziRows, setStoricoPrezziRows] = useState([]);
  const [loadingStoricoPrezzi, setLoadingStoricoPrezzi] = useState(false);
  const [gestisciFasceOpen, setGestisciFasceOpen] = useState(false);
  const [fasceSchemeData, setFasceSchemeData] = useState(null);
  const [fasceForm, setFasceForm] = useState([]);
  const [fasceDecorrenza, setFasceDecorrenza] = useState("");
  const [loadingGestisciFasce, setLoadingGestisciFasce] = useState(false);
  const [savingFasce, setSavingFasce] = useState(false);
  const [fasceStorico, setFasceStorico] = useState([]);
  const [fasceEditMode, setFasceEditMode] = useState(null);
  const [eliminandoVersioneFasce, setEliminandoVersioneFasce] = useState(false);
  const [editingVoceCodice, setEditingVoceCodice] = useState(null);
  const [savingNuovaVoce, setSavingNuovaVoce] = useState(false);
  const [listinoClienteEdit, setListinoClienteEdit] = useState(LISTINO_CLIENTE_EDIT_DEFAULT);
  const [savingListinoClienteEdit, setSavingListinoClienteEdit] = useState(false);
  const [fasceZucchettiEdit, setFasceZucchettiEdit] = useState(null);
  const [savingFasceZucchetti, setSavingFasceZucchetti] = useState(false);
  const [massivoAttivo, setMassivoAttivo] = useState(false);
  const [loadingStessoPrezzo, setLoadingStessoPrezzo] = useState(false);
  const [stessoPrezzoConfirm, setStessoPrezzoConfirm] = useState(null);
  const [stessoPrezzoSelezionati, setStessoPrezzoSelezionati] = useState(new Set());
  const [stessoPrezzoSearch, setStessoPrezzoSearch] = useState("");
  const [periodicitaClienteEdit, setPeriodicitaClienteEdit] = useState(PERIODICITA_CLIENTE_EDIT_DEFAULT);
  const [savingPeriodicitaCliente, setSavingPeriodicitaCliente] = useState(false);
  const [noteFatturazioneCliente, setNoteFatturazioneCliente] = useState("");
  const [noteFatturazioneOpen, setNoteFatturazioneOpen] = useState(false);
  const [savingNoteFatturazioneCliente, setSavingNoteFatturazioneCliente] = useState(false);
  const [tipoZucchettiEdit, setTipoZucchettiEdit] = useState(TIPO_ZUCCHETTI_EDIT_DEFAULT);
  const [savingTipoZucchetti, setSavingTipoZucchetti] = useState(false);
  const [istatClienteEdit, setIstatClienteEdit] = useState(ISTAT_CLIENTE_EDIT_DEFAULT);
  const [savingIstatCliente, setSavingIstatCliente] = useState(false);
  const [istatApplica, setIstatApplica] = useState(ISTAT_APPLICA_DEFAULT);
  const [istatReportModal, setIstatReportModal] = useState(ISTAT_REPORT_DEFAULT);
  const [exportingIstatReport, setExportingIstatReport] = useState(false);
  const [exportingSconti, setExportingSconti] = useState(false);
  const [scontoClienteRows, setScontoClienteRows] = useState([]);
  const [scontoGlobaleIIpayRows, setScontoGlobaleIIpayRows] = useState([]);
  const [scontoClienteEdit, setScontoClienteEdit] = useState(SCONTO_CLIENTE_EDIT_DEFAULT);
  const [savingScontoCliente, setSavingScontoCliente] = useState(false);
  const [storicoScontoClienteOpen, setStoricoScontoClienteOpen] = useState(false);

  const [datiIipay, setDatiIipay] = useState(null);
  const [vociPayrollIipay, setVociPayrollIipay] = useState({});
  const [savingVociPayrollIipay, setSavingVociPayrollIipay] = useState(false);
  const [cedoliniIipayContext, setCedoliniIipayContext] = useState(null);
  const [cedoliniIipayInput, setCedoliniIipayInput] = useState("");
  const [savingCedoliniIipay, setSavingCedoliniIipay] = useState(false);
  const [datiZucchetti, setDatiZucchetti] = useState([]);
  const [tariffeClienteIipay, setTariffeClienteIipay] = useState([]);
  const [tariffeClienteOverride, setTariffeClienteOverride] = useState([]);
  const [editingTariffaCliente, setEditingTariffaCliente] = useState(null);
  const [tariffaClienteImporto, setTariffaClienteImporto] = useState("");
  const [tariffaClienteDecorrenza, setTariffaClienteDecorrenza] = useState("");
  const [savingTariffaCliente, setSavingTariffaCliente] = useState(false);
  const [editingTariffaClienteMulti, setEditingTariffaClienteMulti] = useState(null);
  const [fasceClienteMultiPrezzi, setFasceClienteMultiPrezzi] = useState({});
  const [fasceClienteMultiRateCard, setFasceClienteMultiRateCard] = useState({});
  const [fasceClienteMultiDecorrenza, setFasceClienteMultiDecorrenza] = useState("");
  const [savingTariffaClienteMulti, setSavingTariffaClienteMulti] = useState(false);

  const [listiniIipay, setListiniIipay] = useState([]);
  const [tariffeIipay, setTariffeIipay] = useState([]);
  const [fasciaIipaySel, setFasciaIipaySel] = useState("");
  const [rateCardSearch, setRateCardSearch] = useState("");
  const [loadingIipay, setLoadingIipay] = useState(false);
  const [exportingVariazioniIipay, setExportingVariazioniIipay] = useState(false);

  const [extraRows, setExtraRows] = useState([]);
  const [extraSearch, setExtraSearch] = useState("");
  const [loadingExtra, setLoadingExtra] = useState(false);
  const bpointDecorrenza = refDateIipay || moment().startOf('month').format('YYYY-MM-DD');
  const [exportingBpointListino, setExportingBpointListino] = useState(false);
  const [bpointClienteEdit, setBpointClienteEdit] = useState(null);
  const [savingBpointCliente, setSavingBpointCliente] = useState(false);
  const [bpointClienteStorico, setBpointClienteStorico] = useState(null);
  const [deletingBpointClienteStorico, setDeletingBpointClienteStorico] = useState(false);
  const [bpointClientiPersonalizzati, setBpointClientiPersonalizzati] = useState(null);
  const [loadingBpointClientiPersonalizzati, setLoadingBpointClientiPersonalizzati] = useState(false);
  const [bpointClientiTariffaEreditata, setBpointClientiTariffaEreditata] = useState(null);
  const [loadingBpointClientiTariffaEreditata, setLoadingBpointClientiTariffaEreditata] = useState(false);
  const [datiBpointCliente, setDatiBpointCliente] = useState(null);
  const [bpointTipoEditOpen, setBpointTipoEditOpen] = useState(false);
  const [savingBpointTipo, setSavingBpointTipo] = useState(false);
  const [bpoint427Association, setBpoint427Association] = useState(null);
  const [bpoint427AssociationOpen, setBpoint427AssociationOpen] = useState(false);
  const [bpoint427AssociationSelected, setBpoint427AssociationSelected] = useState("");
  const [savingBpoint427Association, setSavingBpoint427Association] = useState(false);
  const [savingBpoint427AdditionalMonths, setSavingBpoint427AdditionalMonths] = useState(false);

  const [vociListino, setVociListino] = useState([]);
  const [vociSearch, setVociSearch] = useState("");
  const [vociTipologia, setVociTipologia] = useState(initialVociTipologia);
  const [loadingVoci, setLoadingVoci] = useState(false);

  const [masterTipologia, setMasterTipologia] = useState("Z");
  const [cloneSourceType, setCloneSourceType] = useState("master");
  const [cloneSourceCliente, setCloneSourceCliente] = useState("");
  const [cloneTargetCliente, setCloneTargetCliente] = useState("");
  const [cloningListino, setCloningListino] = useState(false);

  const clientiDisponibili = useMemo(() => {
    const source = clienti.length ? clienti : aziende;
    return [...source]
      .filter((a, i, arr) => arr.findIndex((b) => b.codice_univoco === a.codice_univoco) === i)
      .filter((a) => includeCessati || !a.data_fine_elaborazioni)
      .filter((a) => {
        if (tipologieClienteFiltro.size === 0) return true;
        if (Number(a.solo_parcellazione || 0) === 1) return tipologieClienteFiltro.has("P");
        return tipologieClienteFiltro.has(String(a.tipologia_fatturazione || "").toUpperCase());
      })
      .sort((a, b) => String(a.ragione_sociale || "").localeCompare(String(b.ragione_sociale || "")));
  }, [aziende, clienti, includeCessati, tipologieClienteFiltro]);

  const cliente = clientiDisponibili.find((a) => String(a.codice_univoco) === String(clienteSel)) || null;

  // Elenco completo clienti iiPay attivi, indipendente dal filtro Z/I/B della
  // griglia: serve allo sconto globale iiPay per proporre l'esclusione di
  // singoli clienti al momento dell'applicazione.
  const clientiIIpayAttivi = useMemo(
    () => clienti.filter((c) => String(c.tipologia_fatturazione || "").toUpperCase() === "I" && !c.data_fine_elaborazioni),
    [clienti]
  );

  const codiceAgoByPrestazione = useMemo(() => {
    const map = new Map();
    const add = (row) => {
      const ago = normalizeCodiceListino(row?.nuovo_codice_ago);
      if (!ago) return;
      [row?.codice, row?.prestazione].forEach((key) => {
        if (key != null && key !== "") map.set(String(key), ago);
      });
    };
    [...listinoCliente, ...tariffeClienteIipay, ...tariffeIipay, ...vociListino].forEach(add);
    return map;
  }, [listinoCliente, tariffeClienteIipay, tariffeIipay, vociListino]);

  const getCodiceAgoDisplay = useCallback((row) => {
    const direct = normalizeCodiceListino(row?.nuovo_codice_ago);
    if (direct) return direct;
    const mapped = [row?.codice, row?.prestazione]
      .map((key) => (key == null || key === "" ? null : codiceAgoByPrestazione.get(String(key))))
      .find(Boolean);
    if (mapped) return mapped;
    const visualizzato = normalizeCodiceListino(row?.codice_visualizzato);
    if (visualizzato) return visualizzato;
    return normalizeCodiceListino(row?.codice || row?.prestazione);
  }, [codiceAgoByPrestazione]);

  const syncListiniUrlState = useCallback((updates) => {
    setSearchParams((currentParams) => {
      const params = new URLSearchParams(currentParams);
      Object.entries(updates).forEach(([key, value]) => {
        const cleanValue = value == null ? "" : String(value);
        if (cleanValue) params.set(key, cleanValue);
        else params.delete(key);
      });
      return params;
    }, { replace: true });
  }, [setSearchParams]);

  const handleViewChange = useCallback((nextView) => {
    setView(nextView);
    syncListiniUrlState({ listiniView: nextView });
  }, [syncListiniUrlState]);

  useEffect(() => {
    if (!visibleViews.some((item) => item.id === view)) {
      handleViewChange("cliente");
    }
  }, [handleViewChange, view, visibleViews]);

  const handleClienteChange = useCallback((nextCliente) => {
    setClienteSel(nextCliente);
    syncListiniUrlState({ cliente: nextCliente });
  }, [syncListiniUrlState]);

  const handleVociTipologiaChange = useCallback((tipologia) => {
    setVociTipologia((current) => {
      const next = new Set(current);
      next.has(tipologia) ? next.delete(tipologia) : next.add(tipologia);
      syncListiniUrlState({ vociTipo: next.size === 1 ? [...next][0] : "" });
      return next;
    });
  }, [syncListiniUrlState]);

  const aziendeTipologiaNuovaVoce = useMemo(() => {
    const source = clienti.length ? clienti : aziende;
    const tipo = String(nuovaVoce.tipologia_fatturazione || "").toUpperCase();
    return [...source]
      .filter((a, i, arr) => arr.findIndex((b) => b.codice_univoco === a.codice_univoco) === i)
      .filter((a) => String(a.tipologia_fatturazione || "").toUpperCase() === tipo)
      .sort((a, b) => String(a.ragione_sociale || "").localeCompare(String(b.ragione_sociale || "")));
  }, [aziende, clienti, nuovaVoce.tipologia_fatturazione]);

  const aziendeTipologiaNuovaVoceFiltrate = useMemo(() => {
    const q = aziendeAmmesseSearch.trim().toLowerCase();
    const selezionate = new Set((nuovaVoce.aziende_ammesse || []).map(String));
    return aziendeTipologiaNuovaVoce
      .filter((a) => {
        if (!q) return true;
        return (
          String(a.ragione_sociale || "").toLowerCase().includes(q) ||
          String(a.codice_univoco || "").toLowerCase().includes(q)
        );
      })
      .sort((a, b) => {
        const aSelected = selezionate.has(String(a.codice_univoco));
        const bSelected = selezionate.has(String(b.codice_univoco));
        if (aSelected !== bSelected) return aSelected ? -1 : 1;
        return String(a.ragione_sociale || "").localeCompare(String(b.ragione_sociale || ""));
      });
  }, [aziendeTipologiaNuovaVoce, aziendeAmmesseSearch, nuovaVoce.aziende_ammesse]);

  const clienteOptions = clientiDisponibili.map((a) => ({
    id: a.codice_univoco,
    name: `${a.ragione_sociale}${a.data_fine_elaborazioni ? " (cessato)" : ""}`,
    badge: a.tipologia_fatturazione,
    badges: isAdmin && Number(a.solo_parcellazione || 0) === 1 ? [{ label: "P", className: "bg-amber-100 text-amber-800" }] : [],
  }));

  const clientiPerMaster = useMemo(() => {
    const source = clienti.length ? clienti : aziende;
    return [...source]
      .filter((a, i, arr) => arr.findIndex((b) => b.codice_univoco === a.codice_univoco) === i)
      .filter((a) => String(a.tipologia_fatturazione || "").toUpperCase() === masterTipologia)
      .sort((a, b) => String(a.ragione_sociale || "").localeCompare(String(b.ragione_sociale || "")))
      .map((a) => ({
        id: a.codice_univoco,
        name: `${a.ragione_sociale}${a.data_fine_elaborazioni ? " (cessato)" : ""}`,
        badge: a.tipologia_fatturazione,
      }));
  }, [aziende, clienti, masterTipologia]);

  const dettagliOptions = useMemo(() => ({
    tipologia_fatturazione: (dettagliListino.tipologia_fatturazione?.length
      ? dettagliListino.tipologia_fatturazione
      : DEFAULT_DETTAGLI_LISTINO.tipologia_fatturazione
    )
      .map((item) => ({
        id: String(item.id).toUpperCase(),
        name: `${String(item.id).toUpperCase()} - ${item.name}`,
      }))
      .filter((item) => ["Z", "B", "I"].includes(item.id)),
    appartenenza: dettagliListino.appartenenza?.length
      ? dettagliListino.appartenenza
      : DEFAULT_DETTAGLI_LISTINO.appartenenza,
    settore: (dettagliListino.settore?.length
      ? dettagliListino.settore
      : DEFAULT_DETTAGLI_LISTINO.settore
    ).filter((item) => String(item.name).toUpperCase().trim() !== "SOLO ADMIN"),
    metodo_fatturazione: dettagliListino.metodo_fatturazione?.length
      ? dettagliListino.metodo_fatturazione
      : DEFAULT_DETTAGLI_LISTINO.metodo_fatturazione,
  }), [dettagliListino]);

  const settoreLabelById = useMemo(() => {
    const map = new Map();
    dettagliOptions.settore.forEach((s) => map.set(String(s.id), s.name));
    return map;
  }, [dettagliOptions.settore]);

  const metodoLabelById = useMemo(() => {
    const map = new Map();
    dettagliOptions.metodo_fatturazione.forEach((m) => map.set(String(m.id), m.name));
    return map;
  }, [dettagliOptions.metodo_fatturazione]);

  const metodoIipayIds = useMemo(() => {
    const find = (label) =>
      dettagliOptions.metodo_fatturazione.find((m) => String(m.name).toUpperCase().trim() === label)?.id ?? null;
    return {
      libera: find("LIBERA"),
      fisso: find("LISTINO"),
      tabella: find("TABELLA"),
    };
  }, [dettagliOptions.metodo_fatturazione]);

  const metodoStandardOptions = useMemo(() => {
    const find = (label) =>
      dettagliOptions.metodo_fatturazione.find((m) => String(m.name).toUpperCase().trim() === label)?.id ?? null;
    return [
      { key: "listino", label: "Fisso", id: find("LISTINO") },
      { key: "libera", label: "Libera", id: find("LIBERA") },
      { key: "tabella", label: "Tabella", id: find("TABELLA") },
      { key: "forfait", label: "Forfait", id: find("LISTINO/FORFAIT") },
      { key: "listino-forfait", label: "Fisso/forfait", id: find("FISSO/FORFAIT") },
      { key: "listino-tabella", label: "Fisso/Tabella", id: find("LISTINO/TABELLA") },
    ];
  }, [dettagliOptions.metodo_fatturazione]);

  const fasceIipay = useMemo(() => {
    const map = new Map();
    tariffeIipay.filter(isFasciaRow).forEach((row) => {
      const key = getFasciaKey(row);
      if (!map.has(key)) {
        map.set(key, {
          key,
          label: getFasciaLabel(row),
          min_fascia: row.min_fascia,
          max_fascia: row.max_fascia,
        });
      }
    });

    return Array.from(map.values()).sort((a, b) => {
      const aFlat = a.min_fascia == null && a.max_fascia == null;
      const bFlat = b.min_fascia == null && b.max_fascia == null;
      if (aFlat !== bFlat) return aFlat ? 1 : -1;
      return (a.min_fascia ?? -1) - (b.min_fascia ?? -1);
    });
  }, [tariffeIipay]);

  useEffect(() => {
    if (!fasceIipay.length) {
      setFasciaIipaySel("");
      return;
    }
    if (!fasceIipay.some((fascia) => fascia.key === fasciaIipaySel)) {
      setFasciaIipaySel(fasceIipay[0].key);
    }
  }, [fasceIipay, fasciaIipaySel]);

  useEffect(() => {
    if (clientiCaricati && clienteSel && !clientiDisponibili.some((a) => String(a.codice_univoco) === String(clienteSel))) {
      handleClienteChange("");
    }
  }, [clientiCaricati, clienteSel, clientiDisponibili, handleClienteChange]);

  useEffect(() => {
    setNoteFatturazioneCliente(cliente?.note_fatturazione || "");
  }, [cliente?.codice_univoco, cliente?.note_fatturazione]);

  const rateCardRows = useMemo(() => {
    const q = rateCardSearch.trim().toLowerCase();
    const rows = tariffeIipay
      .filter((row) => {
        if (!isFasciaRow(row)) return true;
        if (!fasciaIipaySel) return false;
        return getFasciaKey(row) === fasciaIipaySel;
      })
      .map(decorateTariffaRow)
      .filter((row) => {
        if (!q) return true;
        return (
          String(row.codice_visualizzato || "").toLowerCase().includes(q) ||
          String(row.descrizione_prestazione || "").toLowerCase().includes(q)
        );
      });

    return sortTariffaRows(rows);
  }, [tariffeIipay, fasciaIipaySel, rateCardSearch]);

  const tariffeClienteIipayRows = useMemo(() => {
    const cedolini = cedoliniIipayContext?.cedolini_elaborati;
    const fasceCliente = new Map();
    tariffeClienteIipay.filter(isFasciaRow).forEach((row) => {
      const key = getFasciaKey(row);
      if (!fasceCliente.has(key)) {
        fasceCliente.set(key, { key, min_fascia: row.min_fascia, max_fascia: row.max_fascia });
      }
    });
    const fasceOrdinate = Array.from(fasceCliente.values()).sort(
      (a, b) => (a.min_fascia ?? -1) - (b.min_fascia ?? -1)
    );
    let fasciaSel = null;
    if (cedolini != null) {
      fasciaSel = fasceOrdinate.find(
        (f) => cedolini >= (f.min_fascia ?? -Infinity) && cedolini <= (f.max_fascia ?? Infinity)
      );
    }
    if (!fasciaSel) fasciaSel = fasceOrdinate[0] || null;

    const rows = tariffeClienteIipay.filter((row) => {
      if (isSoloSezione3(row.sezione_crm)) return false;
      if (!isFasciaRow(row)) return true;
      if (!fasciaSel) return false;
      return getFasciaKey(row) === fasciaSel.key;
    });

    const overrideByKey = new Map();
    tariffeClienteOverride.forEach((o) => {
      overrideByKey.set(`${o.prestazione}:${getFasciaKey(o)}`, o);
    });

    const decorated = rows.map((row) => {
      const override = overrideByKey.get(`${row.prestazione}:${getFasciaKey(row)}`);
      const base = decorateTariffaRow(row);
      if (!override) return { ...base, is_override: false };
      return {
        ...base,
        importo: override.importo,
        importo_visualizzato: fmt(override.importo),
        is_override: true,
        override_id: override.id,
        override_decorrenza: override.data_decorrenza,
      };
    });

    return sortTariffaRows(decorated);
  }, [tariffeClienteIipay, tariffeClienteOverride, cedoliniIipayContext]);

  const extraGroups = useMemo(() => {
    const groups = [];
    for (let i = 0; i < extraRows.length; i += 1) {
      const row = extraRows[i];
      const group = {
        fees: row.fees || "",
        gruppo: row.gruppo || "",
        rows: [row],
      };

      if (group.fees || group.gruppo) {
        let j = i + 1;
        while (
          j < extraRows.length &&
          !String(extraRows[j].fees || "").trim() &&
          !String(extraRows[j].gruppo || "").trim()
        ) {
          group.rows.push(extraRows[j]);
          j += 1;
        }
        i = j - 1;
      }

      groups.push(group);
    }

    const q = extraSearch.trim().toLowerCase();
    if (!q) return groups;
    return groups.filter((group) => {
      const groupText = `${group.fees} ${group.gruppo}`.toLowerCase();
      return groupText.includes(q) || group.rows.some((row) =>
        [
          row.numero,
          row.action,
          row.document_required,
          row.miller_will_produce,
        ].some((value) => String(value || "").toLowerCase().includes(q))
      );
    });
  }, [extraRows, extraSearch]);

  const loadClienti = useCallback(async () => {
    try {
      const res = await api.get("/prestazione_azienda/listini/clienti");
      setClienti(res.data || []);
    } catch {
      setClienti([]);
      toast.error("Errore caricamento clienti listino");
    } finally {
      setClientiCaricati(true);
    }
  }, []);

  const createClienteSoloParcellazione = async () => {
    if (!isAdmin || !nuovoClienteParcellazione?.ragione_sociale.trim()) return;
    setSavingNuovoClienteParcellazione(true);
    try {
      const payload = {
        ragione_sociale: nuovoClienteParcellazione.ragione_sociale.trim(),
        codice_fiscale: String(nuovoClienteParcellazione.codice_fiscale || "").trim(),
        tipologia_fatturazione: nuovoClienteParcellazione.tipologia_fatturazione,
        codice_parcellazione: nuovoClienteParcellazione.codice_parcellazione.trim() || null,
        data_fine_elaborazioni: nuovoClienteParcellazione.data_fine_elaborazioni || null,
      };
      const response = nuovoClienteParcellazione.codice_univoco
        ? await api.put(`/prestazione_azienda/listini/clienti/solo-parcellazione/${nuovoClienteParcellazione.codice_univoco}`, payload)
        : await api.post("/prestazione_azienda/listini/clienti/solo-parcellazione", payload);
      await loadClienti();
      if (!nuovoClienteParcellazione.codice_univoco) handleClienteChange(response.data.codice_univoco);
      setNuovoClienteParcellazione(null);
      toast.success(nuovoClienteParcellazione.codice_univoco ? "Cliente aggiornato" : "Cliente solo Parcellazione creato");
    } catch (error) { toast.error(error.response?.data?.message || "Errore creazione cliente"); }
    finally { setSavingNuovoClienteParcellazione(false); }
  };

  const loadDettagliListino = useCallback(async () => {
    try {
      const res = await api.get("/prestazioni/dettagli");
      setDettagliListino({
        ...DEFAULT_DETTAGLI_LISTINO,
        ...(res.data || {}),
      });
    } catch {
      setDettagliListino(DEFAULT_DETTAGLI_LISTINO);
    }
  }, []);

  const loadListinoCliente = useCallback(async (codice) => {
    if (!codice) {
      setListinoCliente([]);
      return;
    }
    setLoadingCliente(true);
    try {
      const params = new URLSearchParams();
      if (anno) params.set("anno", anno);
      if (mese) params.set("mese", mese);
      const query = params.toString();
      const res = await api.get(`/prestazione_azienda/listini/cliente/${codice}${query ? `?${query}` : ""}`);
      setListinoCliente(res.data || []);
    } catch {
      setListinoCliente([]);
      toast.error("Errore caricamento listino cliente");
    } finally {
      setLoadingCliente(false);
    }
  }, [anno, mese]);

  const loadListiniIipay = useCallback(async () => {
    try {
      const res = await api.get("/tipologia_listino_iipay");
      setListiniIipay(res.data || []);
    } catch {
      toast.error("Errore caricamento listini iiPay");
    }
  }, []);

  const loadTariffeIipay = useCallback(async (id, setter = setTariffeIipay, codiceUnivocoAzienda = null) => {
    if (!id) {
      setter([]);
      return;
    }
    setLoadingIipay(true);
    try {
      const params = {};
      if (refDateIipay) params.refDate = refDateIipay;
      if (codiceUnivocoAzienda) params.codiceUnivocoAzienda = codiceUnivocoAzienda;
      const res = await api.get(`/tipologia_listino_iipay/${id}/tariffe`, {
        params,
      });
      setter(res.data || []);
    } catch {
      setter([]);
      toast.error("Errore caricamento rate card iiPay");
    } finally {
      setLoadingIipay(false);
    }
  }, [refDateIipay]);

  const loadTariffeClienteOverride = useCallback(async (codice) => {
    if (!codice) {
      setTariffeClienteOverride([]);
      return;
    }
    try {
      const res = await api.get(`/tipologia_listino_iipay/cliente/${codice}/tariffe`, {
        params: refDateIipay ? { refDate: refDateIipay } : {},
      });
      setTariffeClienteOverride(res.data || []);
    } catch {
      setTariffeClienteOverride([]);
    }
  }, [refDateIipay]);

  const loadDatiIipay = useCallback(async (codice) => {
    if (!codice) {
      setDatiIipay(null);
      setTariffeClienteIipay([]);
      setTariffeClienteOverride([]);
      return;
    }
    try {
      const res = await api.get(`/dati_parcellazione_iipay/${codice}`);
      const dati = res.data?.[0] || null;
      const normalized = {
        ...(dati || { periodicita: "mensile", lingua_fattura: "EN", _fallback_listino_iipay: true }),
        tipologia_listino_iipay: IIPAY_LISTINO_BASE_ID,
      };
      setDatiIipay(normalized);
      const [, , vociRes] = await Promise.all([
        loadTariffeIipay(IIPAY_LISTINO_BASE_ID, setTariffeClienteIipay, codice),
        loadTariffeClienteOverride(codice),
        api.get(`/billing/iipay-voci-payroll/${codice}`),
      ]);
      setVociPayrollIipay(vociRes.data || {});
    } catch {
      setDatiIipay(null);
      setTariffeClienteIipay([]);
      setTariffeClienteOverride([]);
      setVociPayrollIipay({});
      toast.error("Errore caricamento dati iiPay cliente");
    }
  }, [loadTariffeIipay, loadTariffeClienteOverride]);

  const loadDatiBpointCliente = useCallback(async (codice) => {
    if (!codice) return setDatiBpointCliente(null);
    try {
      const response = await api.get(`/dati_parcellazione_bpoint/${codice}`);
      setDatiBpointCliente(response.data?.[0] || {
        codice_univoco_azienda: codice,
        fondi_assicurazione_sanitaria: 0,
        cassa_edile: 0,
        pubblicazione_documentale: 0,
        alfieri: 0,
        presenze_manuali: 0,
        presenze_hr_portal: 0,
        pubblicazione_documentale_dipendenti: 0,
      });
    } catch (error) {
      setDatiBpointCliente(null);
      toast.error(error.response?.data?.message || 'Errore caricamento tipo fasce BPoint');
    }
  }, []);

  const loadBpoint427Association = useCallback(async (codice) => {
    if (!codice) return setBpoint427Association(null);
    try {
      const response = await api.get(`/billing/bpoint-listino/cliente/${codice}/associazione-427`);
      setBpoint427Association(response.data || null);
    } catch (error) {
      setBpoint427Association(null);
      toast.error(error.response?.data?.message || 'Errore caricamento associazione tariffa BPoint 427');
    }
  }, []);

  const openBpoint427Association = () => {
    setBpoint427AssociationSelected(bpoint427Association?.associazione?.codice_univoco_azienda_tariffa || "");
    setBpoint427AssociationOpen(true);
  };

  const saveBpoint427Association = async () => {
    if (!clienteSel || !bpoint427AssociationSelected || savingBpoint427Association) return;
    setSavingBpoint427Association(true);
    try {
      await api.put(`/billing/bpoint-listino/cliente/${clienteSel}/associazione-427`, {
        codice_univoco_azienda_tariffa: bpoint427AssociationSelected,
      });
      await loadBpoint427Association(clienteSel);
      setBpoint427AssociationOpen(false);
      toast.success('Tariffa BPoint 427 collegata');
    } catch (error) { toast.error(error.response?.data?.message || 'Errore salvataggio associazione tariffa BPoint 427'); }
    finally { setSavingBpoint427Association(false); }
  };

  const deleteBpoint427Association = async () => {
    if (!clienteSel || savingBpoint427Association) return;
    setSavingBpoint427Association(true);
    try {
      await api.delete(`/billing/bpoint-listino/cliente/${clienteSel}/associazione-427`);
      await loadBpoint427Association(clienteSel);
      setBpoint427AssociationOpen(false);
      toast.success('Collegamento tariffa BPoint 427 rimosso');
    } catch (error) { toast.error(error.response?.data?.message || 'Errore rimozione associazione tariffa BPoint 427'); }
    finally { setSavingBpoint427Association(false); }
  };

  const saveBpoint427AdditionalMonthsExclusion = async (excluded) => {
    if (!clienteSel || savingBpoint427AdditionalMonths) return;
    setSavingBpoint427AdditionalMonths(true);
    try {
      await api.put(`/billing/bpoint-listino/cliente/${clienteSel}/esclusione-mensilita-427`, { esclusa: excluded });
      setBpoint427Association((prev) => prev ? { ...prev, escludi_mensilita_aggiuntive_427: excluded } : prev);
      toast.success(excluded
        ? 'Mensilità aggiuntive escluse dall’addebito della voce 427'
        : 'Mensilità aggiuntive riattivate sulla voce 427');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Errore aggiornamento mensilità aggiuntive 427');
    } finally { setSavingBpoint427AdditionalMonths(false); }
  };

  const saveBpointTipoCliente = async (alfieri) => {
    if (!datiBpointCliente || savingBpointTipo) return;
    setSavingBpointTipo(true);
    try {
      const updated = { ...datiBpointCliente, codice_univoco_azienda: clienteSel, alfieri: alfieri ? 1 : 0 };
      await api.post('/dati_parcellazione_bpoint', { dati: updated });
      setDatiBpointCliente(updated);
      setBpointTipoEditOpen(false);
      toast.success(`Cliente impostato come BPoint ${alfieri ? 'Alfieri' : 'Standard'}`);
      await loadListinoCliente(clienteSel);
    } catch (error) { toast.error(error.response?.data?.message || 'Errore modifica tipo fasce BPoint'); }
    finally { setSavingBpointTipo(false); }
  };

  const handleToggleVocePayrollIipay = async (prestazione, attivo) => {
    if (!clienteSel || !isAdmin || savingVociPayrollIipay) return;
    const previous = vociPayrollIipay;
    const next = { ...previous, [prestazione]: attivo };
    setVociPayrollIipay(next);
    setSavingVociPayrollIipay(true);
    try {
      await api.put(`/billing/iipay-voci-payroll/${clienteSel}`, { voci: next });
      toast.success(`Voce ${prestazione} ${attivo ? "attivata" : "disattivata"}`);
    } catch (err) {
      setVociPayrollIipay(previous);
      toast.error(err.response?.data?.message || "Errore salvataggio voci Payroll iiPay");
    } finally {
      setSavingVociPayrollIipay(false);
    }
  };

  const loadCedoliniIipayContext = useCallback(async (codice) => {
    if (!codice || !anno || !mese) {
      setCedoliniIipayContext(null);
      setCedoliniIipayInput("");
      return;
    }
    try {
      const res = await api.get(`/dati_parcellazione_iipay/${codice}/cedolini-context?anno=${anno}&mese=${mese}`);
      setCedoliniIipayContext(res.data || null);
      setCedoliniIipayInput(res.data?.cedolini_elaborati ?? "");
    } catch (err) {
      setCedoliniIipayContext(null);
      setCedoliniIipayInput("");
      if (err.response?.status === 404) return;
      toast.error("Errore caricamento cedolini iiPay");
    }
  }, [anno, mese]);

  const canEditCedoliniIipayContext = isAdmin && cedoliniIipayContext && (
    cedoliniIipayContext.cedolini_elaborati == null ||
    Number(cedoliniIipayContext.cedolini_presunti) === 1
  );

  const handleSaveCedoliniIipay = async () => {
    if (!clienteSel || !anno || !mese) return;
    if (!canEditCedoliniIipayContext) {
      toast.warning("I cedolini importati da script non sono modificabili");
      return;
    }
    if (cedoliniIipayInput === "" || cedoliniIipayInput == null || Number(cedoliniIipayInput) < 0) {
      toast.warning("Inserisci un numero cedolini valido");
      return;
    }
    setSavingCedoliniIipay(true);
    try {
      const res = await api.post(`/dati_parcellazione_iipay/${clienteSel}/cedolini-presunti`, {
        anno,
        mese,
        cedolini_elaborati: Number(cedoliniIipayInput),
      });
      setCedoliniIipayContext(res.data || null);
      setCedoliniIipayInput(res.data?.cedolini_elaborati ?? "");
      await loadListinoCliente(clienteSel);
      toast.success("Cedolini presunti salvati");
    } catch {
      toast.error("Errore salvataggio cedolini presunti");
    } finally {
      setSavingCedoliniIipay(false);
    }
  };

  const getDefaultTipologiaNuovaVoce = () => {
    const activeTypes = [...tipologieClienteFiltro].filter((tipo) => ["Z", "I", "B"].includes(tipo));
    if (activeTypes.length === 1) return activeTypes[0];
    return cliente?.tipologia_fatturazione || "Z";
  };

  // Fasce standard = fasce definite sul listino iiPay base (id 1); usate come schema
  // di riferimento per il prezzo per fascia di una voce, indipendentemente dal listino.
  const loadFasceIipayContext = useCallback(async (codicePrestazione) => {
    setLoadingFasceIipay(true);
    try {
      const [schemeRes, tariffeRes] = await Promise.all([
        api.get(`/tipologia_listino_iipay/1/fasce`, { params: refDateIipay ? { refDate: refDateIipay } : {} }),
        api.get(`/tipologia_listino_iipay/1/tariffe`, { params: refDateIipay ? { refDate: refDateIipay } : {} }),
      ]);
      const bands = (schemeRes.data?.fasce || []).map((b) => ({
        key: getFasciaKey(b),
        min_fascia: b.min_fascia,
        max_fascia: b.max_fascia,
      }));
      setFasceStandardIipay(bands);

      const rows = tariffeRes.data || [];
      const prezzi = {};
      const ids = {};
      if (codicePrestazione) {
        rows
          .filter((r) => isFasciaRow(r) && String(r.prestazione) === String(codicePrestazione))
          .forEach((r) => {
            const key = getFasciaKey(r);
            prezzi[key] = fmt(r.importo);
            ids[key] = r.id;
          });
      }
      setFasceEsistentiIds(ids);
      return prezzi;
    } catch {
      toast.error("Errore caricamento fasce iiPay");
      return {};
    } finally {
      setLoadingFasceIipay(false);
    }
  }, [refDateIipay]);

  const openGestisciFasce = async () => {
    setGestisciFasceOpen(true);
    setLoadingGestisciFasce(true);
    setFasceDecorrenza("");
    try {
      const [res, storicoRes] = await Promise.all([
        api.get(`/tipologia_listino_iipay/1/fasce`, {
          params: refDateIipay ? { refDate: refDateIipay } : {},
        }),
        api.get(`/tipologia_listino_iipay/1/fasce/storico`),
      ]);
      setFasceSchemeData(res.data);
      setFasceForm(
        (res.data?.fasce || []).map((b) => ({ min_fascia: b.min_fascia ?? "", max_fascia: b.max_fascia ?? "" }))
      );
      setFasceStorico(storicoRes.data || []);
    } catch {
      toast.error("Errore caricamento fasce iiPay");
      setFasceSchemeData(null);
      setFasceForm([]);
      setFasceStorico([]);
    } finally {
      setLoadingGestisciFasce(false);
    }
  };

  const closeGestisciFasce = () => {
    setGestisciFasceOpen(false);
    setFasceStorico([]);
    setFasceSchemeData(null);
    setFasceForm([]);
    setFasceDecorrenza("");
    setFasceEditMode(null);
  };

  const reloadFasceModal = async () => {
    const [res, storicoRes] = await Promise.all([
      api.get(`/tipologia_listino_iipay/1/fasce`, { params: refDateIipay ? { refDate: refDateIipay } : {} }),
      api.get(`/tipologia_listino_iipay/1/fasce/storico`),
    ]);
    setFasceSchemeData(res.data);
    setFasceStorico(storicoRes.data || []);
    return res.data;
  };

  const startModificaVersione = (versione) => {
    setFasceEditMode(moment(versione.data_decorrenza).format("YYYY-MM-DD"));
    setFasceDecorrenza(moment(versione.data_decorrenza).format("YYYY-MM-DD"));
    setFasceForm(versione.fasce.map((b) => ({ min_fascia: b.min_fascia ?? "", max_fascia: b.max_fascia ?? "" })));
  };

  const annullaModificaVersione = () => {
    setFasceEditMode(null);
    setFasceDecorrenza("");
    setFasceForm(
      (fasceSchemeData?.fasce || []).map((b) => ({ min_fascia: b.min_fascia ?? "", max_fascia: b.max_fascia ?? "" }))
    );
  };

  const handleEliminaVersioneFasce = async (versione) => {
    const decorrenza = moment(versione.data_decorrenza).format("YYYY-MM-DD");
    if (!window.confirm(`Eliminare la versione fasce del ${moment(decorrenza).format("DD/MM/YYYY")}? Torna in vigore quella precedente.`)) return;
    setEliminandoVersioneFasce(true);
    try {
      await api.delete(`/tipologia_listino_iipay/1/fasce/${decorrenza}`);
      toast.success("Versione eliminata");
      if (fasceEditMode === decorrenza) annullaModificaVersione();
      const data = await reloadFasceModal();
      setFasceForm((data?.fasce || []).map((b) => ({ min_fascia: b.min_fascia ?? "", max_fascia: b.max_fascia ?? "" })));
      setFasceStandardIipay([]);
      if (view === "rate_card") await loadTariffeIipay(IIPAY_LISTINO_BASE_ID);
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore eliminazione versione");
    } finally {
      setEliminandoVersioneFasce(false);
    }
  };

  const addFasciaRow = () => {
    setFasceForm((prev) => [...prev, { min_fascia: "", max_fascia: "" }]);
  };

  const removeFasciaRow = (index) => {
    setFasceForm((prev) => prev.filter((_, i) => i !== index));
  };

  const updateFasciaRow = (index, field, value) => {
    setFasceForm((prev) => prev.map((row, i) => (i === index ? { ...row, [field]: value } : row)));
  };

  const handleSaveFasce = async () => {
    if (savingFasce) return;
    if (!fasceDecorrenza) {
      toast.warning("Inserisci la data di decorrenza della nuova versione");
      return;
    }
    const bande = fasceForm
      .map((b) => ({
        min_fascia: String(b.min_fascia || "").trim() === "" ? null : Number(b.min_fascia),
        max_fascia: String(b.max_fascia || "").trim() === "" ? null : Number(b.max_fascia),
      }))
      .filter((b) => b.min_fascia != null || b.max_fascia != null);
    if (!bande.length) {
      toast.warning("Definisci almeno una fascia");
      return;
    }

    setSavingFasce(true);
    try {
      if (fasceEditMode) {
        await api.put(`/tipologia_listino_iipay/1/fasce/${fasceEditMode}`, {
          fasce: bande,
          nuova_data_decorrenza: fasceDecorrenza,
        });
        toast.success("Versione modificata");
      } else {
        await api.post(`/tipologia_listino_iipay/1/fasce`, {
          data_decorrenza: fasceDecorrenza,
          fasce: bande,
        });
        toast.success("Nuova versione fasce creata");
      }
      closeGestisciFasce();
      setFasceStandardIipay([]);
      if (view === "rate_card") await loadTariffeIipay(IIPAY_LISTINO_BASE_ID);
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore salvataggio fasce");
    } finally {
      setSavingFasce(false);
    }
  };

  const openNuovaVoce = () => {
    const tipologia = getDefaultTipologiaNuovaVoce();
    setEditingVoceCodice(null);
    setNuovaVoce({
      ...NUOVA_VOCE_DEFAULT,
      tipologia_fatturazione: tipologia,
    });
    setAziendeAmmesseSearch("");
    setFasceEsistentiIds({});
    setFasceOriginali({});
    if (tipologia === "I") loadFasceIipayContext(null);
    setNuovaVoceOpen(true);
  };

  const closeVoceModal = () => {
    setNuovaVoceOpen(false);
    setEditingVoceCodice(null);
    setAziendeAmmesseSearch("");
  };

  const openEditVoce = (row) => {
    const hasCodiceAgo = !!String(row.nuovo_codice_ago || "").trim();
    setEditingVoceCodice(row.codice);
    setNuovaVoce({
      codice: row.codice ?? "",
      nuovo_codice_ago: hasCodiceAgo ? row.nuovo_codice_ago : row.codice ?? "",
      tipologia_fatturazione: row.tipologia_fatturazione || "Z",
      descrizione_voce_ago: row.descrizione_voce_ago ?? "",
      descrizione_voce_crm: row.descrizione_voce_crm ?? "",
      appartenenza: row.appartenenza ?? 1,
      settore: row.settore ?? 3,
      metodo_fatturazione: row.metodo_fatturazione ?? 3,
      sezione_crm: row.sezione_crm ?? "3",
      importo_default: row.iipay_importo_fisso ?? row.importo_default ?? "",
      note: row.note ?? "",
      richiesta: row.richiesta ?? (isIntegrazioneSalariale(row) ? "Inserire periodo dal … al …" : ""),
      descrizione_obbligatoria: isIntegrazioneSalariale(row) || !!String(row.richiesta || "").trim(),
      codice_ago_fallback: !hasCodiceAgo,
      voce_particolare: Number(row.voce_particolare) === 1,
      quantita_obbligatoria: Number(row.quantita_obbligatoria) === 1,
      attivo: row.attivo == null ? true : Number(row.attivo) === 1,
      solo_admin: Number(row.solo_admin) === 1,
      tutte_aziende: true,
      limitata_aziende: Number(row.limitata_aziende) === 1,
      aziende_ammesse: [],
      iipay_a_fascia: false,
      fasce_prezzi: {},
      prezzo_decorrenza: "",
      importo_default_original: row.iipay_importo_fisso ?? row.importo_default ?? "",
      iipay_importo_fisso_id: row.iipay_importo_fisso_id ?? null,
      cigo_quota_base: row.cigo_quota_base ?? 150,
      cigo_maltempo_quota_base: row.cigo_maltempo_quota_base ?? 75,
      quota_variabile: row.quota_variabile ?? 2,
      fsba_coefficiente: row.fsba_coefficiente ?? 1.5,
      fsba_minimo: row.fsba_minimo ?? 50,
      tetto_massimo: row.tetto_massimo ?? 500,
      quota_fino_5000: row.quota_fino_5000 ?? 50,
      quota_5001_10000: row.quota_5001_10000 ?? 75,
      quota_10001_50000: row.quota_10001_50000 ?? 100,
      quota_oltre_50000: row.quota_oltre_50000 ?? 150,
      quota_domanda_aggiuntiva: row.quota_domanda_aggiuntiva ?? 25,
      importo_minimo: row.importo_minimo ?? 100,
      quota_base_trimestrale: row.quota_base_trimestrale ?? 50,
      quota_per_cedolino_edile: row.quota_per_cedolino_edile ?? 1,
      quota_per_cedolino_dirigente: row.quota_per_cedolino_dirigente ?? 9,
    });
    setAziendeAmmesseSearch("");
    setFasceEsistentiIds({});
    setNuovaVoceOpen(true);
    if (row.codice) {
      api.get(`/prestazioni/listino/${row.codice}/aziende`)
        .then((res) => {
          const codici = (res.data || []).map((r) => String(r.codice_univoco_azienda));
          setNuovaVoce((prev) => ({
            ...prev,
            tutte_aziende: Number(row.limitata_aziende) !== 1 && codici.length === 0,
            aziende_ammesse: codici,
          }));
        })
        .catch(() => {});
    }
    if ((row.tipologia_fatturazione || "Z") === "I" && row.codice) {
      loadFasceIipayContext(row.codice).then((prezzi) => {
        const haFasce = Object.keys(prezzi).length > 0;
        setFasceOriginali(prezzi);
        setNuovaVoce((prev) => ({
          ...prev,
          iipay_a_fascia: haFasce,
          fasce_prezzi: prezzi,
          // La voce può avere prezzi a fascia anche se il metodo_fatturazione salvato
          // non è ancora coerente (dati storici): allinea il toggle a ciò che è vero.
          metodo_fatturazione: haFasce ? metodoIipayIds.tabella : prev.metodo_fatturazione,
        }));
      });
    }
  };

  const setNuovaVoceField = (field, value) => {
    setNuovaVoce((prev) => ({ ...prev, [field]: value }));
  };

  const toggleAziendaAmmessa = (codiceAzienda) => {
    setNuovaVoce((prev) => {
      const key = String(codiceAzienda);
      const set = new Set(prev.aziende_ammesse.map(String));
      if (set.has(key)) set.delete(key); else set.add(key);
      return { ...prev, aziende_ammesse: Array.from(set) };
    });
  };

  const setDescrizioneObbligatoria = (checked) => {
    setNuovaVoce((prev) => ({
      ...prev,
      descrizione_obbligatoria: isIntegrazioneSalariale(prev) ? true : checked,
      richiesta: isIntegrazioneSalariale(prev)
        ? (String(prev.richiesta || "").trim() || "Inserire periodo dal … al …")
        : checked ? prev.richiesta : "",
    }));
  };

  const handleSaveNuovaVoce = async () => {
    const descrizioneAgo = String(nuovaVoce.descrizione_voce_ago || "").trim();
    const descrizioneCrm = String(nuovaVoce.descrizione_voce_crm || "").trim();
    const codiceAgo = String(nuovaVoce.nuovo_codice_ago || "").trim();
    if (!codiceAgo && !editingVoceCodice) {
      toast.warning("Inserisci il codice AGO");
      return;
    }
    if (!descrizioneAgo && !descrizioneCrm) {
      toast.warning("Inserisci almeno una descrizione");
      return;
    }
    if (!["Z", "B", "I"].includes(String(nuovaVoce.tipologia_fatturazione || "").toUpperCase())) {
      toast.warning("Seleziona una tipologia valida");
      return;
    }
    const importoDefault = parseImportoInput(nuovaVoce.importo_default);
    if (String(nuovaVoce.importo_default || "").trim() && importoDefault == null) {
      toast.warning("Importo default non valido");
      return;
    }
    if (isIntegrazioneSalariale(nuovaVoce)) {
      const fields = ["cigo_quota_base", "cigo_maltempo_quota_base", "quota_variabile", "fsba_coefficiente", "fsba_minimo", "tetto_massimo"];
      if (fields.some((field) => parseImportoInput(nuovaVoce[field]) == null || parseImportoInput(nuovaVoce[field]) < 0)) {
        toast.warning("Completa tutti i parametri di calcolo dell’integrazione salariale");
        return;
      }
      if (parseImportoInput(nuovaVoce.tetto_massimo) <= 0) {
        toast.warning("Il tetto massimo deve essere maggiore di zero");
        return;
      }
      if (parseImportoInput(nuovaVoce.fsba_minimo) > parseImportoInput(nuovaVoce.tetto_massimo)) {
        toast.warning("Il minimo FSBA non può superare il tetto massimo");
        return;
      }
    }
    if (isBpoint1439(nuovaVoce)) {
      const fields = ["quota_fino_5000", "quota_5001_10000", "quota_10001_50000", "quota_oltre_50000", "quota_domanda_aggiuntiva", "importo_minimo"];
      if (fields.some((field) => parseImportoInput(nuovaVoce[field]) == null || parseImportoInput(nuovaVoce[field]) < 0)) {
        toast.warning("Completa tutti i parametri di calcolo della voce 1439");
        return;
      }
    }
    if (isBpoint442(nuovaVoce)) {
      if (['quota_base_trimestrale', 'quota_per_cedolino_edile'].some((field) =>
        parseImportoInput(nuovaVoce[field]) == null || parseImportoInput(nuovaVoce[field]) < 0)) {
        toast.warning('Completa i parametri di calcolo della voce 442');
        return;
      }
    }
    if (isBpoint446(nuovaVoce) && (parseImportoInput(nuovaVoce.quota_per_cedolino_dirigente) == null
      || parseImportoInput(nuovaVoce.quota_per_cedolino_dirigente) < 0)) {
      toast.warning('Completa i parametri di calcolo della voce 446');
      return;
    }
    const isEditingVoce = Boolean(editingVoceCodice);
    const tipologiaNuovaVoce = String(nuovaVoce.tipologia_fatturazione || "").toUpperCase();
    const importoDefaultCambiato =
      (!isEditingVoce || !sameImportoInput(nuovaVoce.importo_default, nuovaVoce.importo_default_original));
    const fasceCambiate = !isEditingVoce || (
      nuovaVoce.iipay_a_fascia &&
      fasceStandardIipay.some((fascia) => {
        const current = nuovaVoce.fasce_prezzi[fascia.key];
        if (String(current ?? "").trim() === "") return false;
        return !sameImportoInput(current, fasceOriginali[fascia.key]);
      })
    );
    const prezzoCambiato =
      !isEditingVoce ||
      (tipologiaNuovaVoce === "I" && nuovaVoce.iipay_a_fascia
        ? fasceCambiate
        : importoDefaultCambiato);
    if (prezzoCambiato && !String(nuovaVoce.prezzo_decorrenza || "").trim()) {
      toast.warning("Seleziona la decorrenza prezzo");
      return;
    }

    setSavingNuovaVoce(true);
    try {
      const richiestaText = String(nuovaVoce.richiesta || "").trim();
      const fallbackUnchanged =
        !!nuovaVoce.codice_ago_fallback &&
        normalizeCodiceListino(codiceAgo) === normalizeCodiceListino(nuovaVoce.codice);
      const payload = {
        ...nuovaVoce,
        tipologia_fatturazione: String(nuovaVoce.tipologia_fatturazione).toUpperCase(),
        codice: String(nuovaVoce.codice || "").trim() || null,
        nuovo_codice_ago: fallbackUnchanged ? null : codiceAgo || null,
        descrizione_voce_ago: descrizioneAgo || descrizioneCrm,
        descrizione_voce_crm: descrizioneCrm || null,
        appartenenza: Number(nuovaVoce.appartenenza) || null,
        settore: Number(nuovaVoce.settore) || null,
        metodo_fatturazione: Number(nuovaVoce.metodo_fatturazione) || null,
        sezione_crm: String(nuovaVoce.sezione_crm || "").trim() || "3",
        importo_default: importoDefault,
        note: String(nuovaVoce.note || "").trim() || null,
        richiesta: isIntegrazioneSalariale(nuovaVoce)
          ? (richiestaText || "Inserire periodo dal … al …")
          : nuovaVoce.descrizione_obbligatoria ? (richiestaText || "descrizione obbligatoria") : null,
        voce_particolare: !!nuovaVoce.voce_particolare,
        quantita_obbligatoria: !!nuovaVoce.quantita_obbligatoria,
        attivo: !!nuovaVoce.attivo,
        solo_admin: !!nuovaVoce.solo_admin,
        cigo_quota_base: parseImportoInput(nuovaVoce.cigo_quota_base),
        cigo_maltempo_quota_base: parseImportoInput(nuovaVoce.cigo_maltempo_quota_base),
        quota_variabile: parseImportoInput(nuovaVoce.quota_variabile),
        fsba_coefficiente: parseImportoInput(nuovaVoce.fsba_coefficiente),
        fsba_minimo: parseImportoInput(nuovaVoce.fsba_minimo),
        tetto_massimo: parseImportoInput(nuovaVoce.tetto_massimo),
        quota_fino_5000: parseImportoInput(nuovaVoce.quota_fino_5000),
        quota_5001_10000: parseImportoInput(nuovaVoce.quota_5001_10000),
        quota_10001_50000: parseImportoInput(nuovaVoce.quota_10001_50000),
        quota_oltre_50000: parseImportoInput(nuovaVoce.quota_oltre_50000),
        quota_domanda_aggiuntiva: parseImportoInput(nuovaVoce.quota_domanda_aggiuntiva),
        importo_minimo: parseImportoInput(nuovaVoce.importo_minimo),
        quota_base_trimestrale: parseImportoInput(nuovaVoce.quota_base_trimestrale),
        quota_per_cedolino_edile: parseImportoInput(nuovaVoce.quota_per_cedolino_edile),
        quota_per_cedolino_dirigente: parseImportoInput(nuovaVoce.quota_per_cedolino_dirigente),
        limitata_aziende: !nuovaVoce.tutte_aziende,
        data_decorrenza: prezzoCambiato ? (String(nuovaVoce.prezzo_decorrenza || "").trim() || null) : null,
      };

      const aziendeAmmesse = nuovaVoce.tutte_aziende ? [] : nuovaVoce.aziende_ammesse;
      const res = editingVoceCodice
        ? await api.put(`/prestazioni/listino/${editingVoceCodice}`, { prestazione: payload, aziende_ammesse: aziendeAmmesse })
        : await api.post("/prestazioni/listino", { prestazione: payload, aziende_ammesse: aziendeAmmesse });

      // La rate card (tariffe_iipay_cedolini) è condivisa da tutte le aziende del
      // listino: se la voce è ristretta a "solo alcune aziende" non deve propagare
      // il prezzo lì, altrimenti si applicherebbe erroneamente a tutti i clienti.
      const mesiSovrascritti = [];
      if (payload.tipologia_fatturazione === "I" && res.data?.codice && nuovaVoce.tutte_aziende && prezzoCambiato) {
        const codicePrestazione = res.data.codice;
        const decorrenza = String(nuovaVoce.prezzo_decorrenza || "").trim() || null;

        if (nuovaVoce.iipay_a_fascia) {
          for (const fascia of fasceStandardIipay) {
            const importoFascia = parseImportoInput(nuovaVoce.fasce_prezzi[fascia.key]);
            const importoOriginale = parseImportoInput(fasceOriginali[fascia.key]);
            const existingId = fasceEsistentiIds[fascia.key];
            if (importoFascia == null) continue;
            // Fascia non toccata rispetto a quella caricata all'apertura: non
            // riscriverla, altrimenti ogni salvataggio crea una riga di storico
            // per TUTTE le fasce invece che solo per quella cambiata davvero.
            if (existingId && importoFascia === importoOriginale) continue;
            const fasciaPayload = {
              prestazione: codicePrestazione,
              tipologia_listino_iipay: 1,
              importo: importoFascia,
              min_fascia: fascia.min_fascia ?? null,
              max_fascia: fascia.max_fascia ?? null,
              data_decorrenza: decorrenza,
            };
            const fasciaRes = await api.post(`/tipologia_listino_iipay/tariffe`, fasciaPayload);
            if (fasciaRes.data?.aggiornata) mesiSovrascritti.push(`fascia ${getFasciaLabel(fascia)}`);
          }
        } else if (Number(payload.metodo_fatturazione) === metodoIipayIds.fisso && importoDefaultCambiato) {
          const importoFisso = importoDefault;
          if (importoFisso != null) {
            const fissoPayload = {
              prestazione: codicePrestazione,
              tipologia_listino_iipay: 1,
              importo: importoFisso,
              min_fascia: null,
              max_fascia: null,
              data_decorrenza: decorrenza,
            };
            const fissoRes = await api.post(`/tipologia_listino_iipay/tariffe`, fissoPayload);
            if (fissoRes.data?.aggiornata) mesiSovrascritti.push("importo fisso");
          }
        }
      }
      if (mesiSovrascritti.length) {
        toast.warning(`Hai sovrascritto un prezzo già impostato per lo stesso mese: ${mesiSovrascritti.join(", ")}`);
      }

      if (clienteSel) await loadListinoCliente(clienteSel);
      if (view === "voci") await loadVociListino();
      if (view === "rate_card" && payload.tipologia_fatturazione === "I") {
        await loadTariffeIipay(IIPAY_LISTINO_BASE_ID);
      }
      setNuovaVoceOpen(false);
      setEditingVoceCodice(null);
      setNuovaVoce(NUOVA_VOCE_DEFAULT);
      setFasceEsistentiIds({});
      toast.success(`Voce ${res.data?.nuovo_codice_ago || ""} ${editingVoceCodice ? "aggiornata" : "creata"}`);
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore creazione voce listino");
    } finally {
      setSavingNuovaVoce(false);
    }
  };

  // Senza codiceCliente (da "Voci listino", storico generale): solo le variazioni
  // condivise. Con codiceCliente (dal listino di un cliente specifico): condivise
  // + solo quelle di quel cliente - mai quelle di altri clienti.
  const openStoricoPrezzi = async (row, codiceCliente = null) => {
    setStoricoPrezziOpen(true);
    setStoricoPrezziVoce(row);
    setLoadingStoricoPrezzi(true);
    try {
      const res = await api.get(`/prestazioni/listino/${row.codice}/storico-prezzi`, {
        params: codiceCliente ? { codice_univoco_azienda: codiceCliente } : {},
      });
      setStoricoPrezziRows(res.data || []);
    } catch {
      toast.error("Errore caricamento storico prezzi");
      setStoricoPrezziRows([]);
    } finally {
      setLoadingStoricoPrezzi(false);
    }
  };

  const closeStoricoPrezzi = () => {
    setStoricoPrezziOpen(false);
    setStoricoPrezziVoce(null);
    setStoricoPrezziRows([]);
  };

  const loadDatiZucchetti = useCallback(async (codice) => {
    if (!codice) {
      setDatiZucchetti([]);
      return;
    }
    try {
      const params = new URLSearchParams();
      if (anno) params.set("anno", anno);
      if (mese) params.set("mese", mese);
      const query = params.toString();
      const res = await api.get(`/dati_parcellazione_zucchetti/${codice}${query ? `?${query}` : ""}`);
      setDatiZucchetti(res.data || []);
    } catch {
      setDatiZucchetti([]);
      toast.error("Errore caricamento dati Zucchetti cliente");
    }
  }, [anno, mese]);

  const loadScontoCliente = useCallback(async (codice) => {
    if (!codice) {
      setScontoClienteRows([]);
      return;
    }
    try {
      const res = await api.get(`/billing/client-discounts/${codice}`);
      setScontoClienteRows(res.data || []);
    } catch {
      setScontoClienteRows([]);
    }
  }, []);

  const loadScontoGlobaleIIpay = useCallback(async () => {
    try {
      const res = await api.get(`/billing/client-discounts/global/iipay`);
      setScontoGlobaleIIpayRows(res.data || []);
    } catch {
      setScontoGlobaleIIpayRows([]);
    }
  }, []);

  const refreshClienteListinoState = useCallback(async () => {
    if (!clienteSel) return;
    if (cliente?.tipologia_fatturazione === "I") {
      await loadDatiIipay(clienteSel);
      await loadListinoCliente(clienteSel);
      return;
    }
    if (["Z", "B"].includes(cliente?.tipologia_fatturazione)) {
      await loadDatiZucchetti(clienteSel);
    }
    await Promise.all([
      loadListinoCliente(clienteSel),
      loadTariffeClienteOverride(clienteSel),
    ]);
  }, [
    clienteSel,
    cliente?.tipologia_fatturazione,
    loadDatiIipay,
    loadDatiZucchetti,
    loadListinoCliente,
    loadTariffeClienteOverride,
  ]);

  const handleDeleteStoricoRow = async (group) => {
    if (!window.confirm(`Eliminare questa variazione e ripristinare il prezzo precedente (${group.importo_precedente == null ? "vuoto" : fmt(group.importo_precedente)})? L'operazione non può essere annullata.`)) return;
    try {
      for (const id of group.ids) {
        await api.delete(`/prestazioni/listino/storico-prezzi/${id}`);
      }
      setStoricoPrezziRows((prev) => prev.filter((r) => !group.ids.includes(r.id)));
      await refreshClienteListinoState();
      if (view === "voci") await loadVociListino();
      if (view === "rate_card") await loadTariffeIipay(IIPAY_LISTINO_BASE_ID);
      toast.success("Variazione annullata, prezzo precedente ripristinato");
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore eliminazione riga storico");
    }
  };

  const handleDeleteVoce = async (row) => {
    if (!isAdmin) return;
    const descrizione = row.descrizione_voce_crm || row.descrizione_voce_ago || row.codice;
    const messaggio = row.tipologia_fatturazione === 'B'
      ? `Eliminare la voce "${descrizione}" dal listino BPoint? Le righe nei mesi chiusi saranno conservate; quelle nei mesi aperti passeranno tra gli eliminati.`
      : `Eliminare definitivamente la voce "${descrizione}" (codice ${codiceAgoVoce(row)})? L'operazione non può essere annullata.`;
    if (!window.confirm(messaggio)) {
      return;
    }
    try {
      await api.delete(`/prestazioni/listino/${row.codice}`);
      await loadVociListino();
      if (clienteSel) await loadListinoCliente(clienteSel);
      toast.success("Voce eliminata");
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore eliminazione voce");
    }
  };

  const buildZucchettiEditState = (row, codice, configs, selectedId = null) => {
    const selected = selectedId != null
      ? configs.find((config) => String(config.id) === String(selectedId))
      : configs[0];
    const periodicita = selected?.periodicita && selected.periodicita !== "mensile" ? "custom" : "mensile";
    const selectedImportoForfait = selected?.importo_forfait ?? row?.importo;
    const selectedCostoExtra = selected?.costo_extra ?? row?.importo_unitario ?? row?.prezzo_unitario ?? row?.costo_unitario ?? row?.importo_cedolino ?? row?.importo;
    return {
      row,
      importo: codice === "186" ? fmt(selectedImportoForfait) : fmt(selectedCostoExtra),
      decorrenza: "",
      zucchettiCodice: codice,
      zucchettiRows: configs,
      zucchettiId: selected?.id ?? null,
      importoForfait: fmt(selectedImportoForfait),
      maxCedolini: selected?.max_cedolini ?? "",
      costoExtra: fmt(selectedCostoExtra),
      periodicita,
      // La cadenza vera del cliente (trimestrale/semestrale/annuale) va conservata:
      // qui sopra diventa "custom" solo per mostrare i mesi selezionati nella griglia,
      // e senza questa copia il salvataggio la declasserebbe a "personalizzata".
      periodicitaOriginale: selected?.periodicita || "mensile",
      mesiModificati: false,
      mesiFatturazione: mesiFromPeriodicita(selected?.periodicita, selected?.mesi_fatturazione),
    };
  };

  const openEditListinoCliente = (row) => {
    if (!isAdmin || !clienteSel || !row) return;
    if (cliente?.tipologia_fatturazione === "B" && Number(row.codice) === 427) {
      openBpointClienteEdit(row);
      return;
    }
    if (cliente?.tipologia_fatturazione === "Z" && (row.tariffa_fascia_cliente || row.tariffa_fascia_voce?.fasce?.length)) {
      const tipo = row.tariffa_fascia_voce?.fasce?.length ? "voce" : "cliente";
      const source = tipo === "voce"
        ? row.tariffa_fascia_voce.fasce.map((item) => ({
            label: item.max_quantita == null ? `Oltre ${Number(item.min_quantita) - 1}` : Number(item.min_quantita) === 0 ? `Fino a ${item.max_quantita}` : `${item.min_quantita}-${item.max_quantita}`,
            importo: fmt(item.importo_unitario),
          }))
        : [
            { label: `Fino a ${row.tariffa_fascia_cliente.soglia}`, importo: fmt(row.tariffa_fascia_cliente.importo_fino_soglia) },
            { label: `Oltre ${row.tariffa_fascia_cliente.soglia}`, importo: fmt(row.tariffa_fascia_cliente.importo_oltre_soglia) },
          ];
      setFasceZucchettiEdit({ row, tipo, fasce: source, decorrenza: refDateIipay || moment().startOf("month").format("YYYY-MM-DD") });
      return;
    }
    const sezioneForfait = getForfaitSection(row, cliente);
    if (sezioneForfait) {
      const gestionale = cliente?.tipologia_fatturazione === "B" ? "BPOINT" : "Zucchetti";
      toast.info(`La voce ${codiceAgoVoce(row)} ${gestionale} si modifica dalla sezione Forfait${sezioneForfait === 5 ? " F24" : ""} (sezione ${sezioneForfait})`);
      return;
    }
    resetAggiornamentoMassivo();
    // Per i clienti iiPay il prezzo personalizzato si gestisce sempre dalla
    // tabella con decorrenza (tariffe_iipay_cedolini_cliente), non da
    // prestazioni_azienda che non ha concetto di fascia né di data e si
    // applicherebbe anche ai mesi passati. A fascia -> editor multi-fascia,
    // fisso -> editor a singolo valore (stesso backend, stessa decorrenza).
    if (cliente?.tipologia_fatturazione === "I") {
      if (row.iipay_min_fascia_applicata != null || row.iipay_max_fascia_applicata != null) {
        openEditTariffaClienteMulti({
          codice: row.codice,
          nuovo_codice_ago: row.nuovo_codice_ago,
          codice_visualizzato: row.codice_visualizzato,
          descrizione: row.descrizione,
        });
      } else {
        openEditTariffaCliente({
          prestazione: row.codice,
          nuovo_codice_ago: row.nuovo_codice_ago,
          codice_visualizzato: row.codice_visualizzato,
          tipologia_listino_iipay: datiIipay?.tipologia_listino_iipay || 1,
          min_fascia: null,
          max_fascia: null,
          importo: row.importo,
          descrizione_prestazione: row.descrizione,
          is_override: !!row.personalizzato,
        });
      }
      return;
    }
    if (cliente?.tipologia_fatturazione === "Z" && isZucchettiForfaitListinoCode(row)) {
      const codice = codiceAgoVoce(row);
      const configs = datiZucchetti.filter((config) =>
        codice === "189"
          ? Number(config.tipologia_cliente) === 0
          : Number(config.tipologia_cliente) === 1
      );
      setListinoClienteEdit(buildZucchettiEditState(row, codice, configs));
      return;
    }
    const importoClienteDaModificare = row.importo_cliente_corrente ?? row.importo;
    setListinoClienteEdit({
      row,
      importo: String(row.codice) === "198" && getMetodoClienteDoppiaOpzione(row) === 4
        ? fmt(row.canone_forfait)
        : importoClienteDaModificare === null || importoClienteDaModificare === undefined || importoClienteDaModificare === ""
          ? ""
          : Number(importoClienteDaModificare) === 0 ? "0,00" : fmt(importoClienteDaModificare),
      decorrenza: "",
      metodoFatturazioneCliente: cliente?.tipologia_fatturazione === "Z" && isVoceDoppiaOpzione(row)
        ? String(getMetodoClienteDoppiaOpzione(row))
        : "",
      aZero: isAZero(row),
      applicato: String(row.codice) === "447" && Number(row.bpoint_447_applicato) === 1,
    });
  };

  const saveFasceZucchetti = async () => {
    if (!fasceZucchettiEdit || savingFasceZucchetti) return;
    setSavingFasceZucchetti(true);
    try {
      await api.put(`/prestazione_azienda/listini/cliente/${clienteSel}/tariffe-fascia-zucchetti`, {
        tipo: fasceZucchettiEdit.tipo,
        decorrenza: fasceZucchettiEdit.decorrenza,
        fasce: fasceZucchettiEdit.fasce.map((item) => ({ importo: item.importo })),
      });
      toast.success("Prezzi delle fasce aggiornati");
      setFasceZucchettiEdit(null);
      await loadListinoCliente(clienteSel);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Errore durante il salvataggio delle fasce");
    } finally {
      setSavingFasceZucchetti(false);
    }
  };

  const closeEditListinoCliente = () => {
    setListinoClienteEdit(LISTINO_CLIENTE_EDIT_DEFAULT);
    resetAggiornamentoMassivo();
  };

  const handleZucchettiConfigChange = (id) => {
    const row = listinoClienteEdit.row;
    const codice = listinoClienteEdit.zucchettiCodice;
    if (!row || !codice) return;
    setListinoClienteEdit(buildZucchettiEditState(row, codice, listinoClienteEdit.zucchettiRows, id));
    resetAggiornamentoMassivo();
  };

  const handleZucchettiForfaitMode = (mode) => {
    setListinoClienteEdit((prev) => ({
      ...prev,
      periodicita: mode === "all" ? "mensile" : "custom",
      mesiFatturazione: mode === "all" ? "" : prev.mesiFatturazione,
      mesiModificati: true,
    }));
  };

  const handleToggleZucchettiMese = (mese) => {
    setListinoClienteEdit((prev) => {
      const current = parseMesiFatturazione(prev.mesiFatturazione);
      const next = current.includes(mese)
        ? current.filter((m) => m !== mese)
        : [...current, mese];
      return {
        ...prev,
        periodicita: "custom",
        mesiFatturazione: serializeMesiFatturazione(next),
        mesiModificati: true,
      };
    });
  };

  const eseguiSalvataggioZucchettiListinoCliente = async (dati, zucchettiId) => {
    setSavingListinoClienteEdit(true);
    try {
      if (zucchettiId) {
        await api.put(`/dati_parcellazione_zucchetti/${zucchettiId}`, { dati });
      } else {
        await api.post("/dati_parcellazione_zucchetti", { dati });
      }
      await Promise.all([loadDatiZucchetti(clienteSel), loadListinoCliente(clienteSel)]);
      setListinoClienteEdit(LISTINO_CLIENTE_EDIT_DEFAULT);
      toast.success("Configurazione Zucchetti aggiornata");
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore aggiornamento configurazione Zucchetti");
    } finally {
      setSavingListinoClienteEdit(false);
    }
  };

  // Reset del pannello "Aggiornamento massivo" (checkbox + elenco clienti con
  // lo stesso prezzo): va richiamato ogni volta che si apre/chiude/cambia la
  // voce in modifica, altrimenti resterebbe agganciato alla voce precedente.
  const resetAggiornamentoMassivo = () => {
    setMassivoAttivo(false);
    setStessoPrezzoConfirm(null);
    setStessoPrezzoSelezionati(new Set());
    setStessoPrezzoSearch("");
  };

  const toggleStessoPrezzoSelezionato = (codiceUnivoco) => {
    setStessoPrezzoSelezionati((prev) => {
      const next = new Set(prev);
      if (next.has(codiceUnivoco)) next.delete(codiceUnivoco);
      else next.add(codiceUnivoco);
      return next;
    });
  };

  const toggleStessoPrezzoSelezionaTutti = () => {
    if (!stessoPrezzoConfirm) return;
    const search = stessoPrezzoSearch.trim().toLowerCase();
    const visibili = search
      ? stessoPrezzoConfirm.clienti.filter((c) => c.ragione_sociale.toLowerCase().includes(search))
      : stessoPrezzoConfirm.clienti;
    const tuttiVisibiliSelezionati = visibili.every((c) => stessoPrezzoSelezionati.has(c.codice_univoco));
    setStessoPrezzoSelezionati((prev) => {
      const next = new Set(prev);
      visibili.forEach((c) => {
        if (tuttiVisibiliSelezionati) next.delete(c.codice_univoco);
        else next.add(c.codice_univoco);
      });
      return next;
    });
  };

  // Spuntando "Aggiornamento massivo" nel form di modifica (prima di
  // salvare), andiamo subito a vedere chi altro ha oggi lo stesso prezzo di
  // questa voce per questo cliente, cosi' l'admin puo' scegliere a chi
  // altro applicarlo nello stesso form, senza un passaggio successivo.
  const handleToggleAggiornamentoMassivo = async (checked) => {
    setMassivoAttivo(checked);
    setStessoPrezzoConfirm(null);
    setStessoPrezzoSelezionati(new Set());
    setStessoPrezzoSearch("");
    if (!checked) return;
    const row = listinoClienteEdit.row;
    if (!row || !["Z", "B"].includes(cliente?.tipologia_fatturazione)) return;
    setLoadingStessoPrezzo(true);
    try {
      const { data } = await api.get(
        `/prestazione_azienda/listini/cliente/${clienteSel}/prestazione/${row.codice}/stesso-prezzo`
      );
      setStessoPrezzoConfirm({
        kind: "standard",
        descrizione: row.descrizione,
        importoAttuale: data?.importo ?? null,
        clienti: data?.clienti || [],
      });
      setStessoPrezzoSelezionati(new Set((data?.clienti || []).map((c) => c.codice_univoco)));
    } catch (err) {
      toast.error("Errore controllo altri clienti con lo stesso prezzo");
      setMassivoAttivo(false);
    } finally {
      setLoadingStessoPrezzo(false);
    }
  };

  // Stessa cosa per il costo extra/cedolino (187/189): serve una
  // configurazione gia' esistente (zucchettiId) da cui leggere il prezzo
  // attuale da confrontare.
  const handleToggleAggiornamentoMassivoZucchetti = async (checked) => {
    setMassivoAttivo(checked);
    setStessoPrezzoConfirm(null);
    setStessoPrezzoSelezionati(new Set());
    setStessoPrezzoSearch("");
    if (!checked) return;
    const zucchettiId = listinoClienteEdit.zucchettiId;
    if (!zucchettiId) return;
    setLoadingStessoPrezzo(true);
    try {
      const { data } = await api.get(`/dati_parcellazione_zucchetti/${zucchettiId}/stesso-prezzo`);
      setStessoPrezzoConfirm({
        kind: "zucchetti",
        descrizione: listinoClienteEdit.row?.descrizione,
        importoAttuale: data?.costoExtra ?? null,
        clienti: data?.clienti || [],
        zucchettiId,
      });
      setStessoPrezzoSelezionati(new Set((data?.clienti || []).map((c) => c.codice_univoco)));
    } catch (err) {
      toast.error("Errore controllo altri clienti con lo stesso prezzo");
      setMassivoAttivo(false);
    } finally {
      setLoadingStessoPrezzo(false);
    }
  };

  const eseguiSalvataggioZucchettiMassivo = async (ids, costoExtra, decorrenza) => {
    setSavingListinoClienteEdit(true);
    try {
      await api.put(`/dati_parcellazione_zucchetti/costo-extra-massivo`, {
        ids,
        costo_extra: costoExtra,
        data_decorrenza: decorrenza,
      });
      await Promise.all([loadDatiZucchetti(clienteSel), loadListinoCliente(clienteSel)]);
      setListinoClienteEdit(LISTINO_CLIENTE_EDIT_DEFAULT);
      resetAggiornamentoMassivo();
      toast.success(`Prezzo aggiornato per ${ids.length} configurazioni`);
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore aggiornamento massivo del prezzo");
    } finally {
      setSavingListinoClienteEdit(false);
    }
  };

  const handleSaveZucchettiListinoCliente = async () => {
    const row = listinoClienteEdit.row;
    const codice = listinoClienteEdit.zucchettiCodice;
    if (!isAdmin || !clienteSel || !row || !codice) return;

    const importo = parseImportoInput(listinoClienteEdit.importo);
    const costoExtra = parseImportoInput(listinoClienteEdit.costoExtra);
    const maxCedoliniRaw = String(listinoClienteEdit.maxCedolini ?? "").trim();
    const maxCedolini = maxCedoliniRaw === "" ? null : Number(maxCedoliniRaw);
    const selectedConfig = listinoClienteEdit.zucchettiRows.find((config) =>
      String(config.id) === String(listinoClienteEdit.zucchettiId)
    ) || null;

    if (codice === "186" && listinoClienteEdit.periodicita === "custom" && !listinoClienteEdit.mesiFatturazione) {
      toast.warning("Seleziona almeno un mese");
      return;
    }
    if (maxCedoliniRaw !== "" && (!Number.isFinite(maxCedolini) || maxCedolini < 0)) {
      toast.warning("Cedolini max non valido");
      return;
    }
    if (codice === "186" && importo == null) {
      toast.warning("Importo forfait non valido");
      return;
    }
    if (codice === "187" && costoExtra == null) {
      toast.warning("Costo extra non valido");
      return;
    }
    if (codice === "189" && importo == null) {
      toast.warning("Costo cedolino non valido");
      return;
    }
    if (!listinoClienteEdit.decorrenza) {
      toast.warning("Seleziona la decorrenza prezzo");
      return;
    }

    // Il costo a cedolino (189) e il costo extra oltre soglia forfait (187)
    // sono tariffe unitarie spesso condivise tra clienti, quindi possono
    // sfruttare "Aggiornamento massivo". L'importo forfait (186) resta
    // escluso: e' una cifra negoziata per contratto, non una tariffa
    // confrontabile tra clienti.
    if ((codice === "187" || codice === "189") && massivoAttivo && stessoPrezzoConfirm?.kind === "zucchetti" && stessoPrezzoSelezionati.size) {
      const nuovoCostoExtra = codice === "189" ? importo : costoExtra;
      const idsSelezionati = stessoPrezzoConfirm.clienti
        .filter((c) => stessoPrezzoSelezionati.has(c.codice_univoco))
        .map((c) => c.id);
      const ids = [listinoClienteEdit.zucchettiId, ...idsSelezionati];
      await eseguiSalvataggioZucchettiMassivo(ids, nuovoCostoExtra, listinoClienteEdit.decorrenza);
      return;
    }

    // Finche' i mesi non vengono toccati la cadenza resta quella del cliente: la
    // griglia mostra "custom" solo per evidenziare i mesi di fatturazione, e
    // salvarla come tale trasformerebbe un trimestrale in "personalizzata",
    // cambiando fra l'altro il riproporzionamento dei clienti cessati.
    const periodicitaForfaitDaSalvare = listinoClienteEdit.mesiModificati
      ? listinoClienteEdit.periodicita
      : listinoClienteEdit.periodicitaOriginale || listinoClienteEdit.periodicita;

    const dati = codice === "189"
      ? {
          codice_univoco_azienda: clienteSel,
          tipologia_cliente: 0,
          importo_forfait: null,
          max_cedolini: null,
          costo_extra: importo,
          periodicita: selectedConfig?.periodicita || "mensile",
          mesi_fatturazione: selectedConfig?.mesi_fatturazione || null,
          data_decorrenza: listinoClienteEdit.decorrenza,
        }
      : {
          codice_univoco_azienda: clienteSel,
          tipologia_cliente: 1,
          importo_forfait: codice === "186" ? importo : selectedConfig?.importo_forfait ?? null,
          max_cedolini: codice === "186" ? maxCedolini : selectedConfig?.max_cedolini ?? null,
          costo_extra: codice === "187" ? costoExtra : selectedConfig?.costo_extra ?? null,
          periodicita: codice === "186" ? periodicitaForfaitDaSalvare : selectedConfig?.periodicita || "mensile",
          mesi_fatturazione: codice === "186"
            ? (periodicitaForfaitDaSalvare === "custom" ? listinoClienteEdit.mesiFatturazione : null)
            : selectedConfig?.mesi_fatturazione || null,
          data_decorrenza: listinoClienteEdit.decorrenza,
        };

    await eseguiSalvataggioZucchettiListinoCliente(dati, listinoClienteEdit.zucchettiId);
  };

  const eseguiSalvataggioSingoloListinoCliente = async ({ metodoCliente, importoRichiesto, aZero, importo, decorrenza, row }) => {
    setSavingListinoClienteEdit(true);
    try {
      await api.put(`/prestazione_azienda/listini/cliente/${clienteSel}/prestazione/${row.codice}`, {
        importo: importoRichiesto ? importo : null,
        metodo_fatturazione_cliente: metodoCliente,
        a_zero: aZero ? 1 : 0,
        data_decorrenza: importoRichiesto ? decorrenza : null,
      });
      await refreshClienteListinoState();
      setListinoClienteEdit(LISTINO_CLIENTE_EDIT_DEFAULT);
      resetAggiornamentoMassivo();
      toast.success("Voce cliente aggiornata");
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore aggiornamento voce cliente");
    } finally {
      setSavingListinoClienteEdit(false);
    }
  };

  const eseguiSalvataggioMassivoListinoCliente = async (row, codici, importo, decorrenza) => {
    setSavingListinoClienteEdit(true);
    try {
      await api.put(`/prestazione_azienda/listini/cliente-massivo/prestazione/${row.codice}`, {
        codici_univoci_azienda: codici,
        importo,
        data_decorrenza: decorrenza,
      });
      await refreshClienteListinoState();
      setListinoClienteEdit(LISTINO_CLIENTE_EDIT_DEFAULT);
      resetAggiornamentoMassivo();
      toast.success(`Prezzo aggiornato per ${codici.length} clienti`);
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore aggiornamento massivo del prezzo");
    } finally {
      setSavingListinoClienteEdit(false);
    }
  };

  const handleSaveListinoCliente = async () => {
    const row = listinoClienteEdit.row;
    if (!isAdmin || !clienteSel || !row) return;
    if (listinoClienteEdit.zucchettiCodice) {
      await handleSaveZucchettiListinoCliente();
      return;
    }
    if (String(row.codice) === "447") {
      setSavingListinoClienteEdit(true);
      try {
        const updated = {
          ...(datiBpointCliente || {}),
          codice_univoco_azienda: clienteSel,
          fondi_assicurazione_sanitaria: listinoClienteEdit.applicato ? 1 : 0,
        };
        await api.post('/dati_parcellazione_bpoint', { dati: updated });
        setDatiBpointCliente(updated);
        await refreshClienteListinoState();
        setListinoClienteEdit(LISTINO_CLIENTE_EDIT_DEFAULT);
        toast.success(`Voce 447 ${listinoClienteEdit.applicato ? "applicata" : "non applicata"}`);
      } catch (error) {
        toast.error(error.response?.data?.message || "Errore aggiornamento applicazione voce 447");
      } finally {
        setSavingListinoClienteEdit(false);
      }
      return;
    }
    const metodoCliente = cliente?.tipologia_fatturazione === "Z" && listinoClienteEdit.metodoFatturazioneCliente
      ? Number(listinoClienteEdit.metodoFatturazioneCliente)
      : null;
    const prezzoPerFondo203 = String(row.codice) === "203";
    const importoRichiesto = prezzoPerFondo203 || !isMetodoSenzaImportoFisso(metodoCliente || row.metodo_fatturazione);
    const aZero = !importoRichiesto && Boolean(listinoClienteEdit.aZero);
    const importo = parseImportoInput(listinoClienteEdit.importo);
    if (importoRichiesto && importo == null) {
      toast.warning("Importo non valido");
      return;
    }
    if (importoRichiesto && !listinoClienteEdit.decorrenza) {
      toast.warning("Seleziona la decorrenza prezzo");
      return;
    }

    if (massivoAttivo && stessoPrezzoConfirm?.kind === "standard" && stessoPrezzoSelezionati.size) {
      const codici = [clienteSel, ...Array.from(stessoPrezzoSelezionati)];
      await eseguiSalvataggioMassivoListinoCliente(row, codici, importo, listinoClienteEdit.decorrenza);
      return;
    }

    await eseguiSalvataggioSingoloListinoCliente({
      metodoCliente,
      importoRichiesto,
      aZero,
      importo,
      decorrenza: listinoClienteEdit.decorrenza,
      row,
    });
  };

  const openEditTariffaClienteMulti = async (row) => {
    if (!isAdmin || !clienteSel) return;
    setEditingTariffaClienteMulti({
      prestazione: row.codice,
      nuovo_codice_ago: row.nuovo_codice_ago,
      codice_visualizzato: row.codice_visualizzato,
      descrizione: row.descrizione || "",
      tipologia_listino_iipay: datiIipay?.tipologia_listino_iipay || 1,
    });
    setFasceClienteMultiDecorrenza("");
    const prezziRateCard = await loadFasceIipayContext(row.codice);
    setFasceClienteMultiRateCard(prezziRateCard || {});
    const prezziCliente = {};
    tariffeClienteOverride
      .filter((o) => String(o.prestazione) === String(row.codice))
      .forEach((o) => {
        prezziCliente[getFasciaKey(o)] = fmt(o.importo);
      });
    setFasceClienteMultiPrezzi(prezziCliente);
  };

  const closeEditTariffaClienteMulti = () => {
    setEditingTariffaClienteMulti(null);
    setFasceClienteMultiPrezzi({});
    setFasceClienteMultiRateCard({});
    setFasceClienteMultiDecorrenza("");
  };

  const handleSaveTariffaClienteMulti = async () => {
    const voce = editingTariffaClienteMulti;
    if (!isAdmin || !clienteSel || !voce) return;
    if (!fasceClienteMultiDecorrenza) {
      toast.warning("Seleziona la decorrenza prezzo");
      return;
    }

    setSavingTariffaClienteMulti(true);
    try {
      const fasceSovrascritte = [];
      for (const fascia of fasceStandardIipay) {
        const importoFascia = parseImportoInput(fasceClienteMultiPrezzi[fascia.key]);
        if (importoFascia == null) continue;
        const res = await api.post(`/tipologia_listino_iipay/cliente/tariffe`, {
          codice_univoco_azienda: clienteSel,
          prestazione: voce.prestazione,
          tipologia_listino_iipay: voce.tipologia_listino_iipay,
          importo: importoFascia,
          min_fascia: fascia.min_fascia ?? null,
          max_fascia: fascia.max_fascia ?? null,
          data_decorrenza: fasceClienteMultiDecorrenza,
        });
        if (res.data?.aggiornata) fasceSovrascritte.push(getFasciaLabel(fascia));
      }
      await refreshClienteListinoState();
      closeEditTariffaClienteMulti();
      if (fasceSovrascritte.length) {
        toast.warning(`Hai sovrascritto un prezzo già impostato per lo stesso mese sulla/e fascia/e: ${fasceSovrascritte.join(", ")}`);
      } else {
        toast.success("Prezzi personalizzati salvati");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore salvataggio prezzi personalizzati");
    } finally {
      setSavingTariffaClienteMulti(false);
    }
  };

  const openEditTariffaCliente = (row) => {
    if (!isAdmin || !clienteSel) return;
    // Una voce a fascia si gestisce con l'editor multi-fascia (tutte le
    // fasce insieme, con il prezzo di rate card come riferimento), non con
    // il singolo campo di questa riga.
    if (isFasciaRow(row)) {
      openEditTariffaClienteMulti({
        codice: row.prestazione,
        nuovo_codice_ago: row.nuovo_codice_ago,
        codice_visualizzato: row.codice_visualizzato,
        descrizione: row.descrizione_prestazione,
      });
      return;
    }
    setEditingTariffaCliente(row);
    setTariffaClienteImporto(row.importo == null ? "" : fmt(row.importo));
    setTariffaClienteDecorrenza(
      row.override_decorrenza ? moment(row.override_decorrenza).format("YYYY-MM-DD") : ""
    );
  };

  const closeEditTariffaCliente = () => {
    setEditingTariffaCliente(null);
    setTariffaClienteImporto("");
    setTariffaClienteDecorrenza("");
  };

  const handleSaveTariffaCliente = async () => {
    const row = editingTariffaCliente;
    if (!isAdmin || !clienteSel || !row) return;
    const importo = parseImportoInput(tariffaClienteImporto);
    if (importo == null) {
      toast.warning("Importo non valido");
      return;
    }
    if (!tariffaClienteDecorrenza) {
      toast.warning("Seleziona la decorrenza prezzo");
      return;
    }

    setSavingTariffaCliente(true);
    try {
      const res = await api.post(`/tipologia_listino_iipay/cliente/tariffe`, {
        codice_univoco_azienda: clienteSel,
        prestazione: row.prestazione,
        tipologia_listino_iipay: row.tipologia_listino_iipay,
        importo,
        min_fascia: row.min_fascia ?? null,
        max_fascia: row.max_fascia ?? null,
        data_decorrenza: tariffaClienteDecorrenza,
      });
      await refreshClienteListinoState();
      closeEditTariffaCliente();
      if (res.data?.aggiornata) {
        toast.warning("Hai sovrascritto il prezzo personalizzato già impostato per lo stesso mese");
      } else {
        toast.success("Prezzo personalizzato salvato");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore salvataggio prezzo personalizzato");
    } finally {
      setSavingTariffaCliente(false);
    }
  };

  const openStoricoTariffaCliente = (row) => {
    openStoricoPrezzi({
      codice: row.prestazione,
      nuovo_codice_ago: row.nuovo_codice_ago,
      codice_visualizzato: row.codice_visualizzato,
      descrizione_voce_crm: row.descrizione_prestazione,
    }, clienteSel);
  };

  const openEditPeriodicitaCliente = () => {
    if (!isAdmin || !clienteSel) return;
    const periodicita = periodicitaClienteValue || "mensile";
    setPeriodicitaClienteEdit({
      open: true,
      periodicita: PERIODICITA_OPTION_IDS.has(periodicita) ? periodicita : "mensile",
    });
  };

  const closeEditPeriodicitaCliente = () => {
    setPeriodicitaClienteEdit(PERIODICITA_CLIENTE_EDIT_DEFAULT);
  };

  const handleSavePeriodicitaCliente = async () => {
    if (!isAdmin || !clienteSel || !periodicitaClienteEdit.periodicita) return;
    setSavingPeriodicitaCliente(true);
    try {
      await api.put(`/prestazione_azienda/listini/cliente/${clienteSel}/periodicita`, {
        periodicita: periodicitaClienteEdit.periodicita,
        mesi_fatturazione: null,
      });
      if (cliente?.tipologia_fatturazione === "I") await loadDatiIipay(clienteSel);
      else await loadDatiZucchetti(clienteSel);
      await loadListinoCliente(clienteSel);
      setPeriodicitaClienteEdit(PERIODICITA_CLIENTE_EDIT_DEFAULT);
      toast.success("Periodicità cliente aggiornata");
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore aggiornamento periodicità cliente");
    } finally {
      setSavingPeriodicitaCliente(false);
    }
  };

  const handleSaveNoteFatturazioneCliente = async () => {
    if (!isAdmin || !clienteSel) return;
    setSavingNoteFatturazioneCliente(true);
    try {
      const nota = noteFatturazioneCliente.trim();
      await api.put(`/prestazione_azienda/listini/cliente/${clienteSel}/note-fatturazione`, {
        note_fatturazione: nota,
      });
      setClienti((current) => current.map((item) =>
        String(item.codice_univoco) === String(clienteSel)
          ? { ...item, note_fatturazione: nota || null }
          : item
      ));
      setNoteFatturazioneCliente(nota);
      setNoteFatturazioneOpen(false);
      toast.success(nota ? "Note fatturazione aggiornate" : "Note fatturazione cancellate");
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore aggiornamento note fatturazione");
    } finally {
      setSavingNoteFatturazioneCliente(false);
    }
  };

  const openEditTipoZucchetti = () => {
    if (!isAdmin || !clienteSel || cliente?.tipologia_fatturazione !== "Z") return;
    const oggi = new Date();
    setTipoZucchettiEdit({
      open: true,
      tipo: tipoZucchettiValue,
      decorrenza: `${oggi.getFullYear()}-${String(oggi.getMonth() + 1).padStart(2, "0")}`,
    });
  };

  const closeEditTipoZucchetti = () => {
    setTipoZucchettiEdit(TIPO_ZUCCHETTI_EDIT_DEFAULT);
  };

  const handleSaveTipoZucchetti = async () => {
    if (!isAdmin || !clienteSel || cliente?.tipologia_fatturazione !== "Z") return;
    const tipologieVolute = TIPOLOGIE_CLIENTE_ZUCCHETTI[tipoZucchettiEdit.tipo];
    if (!tipologieVolute) return;
    const daRimuovere = datiZucchetti.filter(
      (config) => !tipologieVolute.includes(Number(config.tipologia_cliente))
    );
    const presenti = new Set(datiZucchetti.map((config) => Number(config.tipologia_cliente)));
    const daCreare = tipologieVolute.filter((tipologia) => !presenti.has(tipologia));
    if (!daRimuovere.length && !daCreare.length) {
      closeEditTipoZucchetti();
      return;
    }
    if (daRimuovere.some((config) => config.importo_forfait != null || config.costo_extra != null)) {
      const conferma = window.confirm(
        "Le configurazioni non più previste verranno eliminate insieme ai loro importi.\n\nConfermi?"
      );
      if (!conferma) return;
    }
    setSavingTipoZucchetti(true);
    try {
      // Prima le nuove configurazioni, poi le rimozioni: il cliente non resta mai
      // senza alcuna configurazione, altrimenti il Payroll non saprebbe come fatturarlo.
      for (const tipologia of daCreare) {
        await api.post("/dati_parcellazione_zucchetti", {
          dati: {
            codice_univoco_azienda: clienteSel,
            tipologia_cliente: tipologia,
            importo_forfait: null,
            max_cedolini: null,
            costo_extra: null,
            periodicita: periodicitaClienteValue || "mensile",
            mesi_fatturazione: null,
            data_decorrenza: tipoZucchettiEdit.decorrenza ? `${tipoZucchettiEdit.decorrenza}-01` : null,
          },
        });
      }
      for (const config of daRimuovere) {
        await api.delete(`/dati_parcellazione_zucchetti/${config.id}`);
      }
      await refreshClienteListinoState();
      setTipoZucchettiEdit(TIPO_ZUCCHETTI_EDIT_DEFAULT);
      toast.success("Tipo cliente aggiornato");
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore aggiornamento tipo cliente");
    } finally {
      setSavingTipoZucchetti(false);
    }
  };

  const openEditIstatCliente = () => {
    if (!isAdmin || !clienteSel) return;
    setIstatClienteEdit({
      open: true,
      applicato: !!cliente?.istat_applicato,
      decorrenza: cliente?.istat_decorrenza ? String(cliente.istat_decorrenza).slice(0, 4) : "",
    });
  };

  const closeEditIstatCliente = () => {
    setIstatClienteEdit(ISTAT_CLIENTE_EDIT_DEFAULT);
  };

  const handleSaveIstatCliente = async () => {
    if (!isAdmin || !clienteSel) return;
    if (istatClienteEdit.applicato && !/^\d{4}$/.test(istatClienteEdit.decorrenza)) {
      toast.warning("Indica l'anno da cui è applicato l'ISTAT (sempre e solo dal 1° gennaio)");
      return;
    }
    setSavingIstatCliente(true);
    try {
      await api.put(`/prestazione_azienda/listini/cliente/${clienteSel}/istat`, {
        istat_applicato: istatClienteEdit.applicato,
        istat_decorrenza: istatClienteEdit.applicato ? `${istatClienteEdit.decorrenza}-01-01` : null,
      });
      await loadClienti();
      setIstatClienteEdit(ISTAT_CLIENTE_EDIT_DEFAULT);
      toast.success("ISTAT cliente aggiornato");
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore aggiornamento ISTAT cliente");
    } finally {
      setSavingIstatCliente(false);
    }
  };

  // Riga valida per il mese/anno selezionato nel filtro periodo della pagina
  // (stesso "anno"/"mese" period-aware gia' usato per Zucchetti/iiPay/ISTAT),
  // non necessariamente il mese solare corrente: se non c'e' un periodo
  // selezionato ricade sul mese corrente reale.
  const trovaScontoAttivo = (rows) => {
    const meseRiferimento = anno && mese ? `${anno}-${String(mese).padStart(2, "0")}-01` : moment().format("YYYY-MM") + "-01";
    return rows.find((r) => r.data_inizio <= meseRiferimento && (!r.data_fine || r.data_fine >= meseRiferimento)) || null;
  };

  const scontoClienteAttivo = trovaScontoAttivo(scontoClienteRows);
  const scontoGlobaleIIpayAttivo = trovaScontoAttivo(scontoGlobaleIIpayRows);

  const openEditScontoCliente = (row = null) => {
    if (!isAdmin || !clienteSel) return;
    const meseInizio = row?.data_inizio ? row.data_inizio.slice(0, 7) : "";
    setScontoClienteEdit({
      open: true,
      id: row?.id ?? null,
      percentuale: row ? fmt(row.percentuale) : "",
      meseInizio,
      meseInizioOriginale: meseInizio,
      meseFine: row?.data_fine ? row.data_fine.slice(0, 7) : "",
      note: row?.note || "",
    });
  };

  // Scorciatoia per un cliente iiPay sul default globale: precompila 0% dal
  // mese/anno del filtro corrente (o dal mese in corso), cosi' basta
  // confermare per escluderlo. Il cliente puo' comunque cambiare la
  // percentuale prima di salvare, se preferisce uno sconto diverso.
  const openEditScontoClienteEscludi = () => {
    if (!isAdmin || !clienteSel) return;
    setScontoClienteEdit({
      open: true,
      id: null,
      percentuale: fmt(0),
      meseInizio: anno && mese ? `${anno}-${String(mese).padStart(2, "0")}` : moment().format("YYYY-MM"),
      meseInizioOriginale: "",
      meseFine: "",
      // Stesso testo usato dall'esclusione massiva in ScontoGlobaleIIpay.js:
      // stessa azione, stessa nota.
      note: "Escluso dal default globale iiPay",
    });
  };

  const closeEditScontoCliente = () => setScontoClienteEdit(SCONTO_CLIENTE_EDIT_DEFAULT);

  const handleSaveScontoCliente = async () => {
    if (!isAdmin || !clienteSel) return;
    const percentuale = parseImportoInput(scontoClienteEdit.percentuale);
    if (percentuale == null || percentuale < 0 || percentuale > 100) {
      toast.warning("Indica una percentuale valida (0-100)");
      return;
    }
    if (!/^\d{4}-\d{2}$/.test(scontoClienteEdit.meseInizio)) {
      toast.warning("Indica il mese di inizio");
      return;
    }
    // Cambiare il mese di inizio rispetto a quello caricato significa aprire
    // un NUOVO periodo (storicizzando quello attuale), non correggere in
    // place quello esistente: in quel caso si crea sempre una riga nuova
    // (POST), anche se si e' aperta la modale da "Modifica" - upsertPeriodoScontoCliente
    // si occupa gia' di chiudere automaticamente il periodo precedente aperto.
    const correzioneInPlace = !!scontoClienteEdit.id && scontoClienteEdit.meseInizio === scontoClienteEdit.meseInizioOriginale;
    setSavingScontoCliente(true);
    try {
      const payload = {
        percentuale,
        data_inizio: scontoClienteEdit.meseInizio,
        data_fine: scontoClienteEdit.meseFine || null,
        note: scontoClienteEdit.note || null,
      };
      if (correzioneInPlace) {
        await api.put(`/billing/client-discounts/${scontoClienteEdit.id}`, payload);
      } else {
        await api.post(`/billing/client-discounts`, { ...payload, codice_univoco_azienda: clienteSel });
      }
      await loadScontoCliente(clienteSel);
      setScontoClienteEdit(SCONTO_CLIENTE_EDIT_DEFAULT);
      toast.success("Sconto cliente aggiornato");
    } catch (err) {
      if (err.response?.status === 409) {
        const suggerito = suggerisciMeseFineMassimo(scontoClienteRows, scontoClienteEdit.meseInizio, correzioneInPlace ? scontoClienteEdit.id : null);
        if (suggerito) {
          setScontoClienteEdit((prev) => ({ ...prev, meseFine: suggerito }));
          toast.warning(
            `Il periodo si sovrappone a uno gia' programmato: ho impostato come fine ${formatMeseAnnoStr(suggerito)}. Correggi se necessario e salva di nuovo, oppure elimina prima il periodo in conflitto dallo Storico.`
          );
          return;
        }
      }
      toast.error(err.response?.data?.message || "Errore aggiornamento sconto cliente");
    } finally {
      setSavingScontoCliente(false);
    }
  };

  const openStoricoScontoCliente = () => setStoricoScontoClienteOpen(true);
  const closeStoricoScontoCliente = () => setStoricoScontoClienteOpen(false);

  const handleEliminaScontoCliente = async (row) => {
    const periodo = `${formatMeseAnnoStr(row.data_inizio)}${row.data_fine ? ` - ${formatMeseAnnoStr(row.data_fine)}` : " (indeterminato)"}`;
    if (!window.confirm(`Eliminare il periodo di sconto ${fmt(row.percentuale)}% (${periodo})? L'operazione non può essere annullata.`)) return;
    try {
      await api.delete(`/billing/client-discounts/${row.id}`);
      await loadScontoCliente(clienteSel);
      toast.success("Periodo di sconto eliminato");
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore eliminazione sconto cliente");
    }
  };

  const openIstatApplica = () => {
    if (!isAdmin) return;
    setIstatApplica({ ...ISTAT_APPLICA_DEFAULT, open: true, selezionati: new Set() });
  };

  const closeIstatApplica = () => {
    setIstatApplica(ISTAT_APPLICA_DEFAULT);
  };

  const loadIstatAnteprima = useCallback(async (voce, percentualeInput, annoDecorrenza, arrotondamento) => {
    const percentuale = parseImportoInput(percentualeInput);
    if (!voce?.codice || !percentuale || !/^\d{4}$/.test(annoDecorrenza || "")) {
      setIstatApplica((prev) => ({ ...prev, anteprima: [], selezionati: new Set(), loadingAnteprima: false }));
      return;
    }
    setIstatApplica((prev) => ({ ...prev, loadingAnteprima: true }));
    try {
      const res = await api.get("/prestazione_azienda/listini/istat/anteprima", {
        params: { prestazione: voce.codice, tipologia_fatturazione: voce.tipologia, percentuale, decorrenza: `${annoDecorrenza}-01-01`, arrotondamento: arrotondamento || undefined },
      });
      const rows = res.data || [];
      setIstatApplica((prev) => ({
        ...prev,
        anteprima: rows,
        selezionati: new Set(rows.map((r) => r.codice_univoco)),
        loadingAnteprima: false,
      }));
    } catch (err) {
      setIstatApplica((prev) => ({ ...prev, anteprima: [], selezionati: new Set(), loadingAnteprima: false }));
      toast.error(err.response?.data?.message || "Errore caricamento anteprima ISTAT");
    }
  }, []);

  useEffect(() => {
    if (!istatApplica.open) return;
    loadIstatAnteprima(istatApplica.voce, istatApplica.percentuale, istatApplica.decorrenza, istatApplica.arrotondamento);
  }, [istatApplica.open, istatApplica.voce, istatApplica.percentuale, istatApplica.decorrenza, istatApplica.arrotondamento, loadIstatAnteprima]);

  const toggleIstatSelezionato = (codiceUnivoco) => {
    setIstatApplica((prev) => {
      const next = new Set(prev.selezionati);
      if (next.has(codiceUnivoco)) next.delete(codiceUnivoco);
      else next.add(codiceUnivoco);
      return { ...prev, selezionati: next };
    });
  };

  const toggleIstatSelezionaTutti = () => {
    setIstatApplica((prev) => {
      const search = prev.search.trim().toLowerCase();
      const visibili = search
        ? prev.anteprima.filter((r) => r.ragione_sociale.toLowerCase().includes(search))
        : prev.anteprima;
      const tuttiSelezionati = visibili.length > 0 && visibili.every((r) => prev.selezionati.has(r.codice_univoco));
      const next = new Set(prev.selezionati);
      visibili.forEach((r) => {
        if (tuttiSelezionati) next.delete(r.codice_univoco);
        else next.add(r.codice_univoco);
      });
      return { ...prev, selezionati: next };
    });
  };

  const handleApplicaIstat = async () => {
    if (!isAdmin || !istatApplica.voce?.codice || !istatApplica.percentuale || !/^\d{4}$/.test(istatApplica.decorrenza)) return;
    if (!istatApplica.selezionati.size) {
      toast.warning("Seleziona almeno un cliente");
      return;
    }
    setIstatApplica((prev) => ({ ...prev, applying: true }));
    try {
      const res = await api.put("/prestazione_azienda/listini/istat/applica", {
        prestazione: istatApplica.voce.codice,
        tipologia_fatturazione: istatApplica.voce.tipologia,
        percentuale: parseImportoInput(istatApplica.percentuale),
        decorrenza: `${istatApplica.decorrenza}-01-01`,
        arrotondamento: istatApplica.arrotondamento || null,
        codici_univoci_azienda: Array.from(istatApplica.selezionati),
      });
      toast.success(`Aumento ISTAT applicato a ${res.data?.aggiornati ?? 0} client${res.data?.aggiornati === 1 ? "e" : "i"}`);
      setIstatApplica(ISTAT_APPLICA_DEFAULT);
      if (clienteSel) {
        await loadDatiZucchetti(clienteSel);
        await loadListinoCliente(clienteSel);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore applicazione ISTAT");
    } finally {
      setIstatApplica((prev) => ({ ...prev, applying: false }));
    }
  };

  const openIstatReport = () => setIstatReportModal({ ...ISTAT_REPORT_DEFAULT, open: true });
  const closeIstatReport = () => setIstatReportModal(ISTAT_REPORT_DEFAULT);

  const handleExportIstatReport = async () => {
    const annoDa = Number(istatReportModal.annoDa);
    const annoA = Number(istatReportModal.annoA);
    if (!Number.isInteger(annoDa) || !Number.isInteger(annoA) || String(istatReportModal.annoDa).length !== 4 || String(istatReportModal.annoA).length !== 4) {
      toast.warning("Indica un intervallo di anni valido");
      return;
    }
    if (annoDa > annoA) {
      toast.warning("L'anno di inizio non può essere successivo a quello di fine");
      return;
    }

    const clientiZAttivi = [...clienti]
      .filter((c) => String(c.tipologia_fatturazione || "").toUpperCase() === "Z" && !c.data_fine_elaborazioni)
      .sort((a, b) => String(a.ragione_sociale || "").localeCompare(String(b.ragione_sociale || ""), "it", { sensitivity: "base" }));

    if (!clientiZAttivi.length) {
      toast.warning("Nessun cliente Zucchetti attivo da esportare");
      return;
    }

    setExportingIstatReport(true);
    try {
      const res = await api.get("/prestazione_azienda/listini/istat/report", {
        params: { anno_da: annoDa, anno_a: annoA },
      });
      const righeVariazioni = res.data || [];

      const wb = XLSX.utils.book_new();
      for (let anno = annoDa; anno <= annoA; anno++) {
        const righeAnno = righeVariazioni.filter((r) => Number(r.anno) === anno);
        const prestazioniAnno = [...new Map(righeAnno.map((r) => [r.prestazione, r])).values()].sort((a, b) =>
          String(codiceExportValue(a.codice_voce)).localeCompare(String(codiceExportValue(b.codice_voce)), "it", { numeric: true })
        );

        const sheetRows = clientiZAttivi.map((c) => {
          const annoDecorrenzaIstat = c.istat_decorrenza ? Number(String(c.istat_decorrenza).slice(0, 4)) : null;
          const istatAttivo = !!c.istat_applicato && annoDecorrenzaIstat != null && annoDecorrenzaIstat <= anno;
          const row = {
            Cliente: c.ragione_sociale || "",
            ISTAT: istatAttivo ? `Sì, da ${formatDateIt(c.istat_decorrenza)}` : "No",
          };
          prestazioniAnno.forEach((prest) => {
            const label = `${codiceExportValue(prest.codice_voce)} - ${prest.descrizione_voce || ""}`;
            // righeAnno e' ordinata dal backend con le duplicazioni piu' recenti
            // prima (s.id DESC): se lo stesso cliente/voce ha piu' variazioni
            // ISTAT nello stesso anno, prendiamo l'ultima applicata.
            const variazione = righeAnno.find(
              (r) => r.codice_univoco_azienda === c.codice_univoco && r.prestazione === prest.prestazione
            );
            // Solo la percentuale originale scelta dall'utente, mai una
            // ricavata da nuovo/precedente: quella sarebbe "sporcata"
            // dall'arrotondamento e non rispecchierebbe l'aumento richiesto.
            row[`${label} (%)`] = variazione?.percentuale_istat != null ? Number(variazione.percentuale_istat) : "";
            row[`${label} (nuovo valore)`] = variazione ? Number(variazione.importo_nuovo) : "";
          });
          return row;
        });

        const headers = ["Cliente", "ISTAT", ...prestazioniAnno.flatMap((prest) => {
          const label = `${codiceExportValue(prest.codice_voce)} - ${prest.descrizione_voce || ""}`;
          return [`${label} (%)`, `${label} (nuovo valore)`];
        })];
        const ws = XLSX.utils.json_to_sheet(sheetRows, { header: headers });
        formatIstatReportWorksheet(ws, headers);
        XLSX.utils.book_append_sheet(wb, ws, String(anno));
      }
      XLSX.writeFile(wb, `report_istat_zucchetti_${annoDa}-${annoA}.xlsx`, { cellStyles: true });
      closeIstatReport();
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore esportazione report ISTAT");
    } finally {
      setExportingIstatReport(false);
    }
  };

  // Export Excel sconti clienti (Voci listino): fogli Zucchetti, BPoint e
  // iiPay, con lo sconto risolto per il periodo anno/mese selezionato
  // nel filtro della pagina (stessa logica di trovaScontoAttivo/il box
  // Sconto in Listino Cliente). Stessa formattazione degli altri export
  // (header blu, autofilter, altezza header calcolata sul wrap).
  const exportScontiClienti = async () => {
    setExportingSconti(true);
    try {
      const res = await api.get("/billing/client-discounts");
      const rows = res.data || [];
      const meseRiferimento = anno && mese ? `${anno}-${String(mese).padStart(2, "0")}-01` : moment().format("YYYY-MM") + "-01";

      const attivoPerCliente = new Map();
      let globaleAttivo = null;
      rows.forEach((r) => {
        const attivo = r.data_inizio <= meseRiferimento && (!r.data_fine || r.data_fine >= meseRiferimento);
        if (!attivo) return;
        if (r.codice_univoco_azienda == null) globaleAttivo = r;
        else attivoPerCliente.set(r.codice_univoco_azienda, r);
      });

      const clientiOrdinati = (tipo) => [...clienti]
        .filter((c) => String(c.tipologia_fatturazione || "").toUpperCase() === tipo && !c.data_fine_elaborazioni)
        .sort((a, b) => String(a.ragione_sociale || "").localeCompare(String(b.ragione_sociale || ""), "it", { sensitivity: "base" }));

      const headersZ = ["Cliente", "Percentuale", "Dal", "Al", "Note"];
      const righeScontiCliente = (tipo) => clientiOrdinati(tipo).map((c) => {
        const r = attivoPerCliente.get(c.codice_univoco);
        return {
          Cliente: c.ragione_sociale || "",
          Percentuale: r ? Number(r.percentuale) : "",
          Dal: r ? formatMeseAnnoStr(r.data_inizio) : "",
          Al: r ? (r.data_fine ? formatMeseAnnoStr(r.data_fine) : "Indeterminato") : "",
          Note: r?.note || "",
        };
      });

      const rowsZ = righeScontiCliente("Z");
      const rowsB = righeScontiCliente("B");

      const headersI = ["Cliente", "Stato", "Percentuale", "Dal", "Al", "Note"];
      const rowsI = clientiOrdinati("I").map((c) => {
        const proprio = attivoPerCliente.get(c.codice_univoco);
        const sorgente = proprio || globaleAttivo || null;
        const stato = proprio
          ? (Number(proprio.percentuale) > 0 ? "Personalizzato" : "Escluso")
          : globaleAttivo
          ? "Default"
          : "Non applicato";
        return {
          Cliente: c.ragione_sociale || "",
          Stato: stato,
          Percentuale: sorgente ? Number(sorgente.percentuale) : "",
          Dal: sorgente ? formatMeseAnnoStr(sorgente.data_inizio) : "",
          Al: sorgente ? (sorgente.data_fine ? formatMeseAnnoStr(sorgente.data_fine) : "Indeterminato") : "",
          Note: sorgente?.note || "",
        };
      });

      const wb = XLSX.utils.book_new();
      // Colonne come "Cliente" hanno un header corto ma dati lunghi (ragioni
      // sociali): columnWidthForHeader guarda solo l'header, quindi qui la
      // larghezza tiene conto anche del contenuto piu' lungo di ogni colonna.
      const columnWidthForRows = (header, data, opts) => {
        const larghezzaDati = data.reduce((max, row) => Math.max(max, String(row[header] ?? "").length), 0);
        return Math.max(columnWidthForHeader(header, opts), Math.min(opts?.max ?? 34, larghezzaDati));
      };
      const buildSheet = (data, headers, nome) => {
        const ws = XLSX.utils.json_to_sheet(data, { header: headers });
        if (!data.length) XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });
        ws["!cols"] = headers.map((h) => ({ wch: columnWidthForRows(h, data, { min: 14, max: h === "Cliente" ? 48 : 34 }) }));
        applyExcelHeaderStyle(ws, headers);
        const percentualeCol = headers.indexOf("Percentuale");
        if (percentualeCol >= 0 && ws["!ref"]) {
          const range = XLSX.utils.decode_range(ws["!ref"]);
          for (let rowIndex = range.s.r + 1; rowIndex <= range.e.r; rowIndex += 1) {
            const cell = ws[XLSX.utils.encode_cell({ r: rowIndex, c: percentualeCol })];
            if (cell && cell.t === "n") cell.z = '0.00"%"';
          }
        }
        XLSX.utils.book_append_sheet(wb, ws, nome);
      };
      buildSheet(rowsZ, headersZ, "Zucchetti");
      buildSheet(rowsI, headersI, "iiPay");
      buildSheet(rowsB, headersZ, "BPoint");

      XLSX.writeFile(wb, `sconti_clienti_${moment().format("YYYYMMDD_HHmm")}.xlsx`, { cellStyles: true });
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore export sconti clienti");
    } finally {
      setExportingSconti(false);
    }
  };

  const loadExtra = useCallback(async () => {
    setLoadingExtra(true);
    try {
      const res = await api.get("/tipologia_listino_iipay/extra/listini");
      setExtraRows(res.data || []);
    } catch {
      setExtraRows([]);
      toast.error("Errore caricamento extra iiPay");
    } finally {
      setLoadingExtra(false);
    }
  }, []);

  const editExtra = async (row = null) => {
    if (!canManageExtra) return;
    const ask = (label, value = "") => window.prompt(label, value ?? "");
    const numero = ask("Numero", row?.numero || "");
    if (numero === null) return;
    const action = ask("Action", row?.action || ""); if (action === null) return;
    const documentRequired = ask("Document required", row?.document_required || ""); if (documentRequired === null) return;
    const millerWillProduce = ask("Miller will produce", row?.miller_will_produce || ""); if (millerWillProduce === null) return;
    const fees = ask("Fees", row?.fees || ""); if (fees === null) return;
    const gruppo = ask("Gruppo", row?.gruppo || ""); if (gruppo === null) return;
    const payload = { numero: numero === "" ? null : Number(numero), action, document_required: documentRequired,
      miller_will_produce: millerWillProduce, fees, gruppo, ordine: row?.ordine || Number(numero) || extraRows.length + 1 };
    try {
      if (row?.id) await api.put(`/tipologia_listino_iipay/extra/listini/${row.id}`, payload);
      else await api.post("/tipologia_listino_iipay/extra/listini", payload);
      await loadExtra();
      toast.success(row?.id ? "Voce extra modificata" : "Voce extra aggiunta");
    } catch (error) { toast.error(error.response?.data?.message || "Errore salvataggio voce extra"); }
  };

  const deleteExtra = async (row) => {
    if (!canManageExtra || !window.confirm(`Eliminare la voce extra ${row.numero || row.id}?`)) return;
    try {
      await api.delete(`/tipologia_listino_iipay/extra/listini/${row.id}`);
      await loadExtra();
      toast.success("Voce extra eliminata");
    } catch (error) { toast.error(error.response?.data?.message || "Errore eliminazione voce extra"); }
  };


  const exportBpointListino = async () => {
    const exportMonth = String(bpointDecorrenza || '').slice(0, 7);
    if (!/^\d{4}-\d{2}$/.test(exportMonth) || exportingBpointListino) return;
    setExportingBpointListino(true);
    try {
      const selectedDate = `${exportMonth}-01`;
      const [selected, initial, selectedCu, initialCu] = await Promise.all([
        api.get('/billing/bpoint-listino', { params: { data_decorrenza: selectedDate } }),
        api.get('/billing/bpoint-listino', { params: { data_decorrenza: '2026-01-01' } }),
        api.get('/billing/bpoint-listino/1421/fasce', { params: { data_decorrenza: selectedDate } }),
        api.get('/billing/bpoint-listino/1421/fasce', { params: { data_decorrenza: '2026-01-01' } }),
      ]);
      const headers = ['Codice', 'Voce', 'Tariffa', 'Da', 'A', 'Importo', 'Unità'];
      const wb = XLSX.utils.book_new();
      const appendSheet = (name, listino, cu) => {
        const ws = XLSX.utils.json_to_sheet(buildBpointExportRows(listino, cu), { header: headers });
        applyExcelHeaderStyle(ws, headers);
        ws['!cols'] = [{ wch: 10 }, { wch: 64 }, { wch: 28 }, { wch: 12 }, { wch: 12 }, { wch: 14 }, { wch: 18 }];
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let rowIndex = 1; rowIndex <= range.e.r; rowIndex += 1) {
          const amount = ws[XLSX.utils.encode_cell({ r: rowIndex, c: 5 })];
          if (amount?.t === 'n') amount.z = '#,##0.00';
        }
        ws['!autofilter'] = { ref: `A1:G${range.e.r + 1}` };
        ws['!freeze'] = { xSplit: 0, ySplit: 1 };
        XLSX.utils.book_append_sheet(wb, ws, name);
      };
      appendSheet(`Listino ${moment(selectedDate).format('MM-YYYY')}`, selected.data || {}, selectedCu.data || {});
      appendSheet('Listino iniziale 01-01-2026', initial.data || {}, initialCu.data || {});
      XLSX.writeFile(wb, `listino_bpoint_${exportMonth}.xlsx`, { cellStyles: true });
    } catch (error) { toast.error(error.response?.data?.message || 'Errore esportazione Fasce BPoint'); }
    finally { setExportingBpointListino(false); }
  };


  const openBpointClienteEdit = async (row) => {
    if (bpoint427Association?.associazione) {
      toast.info(`La tariffa 427 è ereditata da ${bpoint427Association.associazione.ragione_sociale}. Rimuovi prima il collegamento per modificarla.`);
      return;
    }
    try {
      const decorrenza = refDateIipay || moment().startOf('month').format('YYYY-MM-DD');
      const response = await api.get(`/billing/bpoint-listino/cliente/${clienteSel}/fasce`, { params: { data: decorrenza } });
      const tipo = Number(datiBpointCliente?.alfieri || 0) === 1 ? 'alfieri' : 'standard';
      setBpointClienteEdit({
        row,
        tipo,
        decorrenza,
        importoUnico: '',
        personalizzato: !!response.data?.personalizzato,
        fasce: (response.data?.fasce || []).filter((fascia) => fascia.tipo === tipo).map((fascia) => ({ ...fascia })),
        storico: response.data?.storico || [],
      });
    } catch (error) { toast.error(error.response?.data?.message || 'Errore caricamento prezzi cliente BPoint'); }
  };

  // Cambiando mese si riparte dai prezzi in vigore a quella decorrenza: così la
  // nuova versione non riporta indietro valori letti da un altro periodo.
  const changeBpointClienteDecorrenza = async (decorrenza) => {
    setBpointClienteEdit((prev) => (prev ? { ...prev, decorrenza } : prev));
    if (!decorrenza) return;
    try {
      const response = await api.get(`/billing/bpoint-listino/cliente/${clienteSel}/fasce`, { params: { data: decorrenza } });
      setBpointClienteEdit((prev) => (prev && prev.decorrenza === decorrenza ? {
        ...prev,
        personalizzato: !!response.data?.personalizzato,
        fasce: (response.data?.fasce || []).filter((fascia) => fascia.tipo === prev.tipo).map((fascia) => ({ ...fascia })),
        storico: response.data?.storico || [],
      } : prev));
    } catch (error) { toast.error(error.response?.data?.message || 'Errore caricamento prezzi cliente BPoint'); }
  };

  const saveBpointClienteEdit = async () => {
    if (!bpointClienteEdit?.decorrenza || savingBpointCliente) return;
    setSavingBpointCliente(true);
    try {
      const response = await api.post(`/billing/bpoint-listino/cliente/${clienteSel}/fasce`, {
        data_decorrenza: bpointClienteEdit.decorrenza,
        fasce: bpointClienteEdit.fasce,
      });
      const aggiornate = Number(response.data?.fasce_successive_aggiornate || 0);
      toast.success(aggiornate
        ? `Prezzi personalizzati BPoint salvati (aggiornate anche ${aggiornate} fasce delle versioni successive)`
        : 'Prezzi personalizzati BPoint salvati');
      setBpointClienteEdit(null);
      await loadListinoCliente(clienteSel);
    } catch (error) { toast.error(error.response?.data?.message || 'Errore salvataggio prezzi cliente BPoint'); }
    finally { setSavingBpointCliente(false); }
  };

  const openBpointClienteStorico = async () => {
    try {
      const decorrenza = refDateIipay || moment().startOf('month').format('YYYY-MM-DD');
      const response = await api.get(`/billing/bpoint-listino/cliente/${clienteSel}/fasce`, { params: { data: decorrenza } });
      const tipo = Number(datiBpointCliente?.alfieri || 0) === 1 ? 'alfieri' : 'standard';
      setBpointClienteStorico({
        tipo,
        // Le versioni senza differenze restano visibili: prevalgono comunque sul
        // listino generale dalla loro decorrenza e devono poter essere eliminate.
        versioni: (response.data?.storico || []).map((versione) => {
          const fasceTipo = (versione.fasce || []).filter((fascia) => fascia.tipo === tipo);
          return {
            ...versione,
            haFasceTipo: fasceTipo.length > 0,
            fasce: fasceTipo.filter((fascia) => Number(fascia.importo_unitario) !== Number(fascia.prezzo_originale)),
          };
        }).filter((versione) => versione.haFasceTipo),
      });
    } catch (error) { toast.error(error.response?.data?.message || 'Errore caricamento storico prezzi cliente BPoint'); }
  };

  const deleteBpointClienteStorico = async (versione) => {
    if (deletingBpointClienteStorico || !bpointClienteStorico) return;
    const decorrenza = String(versione.data_decorrenza || '').slice(0, 10);
    if (!window.confirm(`Eliminare la personalizzazione BPoint con decorrenza ${moment(decorrenza).format('MM/YYYY')}?`)) return;
    setDeletingBpointClienteStorico(true);
    try {
      await api.delete(`/billing/bpoint-listino/cliente/${clienteSel}/fasce/${decorrenza}`, {
        params: { tipo: bpointClienteStorico.tipo },
      });
      toast.success('Versione personalizzata eliminata');
      setBpointClienteStorico(null);
      await Promise.all([loadListinoCliente(clienteSel), openBpointClienteStorico()]);
    } catch (error) { toast.error(error.response?.data?.message || 'Errore eliminazione versione personalizzata BPoint'); }
    finally { setDeletingBpointClienteStorico(false); }
  };

  const openBpointClientiPersonalizzati = async () => {
    setBpointClientiPersonalizzati([]);
    setLoadingBpointClientiPersonalizzati(true);
    try {
      const response = await api.get('/billing/bpoint-listino/clienti-personalizzati');
      setBpointClientiPersonalizzati(response.data || []);
    } catch (error) {
      setBpointClientiPersonalizzati(null);
      toast.error(error.response?.data?.message || 'Errore caricamento personalizzazioni clienti BPoint');
    } finally { setLoadingBpointClientiPersonalizzati(false); }
  };

  const openBpointClientiTariffaEreditata = async () => {
    setBpointClientiTariffaEreditata([]);
    setLoadingBpointClientiTariffaEreditata(true);
    try {
      const response = await api.get('/billing/bpoint-listino/clienti-tariffa-ereditata');
      setBpointClientiTariffaEreditata(response.data || []);
    } catch (error) {
      setBpointClientiTariffaEreditata(null);
      toast.error(error.response?.data?.message || 'Errore caricamento tariffe BPoint ereditate');
    } finally { setLoadingBpointClientiTariffaEreditata(false); }
  };

  const loadVociListino = useCallback(async () => {
    setLoadingVoci(true);
    try {
      const res = await api.get("/prestazioni", {
        params: refDateIipay ? { refDate: refDateIipay } : {},
      });
      setVociListino(res.data || []);
    } catch {
      setVociListino([]);
      toast.error("Errore caricamento voci listino");
    } finally {
      setLoadingVoci(false);
    }
  }, [refDateIipay]);

  useEffect(() => { loadClienti(); }, [loadClienti]);
  useEffect(() => { if (isAdmin) loadDettagliListino(); }, [isAdmin, loadDettagliListino]);
  useEffect(() => { loadListiniIipay(); }, [loadListiniIipay]);
  useEffect(() => { if (view === "extra") loadExtra(); }, [view, loadExtra]);
  useEffect(() => { if (view === "voci") loadVociListino(); }, [view, loadVociListino]);
  useEffect(() => { if (view === "rate_card") loadTariffeIipay(IIPAY_LISTINO_BASE_ID); }, [view, loadTariffeIipay]);

  useEffect(() => {
    if (view === "cliente") {
      loadListinoCliente(clienteSel);
      if (cliente?.tipologia_fatturazione === "B") {
        loadDatiBpointCliente(clienteSel);
        loadBpoint427Association(clienteSel);
      } else {
        setDatiBpointCliente(null);
        setBpoint427Association(null);
      }
      if (cliente?.tipologia_fatturazione === "I") loadDatiIipay(clienteSel);
      else if (["Z", "B"].includes(cliente?.tipologia_fatturazione)) {
        setDatiIipay(null);
        setCedoliniIipayContext(null);
        setCedoliniIipayInput("");
        setTariffeClienteIipay([]);
        loadDatiZucchetti(clienteSel);
      }
      else {
        setDatiIipay(null);
        setCedoliniIipayContext(null);
        setCedoliniIipayInput("");
        setDatiZucchetti([]);
        setTariffeClienteIipay([]);
      }
    }
  }, [clienteSel, cliente?.tipologia_fatturazione, view, loadListinoCliente, loadDatiIipay, loadDatiBpointCliente, loadBpoint427Association, loadDatiZucchetti]);

  useEffect(() => {
    if (view === "cliente" && cliente?.tipologia_fatturazione === "I") {
      loadCedoliniIipayContext(clienteSel);
    }
  }, [clienteSel, cliente?.tipologia_fatturazione, view, loadCedoliniIipayContext]);

  useEffect(() => {
    if (view === "cliente" && isAdmin) {
      loadScontoCliente(clienteSel);
      if (cliente?.tipologia_fatturazione === "I") loadScontoGlobaleIIpay();
    } else {
      setScontoClienteRows([]);
      setScontoGlobaleIIpayRows([]);
    }
  }, [clienteSel, cliente?.tipologia_fatturazione, view, isAdmin, loadScontoCliente, loadScontoGlobaleIIpay]);

  const listinoClienteLabel = useMemo(() => {
    if (!cliente) return "";
    if (cliente.tipologia_fatturazione === "I") {
      return listiniIipay.find((l) => String(l.id) === String(datiIipay?.tipologia_listino_iipay))?.name || TIPOLOGIA_LABEL.I;
    }
    return TIPOLOGIA_LABEL[cliente.tipologia_fatturazione] || cliente.tipologia_fatturazione;
  }, [cliente, datiIipay?.tipologia_listino_iipay, listiniIipay]);

  const tipoListinoZucchettiLabel = useMemo(() => {
    if (cliente?.tipologia_fatturazione !== "Z") return "";
    if (cliente.tipo_listino_cliente) return cliente.tipo_listino_cliente;
    const hasForfait = datiZucchetti.some((d) => Number(d.tipologia_cliente) === 1);
    const hasListino = datiZucchetti.some((d) => Number(d.tipologia_cliente) === 0);
    if (hasForfait && hasListino) return "Ibrido";
    if (hasForfait) return "Forfait";
    if (hasListino) return "Listino";
    return "-";
  }, [cliente?.tipologia_fatturazione, cliente?.tipo_listino_cliente, datiZucchetti]);

  const tipoZucchettiValue = useMemo(() => {
    const override = String(cliente?.tipo_listino_cliente || "").trim().toLowerCase();
    if (["forfait", "listino", "ibrido"].includes(override)) return override;
    const hasForfait = datiZucchetti.some((d) => Number(d.tipologia_cliente) === 1);
    const hasListino = datiZucchetti.some((d) => Number(d.tipologia_cliente) === 0);
    if (hasForfait && hasListino) return "ibrido";
    if (hasForfait) return "forfait";
    return "listino";
  }, [cliente?.tipo_listino_cliente, datiZucchetti]);

  const periodicitaClienteLabel = useMemo(() => {
    if (!cliente) return "";
    if (cliente.tipologia_fatturazione === "I") {
      return PERIODICITA_LABEL[datiIipay?.periodicita] || datiIipay?.periodicita || "";
    }
    if (["Z", "B"].includes(cliente.tipologia_fatturazione)) {
      const periodicita = cliente.periodicita_fatturazione
        || (cliente.tipologia_fatturazione === "B" ? "trimestrale" : "mensile");
      return PERIODICITA_LABEL[periodicita] || periodicita;
    }
    return "";
  }, [cliente, datiIipay?.periodicita]);

  const periodicitaClienteValue = useMemo(() => {
    if (!cliente) return "mensile";
    if (cliente.tipologia_fatturazione === "I") return datiIipay?.periodicita || "mensile";
    return cliente.periodicita_fatturazione
      || (cliente.tipologia_fatturazione === "B" ? "trimestrale" : "mensile");
  }, [cliente, datiIipay?.periodicita]);

  const showListinoClientePersonalizzatoColumn = useMemo(
    () => {
      if (cliente?.tipologia_fatturazione === "Z") return false;
      return listinoCliente.some((row) => {
        if (cliente?.tipologia_fatturazione === "I" && !String(row.sezione_crm || "").includes("3")) return false;
        if (hideZero && isZeroListino(row)) return false;
        return Boolean(row.personalizzato || row.bpoint_427_personalizzato);
      });
    },
    [listinoCliente, cliente?.tipologia_fatturazione, hideZero]
  );

  const showTariffeClientePersonalizzatoColumn = useMemo(
    () => tariffeClienteIipayRows.some((row) => Boolean(row.is_override)),
    [tariffeClienteIipayRows]
  );

  const forfaitZucchettiBadges = useMemo(() => {
    const values = datiZucchetti
      .filter((row) => Number(row.tipologia_cliente) === 1)
      .map((row) => {
        const max = row.max_cedolini;
        return max !== null && max !== undefined && max !== ""
          ? `Forfait fino a ${max} ced.`
          : "Forfait";
      });
    return [...new Set(values)];
  }, [datiZucchetti]);

  const hasZucchettiListino = useMemo(
    () => datiZucchetti.some((row) => Number(row.tipologia_cliente) === 0),
    [datiZucchetti]
  );

  const getZucchettiTipoBadges = useCallback((row) => {
    if (cliente?.tipologia_fatturazione !== "Z") return [];
    const codice = codiceAgoVoce(row);
    const tariffaVoce = row.tariffa_fascia_voce;
    if (codice === "190" && tariffaVoce?.fasce?.length) {
      const quantita = Number(tariffaVoce.quantita || 0);
      const dettaglio = `${quantita} ${tariffaVoce.criterio}`;
      return tariffaVoce.fasce.map((item) => {
        const min = Number(item.min_quantita);
        const max = item.max_quantita == null ? null : Number(item.max_quantita);
        const applicata = quantita >= min && (max == null || quantita <= max);
        const intervallo = max == null ? `> ${min - 1}` : min === 0 ? `≤ ${max}` : `${min}-${max}`;
        return {
          label: `${intervallo}: ${fmt(item.importo_unitario)} €`,
          tone: applicata ? "fascia-active" : "fascia",
          title: `${dettaglio} · fascia applicata: ${intervallo}`,
        };
      });
    }
    const fascia = row.tariffa_fascia_cliente;
    if (["185", "189", "190", "194"].includes(codice) && fascia) {
      const soglia = Number(fascia.soglia);
      const cedolini = Number(fascia.cedolini_complessivi || 0);
      const finoApplicata = cedolini <= soglia;
      const dettaglio = `${cedolini} cedolini complessivi · fascia applicata: ${finoApplicata ? `fino a ${soglia}` : `oltre ${soglia}`}`;
      return [
        {
          label: `≤ ${soglia}: ${fmt(fascia.importo_fino_soglia)} €`,
          tone: finoApplicata ? "fascia-active" : "fascia",
          title: dettaglio,
        },
        {
          label: `> ${soglia}: ${fmt(fascia.importo_oltre_soglia)} €`,
          tone: !finoApplicata ? "fascia-active" : "fascia",
          title: dettaglio,
        },
      ];
    }
    if (["186", "187"].includes(codice)) {
      return forfaitZucchettiBadges.map((badge) => ({
        label: badge === "Forfait" ? "Forfait" : badge,
        tone: "forfait",
      }));
    }
    if (codice === "189" && hasZucchettiListino) {
      return [{ label: "Listino", tone: "listino" }];
    }
    if (isVoceDoppiaOpzione(row)) {
      const metodo = getMetodoClienteDoppiaOpzione(row);
      const label = metodo === 6
        ? "Tabella"
        : metodo === 4
          ? "Forfait"
          : "Fisso";
      return [
        { label, tone: metodo === 4 ? "forfait" : metodo === 6 ? "tabella" : "listino" },
        { label: "2 scelte", tone: "dual" },
      ];
    }
    if (isVoceForfait(row)) {
      return [{ label: "Forfait", tone: "forfait" }];
    }
    return [];
  }, [cliente?.tipologia_fatturazione, forfaitZucchettiBadges, hasZucchettiListino]);

  const getListinoClienteImportoValue = useCallback((row) => {
    const sezioneForfait = getForfaitSection(row, cliente);
    if (sezioneForfait) return `Sezione ${sezioneForfait}`;
    if (cliente?.tipologia_fatturazione === "B" && codiceAgoVoce(row) === "427") return "A fasce";
    if (cliente?.tipologia_fatturazione === "B" && codiceAgoVoce(row) === "456") return isAZero(row) ? "zero" : "Da tabella";
    if (cliente?.tipologia_fatturazione !== "Z") return getListinoUnitarioValue(row);
    const codice = codiceAgoVoce(row);
    if (codice === "190" && row.tariffa_fascia_voce?.fasce?.length) {
      return fmt(row.tariffa_fascia_voce.fasce[0].importo_unitario);
    }
    if (!["186", "187", "189"].includes(codice)) return getListinoUnitarioValue(row);

    const values = datiZucchetti
      .filter((config) => (
        codice === "189"
          ? Number(config.tipologia_cliente) === 0
          : Number(config.tipologia_cliente) === 1
      ))
      .map((config) => (codice === "186" ? config.importo_forfait : config.costo_extra))
      .filter((value) => value !== null && value !== undefined && value !== "")
      .map((value) => Number(value))
      .filter((value) => Number.isFinite(value));

    // La voce 186 e' a metodo "Libera" a livello di master, ma senza una
    // configurazione forfait dedicata (dati_parcellazione_zucchetti) per il
    // cliente deve figurare a zero, non "Libero".
    if (!values.length) return codice === "186" ? fmt(0) : getListinoUnitarioValue(row);
    return [...new Set(values.map((value) => fmt(value)))].join(" / ");
  }, [cliente, datiZucchetti]);

  // Stessa risoluzione di getListinoClienteImportoValue (186/187/189 dedicate
  // a dati_parcellazione_zucchetti, gia' filtrate per il mese selezionato),
  // ma per l'export: valore numerico vero (non stringa gia' formattata) cosi'
  // Excel puo' formattarlo/sommarlo come importo.
  const getListinoClienteExportValue = useCallback((row) => {
    if (cliente?.tipologia_fatturazione === "Z") {
      const codice = codiceAgoVoce(row);
      if (["186", "187", "189"].includes(codice)) {
        const values = datiZucchetti
          .filter((config) => (
            codice === "189"
              ? Number(config.tipologia_cliente) === 0
              : Number(config.tipologia_cliente) === 1
          ))
          .map((config) => (codice === "186" ? config.importo_forfait : config.costo_extra))
          .filter((value) => value !== null && value !== undefined && value !== "")
          .map((value) => Number(value))
          .filter((value) => Number.isFinite(value));
        if (values.length) {
          const distinct = [...new Set(values)];
          return distinct.length === 1 ? distinct[0] : distinct.map((value) => fmt(value)).join(" / ");
        }
        if (codice === "186") return 0;
      }
    }
    return getListinoExportValue(row);
  }, [cliente?.tipologia_fatturazione, datiZucchetti]);

  const listinoColumns = [
    {
      field: "codice",
      headerName: "Cod.",
      width: 82,
      valueGetter: (p) => codiceSortValue(p.row),
      renderCell: (p) => getCodiceAgoDisplay(p.row),
    },
    {
      field: "descrizione",
      headerName: "Prestazione",
      flex: 2,
      minWidth: 260,
      renderCell: (p) => {
        const aziendeAmmesseCount = Number(p.row.aziende_ammesse_count || 0);
        const sezioneForfait = getForfaitSection(p.row, cliente);
        return (
          <div className="flex h-full min-w-0 items-center gap-2">
            <span className="min-w-0 truncate">{p.value || ""}</span>
            {cliente?.tipologia_fatturazione !== "Z" && isVoceForfait(p.row) && <ForfaitBadge />}
            {sezioneForfait && (
              <span className="inline-flex shrink-0 whitespace-nowrap rounded border border-purple-200 bg-purple-50 px-1.5 py-0.5 text-[10px] font-semibold text-purple-700">
                Gestita in sez. {sezioneForfait}
              </span>
            )}
            {aziendeAmmesseCount > 0 && (
              <span className="inline-flex shrink-0 whitespace-nowrap rounded border border-amber-200 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700">
                Solo {aziendeAmmesseCount} aziende
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: "fascia_applicata",
      headerName: cliente?.tipologia_fatturazione === "Z" ? "Tipo" : "Fascia",
      width: cliente?.tipologia_fatturazione === "Z" ? 315 : 170,
      sortable: false,
      renderCell: (p) => {
        if (cliente?.tipologia_fatturazione === "Z") {
          const badges = getZucchettiTipoBadges(p.row);
          return (
            <div className="flex h-full w-full items-center gap-1 overflow-hidden">
              {badges.length ? (
                badges.map((badge) => (
                  <span
                    key={badge.label}
                    title={badge.title || badge.label}
                    className={`inline-flex shrink-0 justify-center whitespace-nowrap rounded border px-1.5 py-0.5 text-[10px] font-semibold ${
                      badge.tone === "listino"
                        ? "border-blue-200 bg-blue-50 text-blue-700"
                        : badge.tone === "fascia-active"
                          ? "border-amber-400 bg-amber-100 text-amber-900 ring-1 ring-amber-300"
                          : badge.tone === "fascia"
                            ? "border-amber-200 bg-amber-50 text-amber-700"
                        : badge.tone === "tabella"
                          ? "border-slate-200 bg-slate-50 text-slate-700"
                          : badge.tone === "dual"
                            ? "border-violet-200 bg-violet-50 text-violet-700"
                            : "border-emerald-200 bg-emerald-50 text-emerald-700"
                    }`}
                  >
                    {badge.label}
                  </span>
                ))
              ) : (
                <span className="text-xs text-gray-400">—</span>
              )}
            </div>
          );
        }
        const fasciaLabel = getListinoFasciaLabel(p.row);
        if (cliente?.tipologia_fatturazione === "B" && codiceAgoVoce(p.row) === "456") {
          const metodoRaw = String(p.row.bpoint_456_metodo_presenze || "").trim().toLowerCase();
          const metodo = metodoRaw.includes("paghe infinity") ? "Paghe Infinity" : /^manual(?:e|i)\b/.test(metodoRaw) ? "Manuale" : "Non applicabile";
          return <div className="flex h-full w-full items-center gap-1">
            <span className={`inline-flex justify-center whitespace-nowrap rounded border px-1.5 py-0.5 text-[10px] font-semibold ${metodo === "Non applicabile" ? "border-gray-200 bg-gray-50 text-gray-500" : "border-purple-200 bg-purple-50 text-purple-700"}`}>{metodo}</span>
            {isAZero(p.row) && <span className="rounded border border-amber-200 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700">Non addebitata</span>}
          </div>;
        }
        if (cliente?.tipologia_fatturazione === "B" && ["447", "461", "462"].includes(codiceAgoVoce(p.row))) {
          const code = codiceAgoVoce(p.row);
          const applicato = Number(code === "447" ? p.row.bpoint_447_applicato : code === "461" ? p.row.bpoint_461_applicato : p.row.bpoint_462_applicato) === 1;
          const nonAddebitato = isAZero(p.row);
          const label = nonAddebitato ? "Non addebitato" : applicato ? "Applicato" : "Non applicato";
          return (
            <div className="flex h-full w-full items-center">
              <span className={`inline-flex justify-center whitespace-nowrap rounded border px-1.5 py-0.5 text-[10px] font-semibold ${nonAddebitato ? "border-amber-200 bg-amber-50 text-amber-700" : applicato ? "border-emerald-200 bg-emerald-50 text-emerald-700" : "border-gray-200 bg-gray-50 text-gray-500"}`}>
                {label}
              </span>
            </div>
          );
        }
        return (
          <div className="flex h-full w-full items-center">
            {fasciaLabel ? (
              <span className="inline-flex w-32 justify-center whitespace-nowrap rounded border border-blue-200 bg-blue-50 px-1.5 py-0.5 text-[10px] font-semibold text-blue-700">
                A fascia {fasciaLabel}
              </span>
            ) : (
              <span className="text-xs text-gray-400">—</span>
            )}
          </div>
        );
      },
    },
    {
      field: "listino",
      headerName: "Importo",
      width: 120,
      align: "right",
      headerAlign: "right",
      valueGetter: (p) => getListinoClienteImportoValue(p.row),
      renderCell: (p) => (
        <div className="flex h-full w-full items-center justify-end pr-2 font-medium tabular-nums">
          {getListinoClienteImportoValue(p.row)}
        </div>
      ),
    },
    ...(showListinoClientePersonalizzatoColumn ? [{
      field: "personalizzato",
      headerName: "",
      width: 124,
      sortable: false,
      renderCell: (p) => (
        <div className="flex h-full w-full items-center">
          {Boolean(p.row.personalizzato || p.row.bpoint_427_personalizzato) && (
            <span className="inline-flex w-24 justify-center whitespace-nowrap rounded border border-amber-200 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700">
              Personalizzato
            </span>
          )}
        </div>
      ),
    }] : []),
    {
      field: "qta_obbligatoria",
      headerName: "Qtà",
      width: 70,
      align: "center",
      headerAlign: "center",
      valueGetter: (p) => requiresQuantita(p.row) ? "Sì" : "",
    },
    {
      field: "descrizione_obbligatoria",
      headerName: "Descr.",
      width: 82,
      align: "center",
      headerAlign: "center",
      valueGetter: (p) => requiresDescrizione(p.row) ? "Sì" : "",
    },
    { field: "sezione_crm", headerName: "Sez.", width: 72, align: "center", headerAlign: "center", valueFormatter: (p) => formatSezioneCrm(p.value) },
    ...(isAdmin ? [{
      field: "azioni",
      headerName: "Azioni",
      width: 170,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (p) => {
        const isBpoint427 = cliente?.tipologia_fatturazione === "B" && codiceAgoVoce(p.row) === "427";
        const storicoEnabled = isBpoint427 ? Boolean(p.row.bpoint_427_personalizzato) : hasStoricoPrezzi(p.row);
        const tariffa427Ereditata = isBpoint427 && Boolean(bpoint427Association?.associazione);
        const modificaInibita = isForfaitBloccato(p.row, cliente) || tariffa427Ereditata;
        const hasFasceZucchetti = !!(p.row.tariffa_fascia_cliente || p.row.tariffa_fascia_voce?.fasce?.length);
        return (
          <div className="flex gap-1.5">
            <button
              type="button"
              disabled={modificaInibita}
              title={tariffa427Ereditata
                ? `Tariffa ereditata da ${bpoint427Association.associazione.ragione_sociale}`
                : modificaInibita ? `Importo e configurazione si modificano dalla sezione ${getForfaitSection(p.row, cliente)}` : ""}
              onClick={(event) => {
                event.stopPropagation();
                if (modificaInibita) return;
                openEditListinoCliente(p.row);
              }}
              className={`rounded border px-2 py-1 text-xs font-semibold ${
                modificaInibita
                  ? "cursor-not-allowed border-gray-200 bg-gray-100 text-gray-400"
                  : "border-blue-200 bg-blue-50 text-blue-700 hover:bg-blue-100"
              }`}
            >
              {tariffa427Ereditata ? "Ereditata" : modificaInibita ? `Sez. ${getForfaitSection(p.row, cliente)}` : hasFasceZucchetti ? "Modifica fasce" : "Modifica"}
            </button>
            <button
              type="button"
              disabled={!storicoEnabled}
              onClick={(event) => {
                event.stopPropagation();
                if (!storicoEnabled) return;
                if (isBpoint427) {
                  openBpointClienteStorico();
                  return;
                }
                openStoricoPrezzi({
                  ...p.row,
                  descrizione_voce_crm: p.row.descrizione_voce_crm || p.row.descrizione,
                }, clienteSel);
              }}
              className={storicoButtonClass(storicoEnabled)}
            >
              Storico
            </button>
          </div>
        );
      },
    }] : []),
  ];

  const tariffaColumns = [
    {
      field: "prestazione",
      headerName: "Cod.",
      width: 82,
      valueGetter: (p) => getCodiceAgoDisplay(p.row),
      renderCell: (p) => p.value,
    },
    {
      field: "descrizione_prestazione",
      headerName: "Prestazione",
      flex: 2,
      minWidth: 260,
      renderCell: (p) => {
        const aziendeAmmesseCount = Number(p.row.aziende_ammesse_count || 0);
        return (
          <div className="flex h-full min-w-0 items-center gap-2">
            <span className="min-w-0 truncate">{p.value || ""}</span>
            {aziendeAmmesseCount > 0 && (
              <span className="inline-flex shrink-0 whitespace-nowrap rounded border border-amber-200 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700">
                Solo {aziendeAmmesseCount} aziende
              </span>
            )}
          </div>
        );
      },
    },
    {
      field: "fascia_applicata",
      headerName: "Fascia",
      width: 170,
      sortable: false,
      renderCell: (p) => (
        <div className="flex h-full w-full items-center">
          {isFasciaRow(p.row) ? (
            <span className="inline-flex w-32 justify-center whitespace-nowrap rounded border border-blue-200 bg-blue-50 px-1.5 py-0.5 text-[10px] font-semibold text-blue-700">
              A fascia {getFasciaLabel(p.row)}
            </span>
          ) : (
            <span className="text-xs text-gray-400">—</span>
          )}
        </div>
      ),
    },
    {
      field: "importo",
      headerName: "Importo",
      width: 120,
      align: "right",
      headerAlign: "right",
      renderCell: (p) => (
        <div className="flex h-full w-full items-center justify-end pr-2 font-medium tabular-nums">
          {fmt(p.value)}
        </div>
      ),
    },
    {
      field: "attiva_cliente",
      headerName: "Attiva",
      width: 82,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (p) => {
        const prestazione = Number(p.row.prestazione);
        if (![353, 354, 370, 420, 715].includes(prestazione)) return <span className="text-xs text-gray-300">—</span>;
        return (
          <input type="checkbox"
            checked={Boolean(vociPayrollIipay[prestazione])}
            disabled={!isAdmin || savingVociPayrollIipay}
            onChange={(e) => handleToggleVocePayrollIipay(prestazione, e.target.checked)}
            aria-label={`Attiva voce ${prestazione}`}
            className="h-4 w-4 rounded border-gray-300 text-emerald-600 disabled:opacity-40" />
        );
      },
    },
    ...(showTariffeClientePersonalizzatoColumn ? [{
      field: "personalizzato",
      headerName: "",
      width: 124,
      sortable: false,
      renderCell: (p) => (
        <div className="flex h-full w-full items-center">
          {Boolean(p.row.is_override) && (
            <span className="inline-flex w-24 justify-center whitespace-nowrap rounded border border-amber-200 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700">
              Personalizzato
            </span>
          )}
        </div>
      ),
    }] : []),
    {
      field: "qta_obbligatoria",
      headerName: "Qtà",
      width: 70,
      align: "center",
      headerAlign: "center",
      valueGetter: (p) => requiresQuantita(p.row) ? "Sì" : "",
    },
    {
      field: "descrizione_obbligatoria",
      headerName: "Descr.",
      width: 82,
      align: "center",
      headerAlign: "center",
      valueGetter: (p) => requiresDescrizione(p.row) ? "Sì" : "",
    },
    { field: "sezione_crm", headerName: "Sez.", width: 76, align: "center", headerAlign: "center", valueFormatter: (p) => formatSezioneCrm(p.value) },
    ...(isAdmin ? [{
      field: "azioni_cliente",
      headerName: "Azioni",
      width: 170,
      sortable: false,
      renderCell: (p) => {
        const storicoEnabled = hasStoricoPrezzi(p.row);
        return (
          <div className="flex gap-1.5">
            <button
              type="button"
              onClick={() => openEditTariffaCliente(p.row)}
              className="rounded border border-blue-200 bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-700 hover:bg-blue-100"
            >
              Modifica
            </button>
            <button
              type="button"
              disabled={!storicoEnabled}
              onClick={() => {
                if (!storicoEnabled) return;
                openStoricoTariffaCliente(p.row);
              }}
              className={storicoButtonClass(storicoEnabled)}
            >
              Storico
            </button>
          </div>
        );
      },
    }] : []),
  ];

  const rateCardColumns = [
    {
      field: "codice_visualizzato",
      headerName: "Cod.",
      width: 82,
      sortComparator: (v1, v2) => Number(v1) - Number(v2),
    },
    { field: "rate_card", headerName: "RATE CARD", width: 104, align: "center", headerAlign: "center" },
    { field: "sezione_crm", headerName: "Sez.", width: 76, align: "center", headerAlign: "center", valueFormatter: (p) => formatSezioneCrm(p.value) },
    { field: "descrizione_prestazione", headerName: "Prestazione", flex: 2, minWidth: 280 },
    { field: "importo_visualizzato", headerName: "Importo", width: 130, align: "right", headerAlign: "right" },
    {
      field: "tipo_importo",
      headerName: "Tipo",
      width: 92,
      align: "center",
      headerAlign: "center",
      renderCell: (p) =>
        p.value === "A fascia" ? (
          <span className="rounded px-2 py-0.5 text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-200">
            {p.value}
          </span>
        ) : null,
    },
  ];

  const vociZIstatOptions = useMemo(() => {
    return [...vociListino]
      .filter((row) => (
        String(row.tipologia_fatturazione || "").toUpperCase() === "Z"
        && Number(row.attivo) === 1
        // Libera (1/2) e Tabella (6/8): nessun prezzo fisso da aumentare.
        && ![1, 2, 6, 8].includes(Number(row.metodo_fatturazione))
      ))
      .sort((a, b) => codiceAgoSortValue(a).toString().localeCompare(codiceAgoSortValue(b).toString(), "it", { numeric: true }))
      .map((row) => ({
        id: `${row.tipologia_fatturazione}:${row.codice}`,
        codice: row.codice,
        tipologia: row.tipologia_fatturazione,
        name: `${row.tipologia_fatturazione} · ${getCodiceAgoDisplay(row)} - ${row.descrizione_voce_crm || row.descrizione_voce_ago || ""}`,
      }));
  }, [vociListino, getCodiceAgoDisplay]);

  const vociListinoRows = useMemo(() => {
    const q = vociSearch.trim().toLowerCase();
    return [...vociListino]
      .filter((row) => vociTipologia.size === 0 || vociTipologia.has(String(row.tipologia_fatturazione || "").toUpperCase()))
      // Le vecchie voci BPoint prive di sezione sono archiviate per mantenere
      // leggibili le fatture storiche, ma non fanno più parte del catalogo.
      .filter((row) => String(row.tipologia_fatturazione || "").toUpperCase() !== "B" || String(row.sezione_crm || "").trim() !== "")
      .filter((row) => {
        if (!q) return true;
        return [
          row.codice,
          row.nuovo_codice_ago,
          row.descrizione_voce_ago,
          row.descrizione_voce_crm,
          row.note,
        ].some((value) => String(value || "").toLowerCase().includes(q));
      })
      .sort((a, b) => {
        const sezDiff = getSezioneSortValue(a.sezione_crm) - getSezioneSortValue(b.sezione_crm);
        if (sezDiff !== 0) return sezDiff;
        return String(codiceAgoSortValue(a)).localeCompare(String(codiceAgoSortValue(b)), "it", {
          numeric: true,
          sensitivity: "base",
        });
      });
  }, [vociListino, vociSearch, vociTipologia]);

  const vociListinoColumns = [
    { field: "nuovo_codice_ago", headerName: "Codice AGO", width: 116, valueGetter: (p) => codiceAgoSortValue(p.row), renderCell: (p) => getCodiceAgoDisplay(p.row) },
    { field: "sezione_crm", headerName: "Sez.", width: 76, align: "center", headerAlign: "center", valueFormatter: (p) => formatSezioneCrm(p.value) },
    {
      field: "settore",
      headerName: "Settore",
      width: 110,
      align: "center",
      headerAlign: "center",
      valueFormatter: (p) => settoreLabelById.get(String(p.value)) || "",
    },
    {
      field: "descrizione_voce_ago",
      headerName: "Descrizione AGO",
      flex: 1.5,
      minWidth: 240,
      renderCell: (p) => (
        <div className="flex h-full min-w-0 items-center gap-2">
          <span className="min-w-0 truncate">{p.value || ""}</span>
          {isVoceForfait(p.row) && <ForfaitBadge />}
          {isVoceDoppiaOpzione(p.row) && <DualChoiceBadge />}
        </div>
      ),
    },
    { field: "descrizione_voce_crm", headerName: "Descrizione CRM", flex: 1.5, minWidth: 240 },
    { field: "note", headerName: "Note attuali", flex: 1, minWidth: 220 },
    {
      field: "richiesta",
      headerName: "Descr. obbl.",
      width: 116,
      align: "center",
      headerAlign: "center",
      valueGetter: (p) => String(p.row.richiesta || "").trim() ? "Sì" : "No",
    },
    {
      field: "importo_default",
      headerName: "Importo",
      width: 110,
      align: "right",
      headerAlign: "right",
      valueGetter: (p) => getVoceListinoImportoValue(p.row),
      renderCell: (p) => getVoceListinoImportoValue(p.row),
    },
    {
      field: "attivo",
      headerName: "Attiva",
      width: 82,
      align: "center",
      headerAlign: "center",
      valueGetter: (p) => Number(p.row.attivo) === 1 ? "Sì" : "No",
    },
    {
      field: "aziende_ammesse_count",
      headerName: "Aziende",
      width: 110,
      align: "center",
      headerAlign: "center",
      renderCell: (p) =>
        Number(p.row.aziende_ammesse_count) > 0 ? (
          <span className="rounded px-2 py-0.5 text-xs font-semibold bg-amber-50 text-amber-700 border border-amber-200">
            Solo {p.row.aziende_ammesse_count}
          </span>
        ) : Number(p.row.limitata_aziende) === 1 ? (
          <span className="text-xs text-amber-700">Nessuna</span>
        ) : (
          <span className="text-xs text-gray-400">Tutte</span>
        ),
    },
    ...(isAdmin ? [{
      field: "_azioni",
      headerName: "",
      width: 240,
      sortable: false,
      filterable: false,
      renderCell: (p) => {
        const storicoEnabled = hasStoricoPrezzi(p.row);
        return (
          <div className="flex gap-1">
            <button
              type="button"
              onClick={() => openEditVoce(p.row)}
              className="rounded border border-blue-200 bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-700 hover:bg-blue-100"
            >
              Modifica
            </button>
            <button
              type="button"
              disabled={!storicoEnabled}
              onClick={() => {
                if (!storicoEnabled) return;
                openStoricoPrezzi(p.row);
              }}
              className={storicoButtonClass(storicoEnabled)}
            >
              Storico
            </button>
            <button
              type="button"
              onClick={() => handleDeleteVoce(p.row)}
              className="rounded border border-red-200 bg-red-50 px-2 py-1 text-xs font-semibold text-red-700 hover:bg-red-100"
            >
              Elimina
            </button>
          </div>
        );
      },
    }] : []),
  ];

  const handleCloneListino = async () => {
    if (!cloneTargetCliente) {
      toast.warning("Seleziona il cliente destinazione");
      return;
    }
    if (cloneSourceType === "cliente" && !cloneSourceCliente) {
      toast.warning("Seleziona il cliente sorgente");
      return;
    }
    if (cloneSourceType === "cliente" && cloneSourceCliente === cloneTargetCliente) {
      toast.warning("Sorgente e destinazione devono essere diversi");
      return;
    }

    setCloningListino(true);
    try {
      const res = await api.post("/prestazione_azienda/listini/clone", {
        sourceType: cloneSourceType,
        sourceCliente: cloneSourceType === "cliente" ? cloneSourceCliente : null,
        targetCliente: cloneTargetCliente,
        tipologia: masterTipologia,
      });
      if (String(cloneTargetCliente) === String(clienteSel)) await loadListinoCliente(clienteSel);
      toast.success(`Listino clonato: ${res.data?.copied || 0} voci`);
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore clonazione listino");
    } finally {
      setCloningListino(false);
    }
  };

  const rowsCliente = useMemo(() => {
    const rows = hideZero ? listinoCliente.filter((row) => !isZeroListino(row)) : listinoCliente;
    return sortListinoRows(rows);
  }, [listinoCliente, hideZero]);

  const rowsClienteSezione3 = useMemo(
    () => sortListinoRows(rowsCliente.filter((row) => includesSezioneCrm(row.sezione_crm, "3"))),
    [rowsCliente]
  );

  const rowsClienteAltreSezioni = useMemo(
    () => sortListinoRows(rowsCliente.filter((row) => !isSoloSezione3(row.sezione_crm))),
    [rowsCliente]
  );

  // Stima quante righe occupera' un header con wrapText dato lo spazio
  // disponibile in colonna, per non tagliare la seconda riga di testo:
  // un'altezza fissa (pensata per header su 1 riga) troncherebbe quelli
  // piu' lunghi che vanno a capo su 2+ righe. Simula il word-wrap (a capo solo
  // sugli spazi, come Excel) invece di dividere semplicemente lunghezza/wch:
  // una divisione secca sottostima le righe perche' l'header e' in grassetto
  // (piu' largo del carattere "0" con cui e' calibrato "wch") e perche' le
  // parole non si spezzano a meta'.
  const BOLD_HEADER_WIDTH_FACTOR = 1.3;
  const estimateHeaderLines = (text, wch) => {
    const width = Math.max(1, (Number(wch) || 10) / BOLD_HEADER_WIDTH_FACTOR);
    const words = String(text || "").split(/\s+/).filter(Boolean);
    if (!words.length) return 1;
    let lines = 1;
    let lineLength = 0;
    words.forEach((word) => {
      if (lineLength === 0) {
        lineLength = word.length;
      } else if (lineLength + 1 + word.length <= width) {
        lineLength += 1 + word.length;
      } else {
        lines += 1;
        lineLength = word.length;
      }
    });
    return lines;
  };
  const estimateHeaderRowHeight = (headers, cols) => {
    const maxLines = headers.reduce((max, header, colIndex) => {
      const wch = cols?.[colIndex]?.wch;
      return Math.max(max, estimateHeaderLines(header, wch));
    }, 1);
    return 10 + maxLines * 14;
  };

  // Larghezza colonna che punta a un header su una sola riga (fino al
  // massimo consentito): usata al posto di larghezze fisse strette per gli
  // header lunghi (es. "<codice> - <descrizione voce> (nuovo valore)"), che
  // altrimenti andrebbero a capo su troppe righe indipendentemente
  // dall'altezza della riga.
  const columnWidthForHeader = (header, { min = 14, max = 34 } = {}) =>
    Math.min(max, Math.max(min, String(header || "").length));

  // Header blu standard (usato dai fogli senza formattazione dedicata):
  // stesso fill/font/allineamento delle altre esportazioni, altezza riga
  // calcolata per non tagliare gli header che vanno a capo su piu' righe.
  const applyExcelHeaderStyle = (ws, headers) => {
    if (!ws["!ref"]) return;
    const headerStyle = {
      fill: { patternType: "solid", fgColor: { rgb: "1D4ED8" } },
      font: { bold: true, color: { rgb: "FFFFFF" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex += 1) {
      const headerCell = ws[XLSX.utils.encode_cell({ r: range.s.r, c: colIndex })];
      if (headerCell) headerCell.s = headerStyle;
    }
    ws["!rows"] = [{ hpt: estimateHeaderRowHeight(headers, ws["!cols"]) }];
    ws["!autofilter"] = { ref: ws["!ref"] };
    if (!ws["!views"]) ws["!views"] = [{ state: "frozen", ySplit: 1 }];
  };

  const formatListinoClienteWorksheet = (ws, headers) => {
    if (!ws["!ref"]) return;
    const range = XLSX.utils.decode_range(ws["!ref"]);
    const listinoColIndex = headers.indexOf("Listino");
    const centeredHeaders = new Set(["Qta obbligatoria", "Descrizione obbligatoria", "Sezioni CRM"]);

    headers.forEach((header, colIndex) => {
      const cell = ws[XLSX.utils.encode_cell({ r: range.s.r, c: colIndex })];
      if (!cell) return;
      cell.s = {
        fill: { patternType: "solid", fgColor: { rgb: "1D4ED8" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "center", vertical: "center", wrapText: true },
      };
    });

    for (let rowIndex = range.s.r + 1; rowIndex <= range.e.r; rowIndex += 1) {
      headers.forEach((header, colIndex) => {
        const cell = ws[XLSX.utils.encode_cell({ r: rowIndex, c: colIndex })];
        if (!cell) return;
        if (colIndex === listinoColIndex) {
          if (cell.t === "n") cell.z = "€ #,##0.00";
          cell.s = { alignment: { horizontal: "right", vertical: "center" } };
        } else if (centeredHeaders.has(header)) {
          cell.s = { alignment: { horizontal: "center", vertical: "center" } };
        } else {
          cell.s = { alignment: { horizontal: "left", vertical: "center" } };
        }
      });
    }

    ws["!cols"] = headers.map((header) => {
      if (header === "Codice") return { wch: 10 };
      if (header === "Prestazione") return { wch: 48 };
      if (header === "Listino") return { wch: 14 };
      if (header === "Qta obbligatoria" || header === "Descrizione obbligatoria") return { wch: 16 };
      if (header === "Settore voce") return { wch: 20 };
      if (header === "Sezioni CRM") return { wch: 12 };
      return { wch: 16 };
    });
    ws["!rows"] = [{ hpt: estimateHeaderRowHeight(headers, ws["!cols"]) }];
    ws["!autofilter"] = { ref: ws["!ref"] };
    ws["!views"] = [{ state: "frozen", ySplit: 1 }];
  };

  const exportListinoCliente = () => {
    if (!cliente) return;
    const wb = XLSX.utils.book_new();
    const headers = ["Codice", "Prestazione", "Listino", "Qta obbligatoria", "Descrizione obbligatoria", "Settore voce", "Sezioni CRM"];

    SETTORI.forEach((settore) => {
      const settoreRows = sortListinoRows(rowsCliente.filter((r) => settoreMatches(r, settore.settoreId)));
      const sheetRows = settoreRows.map((row) => ({
        Codice: codiceExportValue(row?.nuovo_codice_ago || row?.codice),
        Prestazione: row.descrizione || "",
        Listino: getListinoClienteExportValue(row),
        "Qta obbligatoria": requiresQuantita(row) ? "SI" : "",
        "Descrizione obbligatoria": requiresDescrizione(row) ? "SI" : "",
        "Settore voce": row.settore_listino || "",
        "Sezioni CRM": row.sezione_crm || "",
      }));
      const ws = XLSX.utils.json_to_sheet(sheetRows, { header: headers });
      if (!sheetRows.length) XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });
      formatListinoClienteWorksheet(ws, headers);
      XLSX.utils.book_append_sheet(wb, ws, settore.name.slice(0, 31));
    });

    const safeName = String(cliente.ragione_sociale || "cliente")
      .replace(/[\\/:*?"<>|]+/g, "_")
      .replace(/\s+/g, "_")
      .slice(0, 80);
    XLSX.writeFile(wb, `listino_${safeName}.xlsx`, { cellStyles: true });
  };

  const formatListiniAttiviWorksheet = (ws, headers, restrictedHeaders = [], personalizedCells = [], inheritedCells = []) => {
    if (!ws["!ref"]) return;
    const alignLeft = (cell) => {
      if (!cell) return;
      cell.s = {
        ...(cell.s || {}),
        alignment: {
          ...(cell.s?.alignment || {}),
          horizontal: "left",
          vertical: "center",
        },
      };
    };
    const restrictedHeaderSet = new Set(restrictedHeaders);
    const restrictedColumnStyle = {
      fill: { patternType: "solid", fgColor: { rgb: "FFF3CD" } },
      border: {
        left: { style: "thin", color: { rgb: "E6B800" } },
        right: { style: "thin", color: { rgb: "E6B800" } },
      },
    };
    const restrictedHeaderStyle = {
      ...restrictedColumnStyle,
      font: { bold: true, color: { rgb: "7A5200" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };
    const personalizedCellStyle = {
      fill: { patternType: "solid", fgColor: { rgb: "FFE8A3" } },
      font: { bold: true, color: { rgb: "7A3E00" } },
      border: {
        top: { style: "thin", color: { rgb: "E6A700" } },
        bottom: { style: "thin", color: { rgb: "E6A700" } },
        left: { style: "thin", color: { rgb: "E6A700" } },
        right: { style: "thin", color: { rgb: "E6A700" } },
      },
    };
    const inheritedCellStyle = {
      fill: { patternType: "solid", fgColor: { rgb: "FCE7F3" } },
      font: { bold: true, color: { rgb: "9D174D" } },
      border: {
        top: { style: "thin", color: { rgb: "F9A8D4" } },
        bottom: { style: "thin", color: { rgb: "F9A8D4" } },
        left: { style: "thin", color: { rgb: "F9A8D4" } },
        right: { style: "thin", color: { rgb: "F9A8D4" } },
      },
    };
    const headerStyle = {
      fill: { patternType: "solid", fgColor: { rgb: "1D4ED8" } },
      font: { bold: true, color: { rgb: "FFFFFF" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };
    ws["!cols"] = headers.map((header, index) => {
      if (index === 0) return { wch: 16 };
      if (index === 1) return { wch: 18 };
      if (index === 2) return { wch: 42 };
      if (index === 3) return { wch: 14 };
      if (index === 4) return { wch: 18 };
      if (index === 5) return { wch: 22 };
      if (header === "186 - Forfait fino a") return { wch: columnWidthForHeader(header, { min: 18, max: 34 }) };
      if (String(header).endsWith(" - Fascia")) return { wch: columnWidthForHeader(header, { min: 16, max: 34 }) };
      return { wch: columnWidthForHeader(header) };
    });
    ws["!rows"] = [{ hpt: estimateHeaderRowHeight(headers, ws["!cols"]) }];
    ws["!autofilter"] = { ref: ws["!ref"] };
    ws["!views"] = [{ state: "frozen", xSplit: 6, ySplit: 1 }];

    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex += 1) {
      const header = headers[colIndex] || "";
      const headerCell = ws[XLSX.utils.encode_cell({ r: range.s.r, c: colIndex })];
      if (headerCell) headerCell.s = restrictedHeaderSet.has(header) ? restrictedHeaderStyle : headerStyle;
    }
    for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex += 1) {
      const header = headers[colIndex] || "";
      if (!restrictedHeaderSet.has(header)) continue;
      for (let rowIndex = range.s.r + 1; rowIndex <= range.e.r; rowIndex += 1) {
        const cell = ws[XLSX.utils.encode_cell({ r: rowIndex, c: colIndex })];
        if (cell) cell.s = restrictedColumnStyle;
      }
    }
    for (let rowIndex = range.s.r + 1; rowIndex <= range.e.r; rowIndex += 1) {
      for (let colIndex = 6; colIndex <= range.e.c; colIndex += 1) {
        const header = headers[colIndex] || "";
        if (header === "186 - Forfait fino a") continue;
        if (String(header).endsWith(" - Fascia")) continue;
        const cell = ws[XLSX.utils.encode_cell({ r: rowIndex, c: colIndex })];
        if (cell && cell.t === "n") cell.z = "€ #,##0.00";
      }
    }
    for (let rowIndex = range.s.r + 1; rowIndex <= range.e.r; rowIndex += 1) {
      for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex += 1) {
        alignLeft(ws[XLSX.utils.encode_cell({ r: rowIndex, c: colIndex })]);
      }
    }
    personalizedCells.forEach(({ row, header }) => {
      const colIndex = headers.indexOf(header);
      const rowIndex = Number(row);
      if (colIndex < 0 || !Number.isInteger(rowIndex) || rowIndex <= range.s.r || rowIndex > range.e.r) return;
      const cell = ws[XLSX.utils.encode_cell({ r: rowIndex, c: colIndex })];
      if (!cell) return;
      cell.s = {
        ...(cell.s || {}),
        ...personalizedCellStyle,
        alignment: {
          ...(cell.s?.alignment || {}),
          horizontal: "left",
          vertical: "center",
        },
      };
    });
    inheritedCells.forEach(({ row, header }) => {
      const colIndex = headers.indexOf(header);
      const rowIndex = Number(row);
      if (colIndex < 0 || !Number.isInteger(rowIndex) || rowIndex <= range.s.r || rowIndex > range.e.r) return;
      const cell = ws[XLSX.utils.encode_cell({ r: rowIndex, c: colIndex })];
      if (!cell) return;
      cell.s = {
        ...(cell.s || {}),
        ...inheritedCellStyle,
        alignment: {
          ...(cell.s?.alignment || {}),
          horizontal: "left",
          vertical: "center",
        },
      };
    });
  };

  const formatIstatReportWorksheet = (ws, headers) => {
    if (!ws["!ref"]) return;
    const headerStyle = {
      fill: { patternType: "solid", fgColor: { rgb: "1D4ED8" } },
      font: { bold: true, color: { rgb: "FFFFFF" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    ws["!cols"] = headers.map((header, index) => {
      if (index === 0) return { wch: 30 };
      if (index === 1) return { wch: 22 };
      if (String(header).endsWith(" (%)")) return { wch: columnWidthForHeader(header, { min: 14, max: 34 }) };
      if (String(header).endsWith(" (nuovo valore)")) return { wch: columnWidthForHeader(header, { min: 16, max: 34 }) };
      return { wch: columnWidthForHeader(header) };
    });
    ws["!rows"] = [{ hpt: estimateHeaderRowHeight(headers, ws["!cols"]) }];
    ws["!autofilter"] = { ref: ws["!ref"] };
    ws["!views"] = [{ state: "frozen", xSplit: 2, ySplit: 1 }];

    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex += 1) {
      const headerCell = ws[XLSX.utils.encode_cell({ r: range.s.r, c: colIndex })];
      if (headerCell) headerCell.s = headerStyle;
    }
    for (let rowIndex = range.s.r + 1; rowIndex <= range.e.r; rowIndex += 1) {
      for (let colIndex = range.s.c; colIndex <= range.e.c; colIndex += 1) {
        const header = headers[colIndex] || "";
        const cell = ws[XLSX.utils.encode_cell({ r: rowIndex, c: colIndex })];
        if (!cell) continue;
        if (header.endsWith(" (%)") && cell.t === "n") cell.z = '0.00"%"';
        else if (header.endsWith(" (nuovo valore)") && cell.t === "n") cell.z = "€ #,##0.00";
        cell.s = {
          alignment: {
            horizontal: colIndex <= 1 ? "left" : "center",
            vertical: "center",
          },
        };
      }
    }
  };

  const exportListiniClientiAttivi = async () => {
    setExportingListiniAttivi(true);
    try {
      const params = new URLSearchParams();
      if (anno) params.set("anno", anno);
      if (mese) params.set("mese", mese);
      const res = await api.get(`/prestazione_azienda/listini/export/clienti-attivi${params.toString() ? `?${params.toString()}` : ""}`);
      const wb = XLSX.utils.book_new();

      (res.data?.sheets || []).forEach((sheet) => {
        const headers = sheet.headers || [];
        const rows = sheet.rows || [];
        const ws = XLSX.utils.json_to_sheet(rows, { header: headers });
        if (!rows.length && headers.length) {
          XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });
        }
        formatListiniAttiviWorksheet(ws, headers, sheet.restrictedHeaders || [], sheet.personalizedCells || [], sheet.inheritedCells || []);
        XLSX.utils.book_append_sheet(wb, ws, String(sheet.name || "Listino").slice(0, 31));
      });

      if (!wb.SheetNames.length) {
        toast.warning("Nessun listino attivo da esportare");
        return;
      }

      XLSX.writeFile(wb, `listini_clienti_attivi_${moment().format("YYYYMMDD_HHmm")}.xlsx`, { cellStyles: true });
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore export listini clienti attivi");
    } finally {
      setExportingListiniAttivi(false);
    }
  };

  const exportReportVoce186 = async () => {
    const annoReport = Number(report186Anno);
    if (!Number.isInteger(annoReport) || annoReport < 2000 || annoReport > 2100) {
      toast.warning("Seleziona un anno valido");
      return;
    }
    setExportingReport186(true);
    try {
      const response = await api.get("/billing/cedolini-riepilogo/export-forfait-186", {
        params: { anno_da: annoReport, anno_a: annoReport },
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `report_voce_186_${annoReport}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setReport186Open(false);
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore export report voce 186");
    } finally {
      setExportingReport186(false);
    }
  };

  const exportRateCardIipay = () => {
    if (!tariffeIipay.length) {
      toast.warning("Nessuna tariffa da esportare");
      return;
    }

    const listino = listiniIipay.find((item) => String(item.id) === IIPAY_LISTINO_BASE_ID);
    const q = rateCardSearch.trim().toLowerCase();
    const fasciaColumns = fasceIipay.map((fascia) => ({
      ...fascia,
      header: `Fascia ${fascia.label}`,
    }));
    const groupedRows = new Map();

    tariffeIipay.forEach((row) => {
      const codice = normalizeCodiceListino(row.nuovo_codice_ago || row.prestazione);
      const searchText = `${codice} ${row.descrizione_prestazione || ""}`.toLowerCase();
      if (q && !searchText.includes(q)) return;

      const key = `${row.prestazione || ""}:${codice}`;
      if (!groupedRows.has(key)) {
        groupedRows.set(key, {
          base: {
            ...row,
            codice_visualizzato: codice,
          },
          fixed: null,
          byFascia: new Map(),
        });
      }

      const group = groupedRows.get(key);
      if (isFasciaRow(row)) group.byFascia.set(getFasciaKey(row), row);
      else group.fixed = row;
    });

    const sheetRows = Array.from(groupedRows.values())
      .sort((a, b) => compareTariffaRows(a.base, b.base))
      .map((group) => {
        const hasFascia = group.byFascia.size > 0;
        const fixedRow = group.fixed || group.base;
        const out = {
          Codice: codiceExportValue(group.base.codice_visualizzato),
          "RATE CARD": getRateCardFlagIipay(group.base.codice_visualizzato),
          "Sezioni CRM": formatSezioneCrm(group.base.sezione_crm),
          Prestazione: group.base.descrizione_prestazione || "",
          Tipo: hasFascia ? "A fascia" : "Fisso",
          "Importo fisso": group.fixed ? getListinoExportValue(group.fixed) : "",
          "Qta obbligatoria": requiresQuantita(fixedRow) ? "Sì" : "",
          "Descrizione obbligatoria": requiresDescrizione(fixedRow) ? "Sì" : "",
          Note: fixedRow.note || "",
        };

        fasciaColumns.forEach((fascia) => {
          out[fascia.header] = group.byFascia.has(fascia.key)
            ? getListinoExportValue(group.byFascia.get(fascia.key))
            : "";
        });

        return out;
      });

    if (!sheetRows.length) {
      toast.warning("Nessuna riga da esportare con i filtri correnti");
      return;
    }

    const headers = Object.keys(sheetRows[0]);
    const ws = XLSX.utils.json_to_sheet(sheetRows, { header: headers });
    const moneyColumns = [5, ...fasciaColumns.map((_, index) => 9 + index)];
    if (ws["!ref"]) {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let rowIndex = 1; rowIndex <= range.e.r; rowIndex += 1) {
        moneyColumns.forEach((colIndex) => {
          const cell = ws[XLSX.utils.encode_cell({ r: rowIndex, c: colIndex })];
          if (cell && cell.t === "n") cell.z = "#,##0.00";
        });
      }
    }
    ws["!cols"] = [
      { wch: 10 },
      { wch: 10 },
      { wch: 12 },
      { wch: 42 },
      { wch: 12 },
      { wch: 14 },
      { wch: 16 },
      { wch: 22 },
      { wch: 34 },
      ...fasciaColumns.map(() => ({ wch: 14 })),
    ];
    applyExcelHeaderStyle(ws, headers);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Rate card iiPay");
    const safeName = String(listino?.name || "iipay")
      .replace(/[\\/:*?"<>|]+/g, "_")
      .replace(/\s+/g, "_")
      .slice(0, 60);
    XLSX.writeFile(wb, `rate_card_iipay_${safeName}.xlsx`, { cellStyles: true });
  };

  const exportVariazioniClientiIipay = async () => {
    setExportingVariazioniIipay(true);
    try {
      const params = new URLSearchParams();
      if (rateCardSearch.trim()) params.set("search", rateCardSearch.trim());

      const res = await api.get(`/tipologia_listino_iipay/clienti/variazioni-prezzi${params.toString() ? `?${params.toString()}` : ""}`);
      const rows = Array.isArray(res.data) ? res.data : [];

      if (!rows.length) {
        toast.warning("Nessuna variazione cliente iiPay da esportare con i filtri correnti");
        return;
      }

      const sortedRows = [...rows].sort((a, b) => {
        const byCliente = String(a.cliente || "").localeCompare(String(b.cliente || ""), "it", {
          sensitivity: "base",
          numeric: true,
        });
        if (byCliente) return byCliente;
        const byCodice = String(a.codice_voce || "").localeCompare(String(b.codice_voce || ""), "it", {
          sensitivity: "base",
          numeric: true,
        });
        if (byCodice) return byCodice;
        return (a.min_fascia ?? -1) - (b.min_fascia ?? -1);
      });

      const baseRow = (row) => ({
        Cliente: row.cliente || "",
        "Competenza variazione": formatDateIt(row.data_decorrenza),
        "Codice voce": codiceExportValue(row.codice_voce),
        Descrizione: row.descrizione || "",
        "Prezzo originale": Number(row.prezzo_originale),
        "Prezzo modificato": Number(row.prezzo_modificato),
      });

      const rowsNoFasce = sortedRows
        .filter((row) => !isFasciaRow(row))
        .map(baseRow);
      const rowsFasce = sortedRows
        .filter(isFasciaRow)
        .map((row) => ({
          ...baseRow(row),
          Fascia: getFasciaLabel(row),
        }));

      const appendSheet = (wb, sheetName, data, headers) => {
        const ws = XLSX.utils.json_to_sheet(data, { header: headers });
        if (!data.length) XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });
        if (ws["!ref"]) {
          const range = XLSX.utils.decode_range(ws["!ref"]);
          const moneyColumns = headers
            .map((header, index) => (header.startsWith("Prezzo ") ? index : -1))
            .filter((index) => index >= 0);
          for (let rowIndex = 1; rowIndex <= range.e.r; rowIndex += 1) {
            moneyColumns.forEach((colIndex) => {
              const cell = ws[XLSX.utils.encode_cell({ r: rowIndex, c: colIndex })];
              if (cell && cell.t === "n") cell.z = "#,##0.00";
            });
          }
        }
        ws["!cols"] = headers.map((header) => {
          if (header === "Cliente") return { wch: 34 };
          if (header === "Competenza variazione") return { wch: 22 };
          if (header === "Descrizione") return { wch: 56 };
          if (header === "Fascia") return { wch: 14 };
          if (header.startsWith("Prezzo ")) return { wch: 18 };
          return { wch: 14 };
        });
        applyExcelHeaderStyle(ws, headers);
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
      };

      const wb = XLSX.utils.book_new();
      appendSheet(
        wb,
        "Prezzi a fasce",
        rowsFasce,
        ["Cliente", "Competenza variazione", "Codice voce", "Descrizione", "Fascia", "Prezzo originale", "Prezzo modificato"]
      );
      appendSheet(
        wb,
        "Prezzi non a fasce",
        rowsNoFasce,
        ["Cliente", "Competenza variazione", "Codice voce", "Descrizione", "Prezzo originale", "Prezzo modificato"]
      );

      XLSX.writeFile(wb, `variazioni_clienti_iipay_${moment().format("YYYYMMDD_HHmm")}.xlsx`, { cellStyles: true });
    } catch (err) {
      toast.error(err.response?.data?.message || "Errore export variazioni clienti iiPay");
    } finally {
      setExportingVariazioniIipay(false);
    }
  };

  const exportVociListino = () => {
    const tipologieExport = [
      { id: "I", sheetName: "iiPay" },
      { id: "Z", sheetName: "Zucchetti" },
      { id: "B", sheetName: "BPoint" },
    ];

    const rowsByTipologia = tipologieExport.map((tipologia) => {
      const rows = [...vociListino]
        .filter((row) => String(row.tipologia_fatturazione || "").toUpperCase() === tipologia.id)
        .filter((row) => !row.deleted_at)
        // Come nella pagina, le vecchie voci BPoint senza sezione sono archiviate.
        .filter((row) => tipologia.id !== "B" || String(row.sezione_crm ?? "").trim() !== "")
        .sort((a, b) => {
          const sezDiff = getSezioneSortValue(a.sezione_crm) - getSezioneSortValue(b.sezione_crm);
          if (sezDiff !== 0) return sezDiff;
          return String(codiceAgoSortValue(a)).localeCompare(String(codiceAgoSortValue(b)), "it", {
            numeric: true,
            sensitivity: "base",
          });
        });

      return { ...tipologia, rows };
    });

    if (!rowsByTipologia.some((group) => group.rows.length)) {
      toast.warning("Nessuna voce listino da esportare");
      return;
    }

    // Le voci iiPay a fascia hanno metodo_fatturazione "Tabella": in export va comunque
    // riportato "FASCIA", altrimenti risultano voci a tabella come nel listino a video.
    const getMetodoVoceExport = (row) => {
      if (String(row.tipologia_fatturazione || "").toUpperCase() === "I" && isVoceIipayAFascia(row)) {
        return "FASCIA";
      }
      return metodoLabelById.get(String(row.metodo_fatturazione)) || "";
    };

    const getImportoVoceExport = (row) => {
      if (String(row.tipologia_fatturazione || "").toUpperCase() === "I") {
        if (isVoceIipayAFascia(row)) return "A fascia";
        const metodo = Number(row.metodo_fatturazione);
        if (metodo === Number(metodoIipayIds.libera)) return "Libera";
        if (metodo === Number(metodoIipayIds.tabella)) return "Tabella";
        const value = row.iipay_importo_fisso ?? row.importo_default;
        return value === null || value === undefined || value === "" ? "" : Number(value);
      }

      const value = row.importo_default;
      return value === null || value === undefined || value === "" ? "" : Number(value);
    };

    const headers = [
      "Codice AGO",
      "Sezioni CRM",
      "Settore",
      "Appartenenza",
      "Metodo fatturazione",
      "Descrizione AGO",
      "Descrizione CRM",
      "Note attuali",
      "Importo",
      "Quantità obbligatoria",
      "Descrizione obbligatoria",
      "Richiesta descrizione",
      "Aziende associate",
      "Attiva",
      "Solo admin",
    ];

    const wb = XLSX.utils.book_new();

    rowsByTipologia.forEach((group) => {
      const data = group.rows.map((row) => ({
        "Codice AGO": codiceExportValue(codiceAgoSortValue(row)),
        "Sezioni CRM": formatSezioneCrm(row.sezione_crm),
        Settore: settoreLabelById.get(String(row.settore)) || "",
        Appartenenza: String(row.appartenenza) === "2" ? "Studio Albergoni" : "Miller",
        "Metodo fatturazione": getMetodoVoceExport(row),
        "Descrizione AGO": row.descrizione_voce_ago || "",
        "Descrizione CRM": row.descrizione_voce_crm || "",
        "Note attuali": row.note || "",
        Importo: getImportoVoceExport(row),
        "Quantità obbligatoria": requiresQuantita(row) ? "Sì" : "No",
        "Descrizione obbligatoria": requiresDescrizione(row) ? "Sì" : "No",
        "Richiesta descrizione": row.richiesta || "",
        "Aziende associate": Number(row.aziende_ammesse_count || 0) > 0 ? `Solo ${row.aziende_ammesse_count}` : Number(row.limitata_aziende) === 1 ? "Nessuna" : "Tutte",
        Attiva: Number(row.attivo) === 1 ? "Sì" : "No",
        "Solo admin": Number(row.solo_admin || 0) === 1 || Number(row.settore) === SETTORE_SOLO_ADMIN ? "Sì" : "No",
      }));

      const ws = XLSX.utils.json_to_sheet(data, { header: headers });
      if (!data.length) XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A1" });
      if (ws["!ref"]) {
        const range = XLSX.utils.decode_range(ws["!ref"]);
        for (let rowIndex = 1; rowIndex <= range.e.r; rowIndex += 1) {
          const importoCell = ws[XLSX.utils.encode_cell({ r: rowIndex, c: 8 })];
          if (importoCell && importoCell.t === "n") importoCell.z = "#,##0.00";
        }
      }
      ws["!cols"] = [
        { wch: 12 },
        { wch: 12 },
        { wch: 14 },
        { wch: 18 },
        { wch: 20 },
        { wch: 42 },
        { wch: 42 },
        { wch: 38 },
        { wch: 14 },
        { wch: 20 },
        { wch: 22 },
        { wch: 34 },
        { wch: 18 },
        { wch: 10 },
        { wch: 12 },
      ];
      applyExcelHeaderStyle(ws, headers);

      XLSX.utils.book_append_sheet(wb, ws, group.sheetName);
    });

    XLSX.writeFile(wb, `voci_listino_${moment().format("YYYYMMDD_HHmm")}.xlsx`, { cellStyles: true });
  };

  const renderListinoPerSettore = (rows, loading = false, options = {}) => {
    const { title = "", rowIdPrefix = "listino-cliente", showSettori = true } = options;
    const activeSettore = SETTORI.find((settore) => settore.id === settoreClienteTab) || SETTORI[0];
    const rowsBySettore = SETTORI.reduce((acc, settore) => {
      acc[settore.id] = sortListinoRows(rows.filter((r) => settoreMatches(r, settore.settoreId)));
      return acc;
    }, {});
    const activeRows = showSettori ? (rowsBySettore[activeSettore.id] || []) : sortListinoRows(rows);

    return (
      <div className="overflow-hidden rounded-md border border-gray-200 bg-white">
        {title && (
          <div className="border-b bg-gray-50 px-3 py-2 text-sm font-semibold text-gray-700">
            {title}
          </div>
        )}
        {showSettori && (
          <div className="flex flex-wrap items-center gap-2 px-3 py-2 border-b bg-gray-50">
            {SETTORI.map((settore) => (
              <button
                key={settore.id}
                type="button"
                onClick={() => setSettoreClienteTab(settore.id)}
                className={`px-3 py-1.5 rounded-md text-sm font-medium border transition-colors ${
                  settoreClienteTab === settore.id
                    ? "bg-blue-50 border-blue-300 text-blue-700"
                    : "bg-white border-gray-200 text-gray-600 hover:bg-gray-50"
                }`}
              >
                {settore.name}
                <span className="ml-2 text-xs text-gray-500">{rowsBySettore[settore.id]?.length || 0}</span>
              </button>
            ))}
          </div>
        )}
        <div>
          <DataGridPro
            key={`${rowIdPrefix}-${showSettori ? activeSettore.id : "all"}`}
            autoHeight
            density="compact"
            rows={activeRows}
            columns={listinoColumns}
            loading={loading}
            getRowId={(r) => `${rowIdPrefix}-${showSettori ? activeSettore.id : "all"}-${r.codice}`}
            getRowClassName={(params) => Number(params.row.aziende_ammesse_count || 0) > 0 ? "bg-amber-50" : ""}
            localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
            slots={{ toolbar: Toolbar, footer: ListiniGridFooter, loadingOverlay: LinearProgress }}
            initialState={{
              sorting: { sortModel: [{ field: "codice", sort: "asc" }] },
              ...(isAdmin ? { pinnedColumns: { right: ["azioni"] } } : {}),
            }}
            disableRowSelectionOnClick
          />
        </div>
      </div>
    );
  };

  const renderCliente = () => (
    <div className="flex flex-col gap-3">
      <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-3 items-end">
        <Autocomplete
          label="Cliente"
          placeholder="Cerca cliente..."
          value={clienteSel}
          onChange={(e) => handleClienteChange(e.target.value)}
          options={clienteOptions}
        />
        <div className="flex flex-wrap items-center justify-end gap-2 pb-2">
          {isAdmin && <button type="button" onClick={() => setNuovoClienteParcellazione({ ragione_sociale: "", codice_fiscale: "", tipologia_fatturazione: "Z", codice_parcellazione: "", data_fine_elaborazioni: "" })}
            className="rounded border border-blue-300 bg-blue-50 px-2.5 py-1 text-xs font-semibold text-blue-700 hover:bg-blue-100">
            Aggiungi cliente
          </button>}
          {TIPOLOGIE_CLIENTE.map((tipologia) => (
            <button
              key={tipologia.id}
              type="button"
              onClick={() => setTipologieClienteFiltro((prev) => { const next = new Set(prev); next.has(tipologia.id) ? next.delete(tipologia.id) : next.add(tipologia.id); return next; })}
              className={`px-2.5 py-0.5 rounded text-xs font-semibold border transition-colors ${
                tipologieClienteFiltro.has(tipologia.id)
                  ? `${TIPO_BADGE_CLASSES[tipologia.id]} ring-1 ${tipologia.id === "Z" ? "ring-blue-300 border-blue-400" : tipologia.id === "I" ? "ring-green-300 border-green-400" : "ring-purple-300 border-purple-400"}`
                  : "bg-white text-gray-500 border-gray-200 hover:bg-gray-50"
              }`}
            >
              {tipologia.id}
            </button>
          ))}
          {isAdmin && <button
            type="button"
            onClick={() => setTipologieClienteFiltro((prev) => { const next = new Set(prev); next.has("P") ? next.delete("P") : next.add("P"); return next; })}
            className={`px-2.5 py-0.5 rounded text-xs font-semibold border transition-colors ${
              tipologieClienteFiltro.has("P")
                ? "bg-amber-100 text-amber-800 border-amber-400 ring-1 ring-amber-300"
                : "bg-white text-gray-500 border-gray-200"
            }`}
            title="Solo Parcellazione"
          >P</button>}
          <label className="inline-flex items-center gap-1.5 px-2 py-1 rounded text-xs font-semibold border bg-white text-gray-600 border-gray-200">
            <input
              type="checkbox"
              checked={includeCessati}
              onChange={(e) => setIncludeCessati(e.target.checked)}
              className="h-3.5 w-3.5 rounded border-gray-300 text-blue-600"
            />
            Includi cessati
          </label>
          <button
            type="button"
            onClick={() => setHideZero((v) => !v)}
            className={`px-2.5 py-1 rounded text-xs font-semibold border transition-colors ${
              hideZero
                ? "bg-orange-50 text-orange-700 border-orange-300"
                : "bg-white text-gray-500 border-gray-200"
            }`}
          >
            {hideZero ? "Mostra zero" : "Nascondi zero"}
          </button>
          {Number(cliente?.solo_parcellazione || 0) !== 1 && <button
              type="button"
              onClick={exportListinoCliente}
              disabled={!cliente}
              className={EXPORT_BUTTON_CLASS}
            >
              Excel
            </button>}
          <button
            type="button"
            onClick={() => {
              setReport186Anno(anno || new Date().getFullYear());
              setReport186Open(true);
            }}
            disabled={exportingReport186}
            className={EXPORT_BUTTON_CLASS}
          >
            {exportingReport186 ? "Export..." : "Report 186"}
          </button>
          <button
            type="button"
            onClick={exportListiniClientiAttivi}
            disabled={exportingListiniAttivi}
            className={EXPORT_BUTTON_CLASS}
          >
            {exportingListiniAttivi ? "Export..." : "Excel tutti"}
          </button>
        </div>
      </div>
      {!cliente ? (
        <EmptyState text="Seleziona un cliente per visualizzare il listino diviso per settore." />
      ) : (
        <>
          <div className="flex flex-col gap-3">
            <div className="grid grid-cols-8 gap-2 text-sm">
              <Info label="Listino" value={listinoClienteLabel} />
              {cliente.tipologia_fatturazione === "Z" ? (
                <div className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
                  <div className="text-xs uppercase text-gray-500">Tipo</div>
                  <div className="truncate font-medium text-gray-800">{tipoListinoZucchettiLabel}</div>
                  {isAdmin && (
                    <button
                      type="button"
                      onClick={openEditTipoZucchetti}
                      className="mt-1 rounded border border-blue-200 bg-white px-1.5 py-0.5 text-xs font-semibold text-blue-700 hover:bg-blue-50"
                    >
                      Modifica
                    </button>
                  )}
                </div>
              ) : cliente.tipologia_fatturazione === "I" ? (
                <Info
                  label="Lingua"
                  value={datiIipay?.lingua_fattura || "EN"}
                />
              ) : cliente.tipologia_fatturazione === "B" ? (
                <div className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
                  <div className="text-xs uppercase text-gray-500">Tipo fasce BPoint</div>
                  <div className="truncate font-medium text-gray-800">
                    {!datiBpointCliente ? "Caricamento..." : Number(datiBpointCliente.alfieri || 0) === 1 ? "Alfieri" : "Standard"}
                  </div>
                  {isAdmin && (
                    <button
                      type="button"
                      disabled={!datiBpointCliente}
                      onClick={() => setBpointTipoEditOpen(true)}
                      className="mt-1 rounded border border-blue-200 bg-white px-1.5 py-0.5 text-xs font-semibold text-blue-700 hover:bg-blue-50 disabled:opacity-50"
                    >
                      Modifica
                    </button>
                  )}
                </div>
              ) : null}
              {cliente.tipologia_fatturazione === "B" && (
                <div className="rounded-md border border-purple-200 bg-purple-50 px-3 py-2">
                  <div className="text-xs uppercase text-purple-600">Tariffa BPoint 427</div>
                  <div className="truncate font-medium text-purple-950">
                    {bpoint427Association?.associazione
                      ? `Ereditata da ${bpoint427Association.associazione.ragione_sociale}`
                      : "Listino proprio"}
                  </div>
                  {isAdmin && (
                    <button
                      type="button"
                      disabled={!bpoint427Association}
                      onClick={openBpoint427Association}
                      className="mt-1 rounded border border-purple-200 bg-white px-1.5 py-0.5 text-xs font-semibold text-purple-700 hover:bg-purple-100 disabled:opacity-50"
                    >
                      Modifica
                    </button>
                  )}
                </div>
              )}
              {cliente.tipologia_fatturazione === "B" && (
                <div className={`rounded-md border px-3 py-2 ${bpoint427Association?.escludi_mensilita_aggiuntive_427 ? "border-rose-300 bg-rose-50" : "border-gray-200 bg-gray-50"}`}>
                  <div className={`text-xs uppercase ${bpoint427Association?.escludi_mensilita_aggiuntive_427 ? "text-rose-700" : "text-gray-500"}`}>Mensilità aggiuntive 427</div>
                  <label className="mt-1 inline-flex items-center gap-2 text-xs font-semibold text-gray-800">
                    <input type="checkbox"
                      checked={Boolean(bpoint427Association?.escludi_mensilita_aggiuntive_427)}
                      disabled={!isAdmin || !bpoint427Association || savingBpoint427AdditionalMonths}
                      onChange={(event) => saveBpoint427AdditionalMonthsExclusion(event.target.checked)}
                      className="h-4 w-4 rounded border-gray-300 text-rose-600" />
                    Non addebitare sulla voce 427
                  </label>
                </div>
              )}
              <div className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
                <div className="text-xs uppercase text-gray-500">Periodicita</div>
                <div className="truncate font-medium text-gray-800">{periodicitaClienteLabel || "-"}</div>
                {isAdmin && (
                  <button
                    type="button"
                    onClick={openEditPeriodicitaCliente}
                    className="mt-1 rounded border border-blue-200 bg-white px-1.5 py-0.5 text-xs font-semibold text-blue-700 hover:bg-blue-50"
                  >
                    Modifica
                  </button>
                )}
              </div>
              <Info label="Codice parcellazione cliente" value={String(cliente.codice_parcellazione ?? "").replace(/^0+(?=.)/, "")} />
              {Number(cliente.solo_parcellazione || 0) === 1 && <Info label="Partita IVA" value={String(cliente.codice_fiscale ?? "")} />}
              <Info label="Referente payroll" value={cliente.referente_payroll_nome || ""} />
              <Info label="Referente assunzioni" value={cliente.referente_assunzioni_nome || ""} />
              {isAdmin && Number(cliente.solo_parcellazione || 0) === 1 && <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2">
                <div className="text-xs uppercase text-amber-700">Cliente P</div>
                <button type="button" onClick={() => setNuovoClienteParcellazione({
                  codice_univoco: cliente.codice_univoco,
                  ragione_sociale: cliente.ragione_sociale || "",
                  codice_fiscale: cliente.codice_fiscale || "",
                  tipologia_fatturazione: cliente.tipologia_fatturazione,
                  codice_parcellazione: String(cliente.codice_parcellazione || ""),
                  data_fine_elaborazioni: cliente.data_fine_elaborazioni ? String(cliente.data_fine_elaborazioni).slice(0, 10) : "",
                })} className="mt-1 rounded border border-amber-300 bg-white px-2 py-0.5 text-xs font-semibold text-amber-800">Modifica cliente</button>
              </div>}
              {cliente.tipologia_fatturazione === "Z" && (
                <div className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
                  <div className="text-xs uppercase text-gray-500">ISTAT</div>
                  <div className="truncate font-medium text-gray-800">
                    {cliente.istat_applicato
                      ? `Da ${formatDateIt(cliente.istat_decorrenza)}`
                      : "Non applicato"}
                  </div>
                  {isAdmin && (
                    <button
                      type="button"
                      onClick={openEditIstatCliente}
                      className="mt-1 rounded border border-blue-200 bg-white px-1.5 py-0.5 text-xs font-semibold text-blue-700 hover:bg-blue-50"
                    >
                      Modifica
                    </button>
                  )}
                </div>
              )}
              <div className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
                <div className="text-xs uppercase text-gray-500">Sconto</div>
                <div className="truncate text-gray-800">
                  {cliente.tipologia_fatturazione === "I" ? (
                    scontoClienteAttivo ? (
                      Number(scontoClienteAttivo.percentuale) > 0
                        ? `Custom ${fmt(scontoClienteAttivo.percentuale)}%`
                        : "Escluso"
                    ) : scontoGlobaleIIpayAttivo ? (
                      `Default ${fmt(scontoGlobaleIIpayAttivo.percentuale)}%`
                    ) : (
                      "Non applicato"
                    )
                  ) : scontoClienteAttivo ? (
                    `${fmt(scontoClienteAttivo.percentuale)}% ${formatMeseAnnoStr(scontoClienteAttivo.data_inizio)}–${scontoClienteAttivo.data_fine ? formatMeseAnnoStr(scontoClienteAttivo.data_fine) : "indeterminato"}`
                  ) : (
                    "Non applicato"
                  )}
                </div>
                {isAdmin && (
                  <div className="mt-1 flex flex-wrap items-center gap-2">
                    {cliente.tipologia_fatturazione === "I" && !scontoClienteAttivo ? (
                      <>
                        <button
                          type="button"
                          onClick={openEditScontoClienteEscludi}
                          className="rounded border border-blue-200 bg-white px-1.5 py-0.5 text-xs font-semibold text-blue-700 hover:bg-blue-50"
                        >
                          Escludi
                        </button>
                        <button
                          type="button"
                          onClick={() => openEditScontoCliente(null)}
                          className="rounded border border-blue-200 bg-white px-1.5 py-0.5 text-xs font-semibold text-blue-700 hover:bg-blue-50"
                        >
                          Sconto diverso
                        </button>
                      </>
                    ) : (
                      <button
                        type="button"
                        onClick={() => openEditScontoCliente(scontoClienteAttivo)}
                        className="rounded border border-blue-200 bg-white px-1.5 py-0.5 text-xs font-semibold text-blue-700 hover:bg-blue-50"
                      >
                        {scontoClienteAttivo ? "Modifica" : "Applica"}
                      </button>
                    )}
                    {scontoClienteRows.length > 0 && (
                      <button
                        type="button"
                        onClick={openStoricoScontoCliente}
                        className="text-xs font-semibold text-gray-500 underline hover:text-gray-700"
                      >
                        Storico
                      </button>
                    )}
                  </div>
                )}
              </div>
              {cliente.note_fatturazione ? (
                <div className="col-span-8 flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50/60 px-3 py-2 text-sm">
                  <span className="shrink-0 text-xs font-semibold uppercase text-amber-800">Nota fatturazione</span>
                  <span className="min-w-0 flex-1 whitespace-pre-wrap text-gray-800">{cliente.note_fatturazione}</span>
                  {isAdmin && (
                    <button type="button" onClick={() => setNoteFatturazioneOpen(true)}
                      className="shrink-0 rounded border border-amber-300 bg-white px-2 py-0.5 text-xs font-semibold text-amber-800 hover:bg-amber-100">
                      Modifica
                    </button>
                  )}
                </div>
              ) : isAdmin ? (
                <div className="col-span-8">
                  <button type="button" onClick={() => setNoteFatturazioneOpen(true)}
                    className="rounded border border-amber-300 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-800 hover:bg-amber-100">
                    + Aggiungi nota
                  </button>
                </div>
              ) : null}
            </div>
            {cliente.tipologia_fatturazione === "I" && cedoliniIipayContext && (
              <div className="rounded-md border border-blue-200 bg-blue-50 px-3 py-2">
                <div className="grid grid-cols-1 items-center gap-3 md:grid-cols-[minmax(0,1fr)_auto]">
                  <div className="min-w-0 text-sm text-blue-950">
                    <div className="text-xs font-semibold uppercase text-blue-600">Cedolini rate card</div>
                    <div className="leading-5">
                      {cedoliniIipayContext.mese_considerato ? "Mese con dati considerato" : "Mese considerato"}:{" "}
                      <strong>
                        {formatMeseAnno(cedoliniIipayContext.mese_considerato || cedoliniIipayContext.mese_precedente)}
                      </strong>
                      {" · "}
                      {cedoliniIipayContext.cedolini_elaborati != null ? (
                        <>
                          Cedolini: <strong>{cedoliniIipayContext.cedolini_elaborati}</strong>
                          {Number(cedoliniIipayContext.cedolini_presunti) === 1 && " (presunti)"}
                        </>
                      ) : (
                        <strong>nessun mese con dati: applicata fascia minima</strong>
                      )}
                    </div>
                    {datiIipay?._fallback_listino_iipay && (
                      <div className="text-xs text-blue-700">
                        Configurazione listino iiPay cliente mancante: applicato listino iiPay base.
                      </div>
                    )}
                  </div>
                  {canEditCedoliniIipayContext && (
                    <div className="flex w-full items-end gap-2 md:w-auto">
                      <div className="w-24 md:w-28">
                        <Input
                          label="Presunti"
                          type="number"
                          value={cedoliniIipayInput}
                          onChange={(e) => setCedoliniIipayInput(e.target.value)}
                        />
                      </div>
                      <button
                        type="button"
                        onClick={handleSaveCedoliniIipay}
                        disabled={savingCedoliniIipay}
                        className="mb-0.5 h-9 rounded border border-blue-300 bg-white px-3 text-sm font-semibold text-blue-700 hover:bg-blue-50 disabled:opacity-40"
                      >
                        {savingCedoliniIipay ? "Salvo..." : "Salva"}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          {renderListinoPerSettore(rowsClienteSezione3, loadingCliente, {
            title: "Listino cliente - sezione 3",
            rowIdPrefix: "listino-cliente-sezione-3",
          })}
          {cliente.tipologia_fatturazione === "I" && (
            <div className="overflow-hidden rounded-md border border-gray-200 bg-white">
              <div className="px-3 py-2 border-b bg-gray-50 text-sm font-semibold text-gray-700">
                Rate card applicata al cliente
              </div>
              <div>
                <DataGridPro
                  autoHeight
                  density="compact"
                  rows={tariffeClienteIipayRows}
                  columns={tariffaColumns}
                  loading={loadingIipay}
                  getRowId={(r) => r.id}
                  getRowClassName={(params) => Number(params.row.aziende_ammesse_count || 0) > 0 ? "bg-amber-50" : ""}
                  localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
                  slots={{ toolbar: Toolbar, footer: ListiniGridFooter, loadingOverlay: LinearProgress }}
                  disableRowSelectionOnClick
                />
              </div>
            </div>
          )}
          {cliente.tipologia_fatturazione !== "I" && (
            renderListinoPerSettore(rowsClienteAltreSezioni, loadingCliente, {
              title: "Altre sezioni",
              rowIdPrefix: "listino-cliente-altre-sezioni",
              showSettori: false,
            })
          )}
        </>
      )}
      {nuovoClienteParcellazione && <div className="fixed inset-0 z-[350] flex items-center justify-center bg-slate-900/45 p-4">
        <form onSubmit={(event) => { event.preventDefault(); createClienteSoloParcellazione(); }}
          className="w-full max-w-md rounded-xl bg-white shadow-2xl" role="dialog" aria-modal="true">
          <div className="flex items-center justify-between border-b px-5 py-4">
            <div><h2 className="text-lg font-semibold text-slate-800">{nuovoClienteParcellazione.codice_univoco ? "Modifica cliente Parcellazione" : "Nuovo cliente Parcellazione"}</h2>
              <p className="text-xs text-slate-500">Visibile in Altri adempimenti soltanto agli ADMIN</p></div>
            <button type="button" onClick={() => setNuovoClienteParcellazione(null)} className="rounded p-1 text-2xl text-slate-400 hover:bg-slate-100">×</button>
          </div>
          <div className="space-y-4 p-5">
            <label className="block text-sm font-semibold text-slate-700">Ragione sociale *
              <input autoFocus required value={nuovoClienteParcellazione.ragione_sociale}
                onChange={(event) => setNuovoClienteParcellazione((current) => ({ ...current, ragione_sociale: event.target.value }))}
                className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 font-normal outline-none focus:border-blue-500" /></label>
            <label className="block text-sm font-semibold text-slate-700">Partita IVA
              <input type="text" value={String(nuovoClienteParcellazione.codice_fiscale ?? "")}
                onChange={(event) => setNuovoClienteParcellazione((current) => ({ ...current, codice_fiscale: event.target.value }))}
                className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 font-normal outline-none focus:border-blue-500" /></label>
            <label className="block text-sm font-semibold text-slate-700">Tipologia
              <select value={nuovoClienteParcellazione.tipologia_fatturazione}
                onChange={(event) => setNuovoClienteParcellazione((current) => ({ ...current, tipologia_fatturazione: event.target.value }))}
                className="mt-1 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 font-normal outline-none focus:border-blue-500">
                <option value="Z">Z — Zucchetti</option><option value="B">B — Bpoint</option>
              </select></label>
            <label className="block text-sm font-semibold text-slate-700">Codice parcellazione
              <input type="text" value={String(nuovoClienteParcellazione.codice_parcellazione ?? "")}
                onChange={(event) => setNuovoClienteParcellazione((current) => ({ ...current, codice_parcellazione: event.target.value }))}
                className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 font-normal outline-none focus:border-blue-500" /></label>
            <label className="block text-sm font-semibold text-slate-700">Data di cessazione
              <input type="date" value={nuovoClienteParcellazione.data_fine_elaborazioni}
                onChange={(event) => setNuovoClienteParcellazione((current) => ({ ...current, data_fine_elaborazioni: event.target.value }))}
                className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 font-normal outline-none focus:border-blue-500" /></label>
          </div>
          <div className="flex justify-end gap-2 border-t bg-slate-50 px-5 py-4">
            <button type="button" onClick={() => setNuovoClienteParcellazione(null)} className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700">Annulla</button>
            <button type="submit" disabled={savingNuovoClienteParcellazione || !nuovoClienteParcellazione.ragione_sociale.trim()}
              className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white disabled:opacity-50">
              {savingNuovoClienteParcellazione ? "Salvataggio..." : nuovoClienteParcellazione.codice_univoco ? "Salva modifiche" : "Crea cliente"}
            </button>
          </div>
        </form>
      </div>}
    </div>
  );

  const renderRateCard = () => (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1 pb-2">
        <span className="text-xs font-semibold text-gray-500 uppercase">Fascia cedolini</span>
        <div className="flex flex-wrap gap-1.5">
          {fasceIipay.map((fascia) => (
            <button
              key={fascia.key}
              type="button"
              onClick={() => setFasciaIipaySel(fascia.key)}
              className={`px-3 py-1.5 rounded-md text-sm font-medium border transition-colors ${
                fasciaIipaySel === fascia.key
                  ? "bg-blue-50 border-blue-300 text-blue-700"
                  : "bg-white border-gray-200 text-gray-600 hover:bg-gray-50"
              }`}
            >
              {fascia.label}
            </button>
          ))}
        </div>
      </div>
      <div className="text-xs text-gray-500">
        Le voci fisse sono visibili in ogni fascia. Il badge "A fascia" identifica gli importi soggetti a fascia cedolini.
      </div>
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="w-full md:w-96">
          <Input
            type="text"
            placeholder="Cerca codice o voce..."
            value={rateCardSearch}
            onChange={(e) => setRateCardSearch(e.target.value)}
            showClear
          />
        </div>
        <div className="flex items-center gap-2 pb-2">
          <div className="text-xs text-gray-500">
            {rateCardRows.length} voci visibili
          </div>
          <button
            type="button"
            onClick={exportRateCardIipay}
            disabled={!tariffeIipay.length}
            className={EXPORT_BUTTON_CLASS}
          >
            Excel
          </button>
        </div>
      </div>
      <div className="h-[62vh] border rounded-md overflow-hidden bg-white">
        <DataGridPro
          density="compact"
          rows={rateCardRows}
          columns={rateCardColumns}
          loading={loadingIipay}
          getRowId={(r) => r.id}
          localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
          slots={{ footer: ListiniGridFooter, loadingOverlay: LinearProgress }}
          disableRowSelectionOnClick
        />
      </div>
    </div>
  );

  const renderBpointListino = () => <div className="space-y-4">
      <div className="flex flex-wrap items-end justify-between gap-3 rounded-lg border border-purple-200 bg-purple-50 p-4">
        <div><h3 className="text-lg font-semibold text-purple-950">Fasce BPoint</h3></div>
        <div className="flex flex-wrap items-end justify-end gap-2">
          <button type="button" onClick={exportBpointListino} disabled={exportingBpointListino} className="h-10 rounded border border-green-300 bg-green-50 px-4 text-sm font-semibold text-green-800 hover:bg-green-100 disabled:opacity-50">{exportingBpointListino ? 'Esporto…' : 'Excel listino'}</button>
          <button type="button" onClick={openBpointClientiPersonalizzati} className="h-10 rounded border border-amber-300 bg-amber-50 px-4 text-sm font-semibold text-amber-800 hover:bg-amber-100">Personalizzazioni clienti</button>
          <button type="button" onClick={openBpointClientiTariffaEreditata} className="h-10 rounded border border-pink-300 bg-pink-50 px-4 text-sm font-semibold text-pink-800 hover:bg-pink-100">Tariffe ereditate</button>
        </div>
      </div>
      <BpointListinoEditor date={bpointDecorrenza} canEdit={isAdmin} />
    </div>;

  const renderExtra = () => (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="w-full md:w-96">
          <Input
            type="text"
            placeholder="Cerca extra..."
            value={extraSearch}
            onChange={(e) => setExtraSearch(e.target.value)}
            showClear
          />
        </div>
        <div className="flex items-center gap-2 pb-2">
          <span className="text-xs text-gray-500">{extraGroups.reduce((acc, group) => acc + group.rows.length, 0)} righe</span>
          {canManageExtra && <button type="button" onClick={() => editExtra()}
            className="rounded border border-blue-300 bg-blue-50 px-3 py-1.5 text-sm font-semibold text-blue-700 hover:bg-blue-100">
            Aggiungi voce
          </button>}
        </div>
      </div>
      <div className="h-[62vh] overflow-auto border rounded-md bg-white">
        {loadingExtra ? (
          <LinearProgress />
        ) : (
          <table className="min-w-full border-collapse text-sm">
            <thead className="sticky top-0 z-10 bg-sky-500 text-white">
              <tr>
                <th className="w-14 border-b border-sky-600 px-3 py-2 text-left font-semibold">#</th>
                <th className="min-w-[260px] border-b border-sky-600 px-3 py-2 text-left font-semibold">Action</th>
                <th className="min-w-[260px] border-b border-sky-600 px-3 py-2 text-left font-semibold">Document required</th>
                <th className="min-w-[220px] border-b border-sky-600 px-3 py-2 text-left font-semibold">Miller will produce</th>
                <th className="min-w-[220px] border-b border-sky-600 px-3 py-2 text-left font-semibold">Fees</th>
                <th className="min-w-[220px] border-b border-sky-600 px-3 py-2 text-left font-semibold">Gruppo</th>
                {canManageExtra && <th className="w-36 border-b border-sky-600 px-3 py-2 text-left font-semibold">Azioni</th>}
              </tr>
            </thead>
            <tbody>
              {extraGroups.map((group) =>
                group.rows.map((row, index) => (
                  <tr key={row.id} className="border-b border-gray-200 align-top">
                    <td className="px-3 py-2 font-medium text-gray-700">{row.numero}</td>
                    <td className="whitespace-pre-wrap px-3 py-2 text-gray-800">{row.action || "-"}</td>
                    <td className="whitespace-pre-wrap px-3 py-2 text-gray-700">{row.document_required || "-"}</td>
                    <td className="whitespace-pre-wrap px-3 py-2 text-gray-700">{row.miller_will_produce || "-"}</td>
                    {index === 0 && (
                      <>
                        <td
                          rowSpan={group.rows.length}
                          className="whitespace-pre-wrap border-l border-gray-200 bg-blue-50 px-3 py-2 font-semibold text-blue-900"
                        >
                          {group.fees || "-"}
                        </td>
                        <td
                          rowSpan={group.rows.length}
                          className="whitespace-pre-wrap border-l border-gray-200 bg-gray-50 px-3 py-2 font-medium text-gray-800"
                        >
                          {group.gruppo || "-"}
                        </td>
                      </>
                    )}
                    {canManageExtra && <td className="whitespace-nowrap px-3 py-2">
                      <button type="button" onClick={() => editExtra(row)} className="mr-1 rounded border border-blue-200 bg-blue-50 px-2 py-1 text-xs font-semibold text-blue-700">Modifica</button>
                      <button type="button" onClick={() => deleteExtra(row)} className="rounded border border-red-200 bg-red-50 px-2 py-1 text-xs font-semibold text-red-700">Elimina</button>
                    </td>}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );

  const renderVociListino = () => (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="flex flex-wrap items-end gap-2">
          <div className="flex flex-col gap-1 pb-2">
            <span className="text-xs font-semibold uppercase text-gray-500">Tipologia</span>
            <div className="flex gap-1.5">
              {TIPOLOGIE_CLIENTE.map((tipologia) => (
                <button
                  key={tipologia.id}
                  type="button"
                  onClick={() => handleVociTipologiaChange(tipologia.id)}
                  className={`px-2.5 py-0.5 rounded text-xs font-semibold border transition-colors ${
                    vociTipologia.has(tipologia.id)
                      ? `${TIPO_BADGE_CLASSES[tipologia.id]} ring-1 ${tipologia.id === "Z" ? "ring-blue-300 border-blue-400" : tipologia.id === "I" ? "ring-green-300 border-green-400" : "ring-purple-300 border-purple-400"}`
                      : "bg-white text-gray-500 border-gray-200 hover:bg-gray-50"
                  }`}
                >
                  {tipologia.id}
                </button>
              ))}
            </div>
          </div>
          <div className="w-full md:w-96">
            <Input
              type="text"
              placeholder="Cerca codice o descrizione..."
              value={vociSearch}
              onChange={(e) => setVociSearch(e.target.value)}
              showClear
            />
          </div>
        </div>
        <div className="flex items-center gap-2 pb-2 [&>button]:inline-flex [&>button]:h-9 [&>button]:items-center [&>button]:justify-center [&>button]:rounded-md [&>button]:px-3 [&>button]:py-0 [&>button]:text-sm [&>button]:font-semibold">
          <span className="text-xs text-gray-500">{vociListinoRows.length} voci</span>
          <button
            type="button"
            onClick={exportVociListino}
            disabled={loadingVoci || !vociListino.length}
            className={EXPORT_BUTTON_CLASS}
          >
            Excel
          </button>
          {isAdmin && vociTipologia.size === 1 && vociTipologia.has("I") && (
            <button
              type="button"
              onClick={openGestisciFasce}
              className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-semibold text-gray-700 hover:bg-gray-50"
            >
              Gestisci fasce
            </button>
          )}
          {isAdmin && vociTipologia.size === 1 && vociTipologia.has("B") && (
            <button
              type="button"
              onClick={() => handleViewChange('bpoint_listino')}
              className="rounded-md border border-purple-300 bg-purple-50 px-3 py-1.5 text-sm font-semibold text-purple-700 hover:bg-purple-100"
            >
              Gestisci fasce
            </button>
          )}
          {isAdmin && vociTipologia.size === 1 && vociTipologia.has("Z") && (
            <button
              type="button"
              onClick={openIstatApplica}
              className="rounded-md border border-orange-300 bg-orange-50 px-3 py-1.5 text-sm font-semibold text-orange-700 hover:bg-orange-100"
            >
              ISTAT
            </button>
          )}
          {isAdmin && vociTipologia.size === 1 && vociTipologia.has("Z") && (
            <button
              type="button"
              onClick={openIstatReport}
              className={EXPORT_BUTTON_CLASS}
            >
              Report ISTAT
            </button>
          )}
          {isAdmin && (
            <button
              type="button"
              onClick={exportScontiClienti}
              disabled={exportingSconti}
              className={EXPORT_BUTTON_CLASS}
            >
              {exportingSconti ? "Export..." : "Excel sconti"}
            </button>
          )}
          {isAdmin && (
            <button
              type="button"
              onClick={openNuovaVoce}
              className="rounded-md border border-blue-300 bg-blue-50 px-3 py-1.5 text-sm font-semibold text-blue-700 hover:bg-blue-100"
            >
              + Nuova voce
            </button>
          )}
        </div>
      </div>
      <div className="h-[68vh] rounded-md border bg-white">
        <DataGridPro
          density="compact"
          rows={vociListinoRows}
          columns={vociListinoColumns}
          loading={loadingVoci}
          getRowId={(r) => r.codice}
          localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
          slots={{ footer: ListiniGridFooter, loadingOverlay: LinearProgress }}
          initialState={{
            sorting: { sortModel: [{ field: "codice", sort: "asc" }] },
          }}
          disableRowSelectionOnClick
        />
      </div>
    </div>
  );

  const renderMaster = () => (
    <div className="flex flex-col gap-4">
      <div className="rounded-md border bg-gray-50 p-3">
        <span className="text-xs font-semibold uppercase text-gray-500">Tipologia</span>
        <div className="mt-1 flex gap-1.5">
          {TIPOLOGIE_CLIENTE.filter((tipologia) => tipologia.id !== "I").map((tipologia) => (
            <button
              key={tipologia.id}
              type="button"
              onClick={() => setMasterTipologia(tipologia.id)}
              className={`rounded-md border px-3 py-1.5 text-sm font-medium ${
                masterTipologia === tipologia.id
                  ? `border-transparent ${TIPO_BADGE_CLASSES[tipologia.id]}`
                  : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
              }`}
            >
              {tipologia.id}
            </button>
          ))}
        </div>
      </div>

      <div className="rounded-md border bg-white p-3">
        <div className="mb-2 text-sm font-semibold text-gray-700">Clona listino</div>
        <div className="grid grid-cols-1 items-end gap-3 md:grid-cols-[160px_1fr_1fr_auto]">
          <Select
            label="Sorgente"
            placeholder="Seleziona..."
            value={cloneSourceType}
            onChange={(e) => setCloneSourceType(e.target.value)}
            options={[
              { id: "master", name: "Master" },
              { id: "cliente", name: "Cliente" },
            ]}
          />
          <Autocomplete
            label="Cliente sorgente"
            placeholder="Cerca cliente..."
            value={cloneSourceCliente}
            onChange={(e) => setCloneSourceCliente(e.target.value)}
            options={clientiPerMaster}
            disabled={cloneSourceType !== "cliente"}
          />
          <Autocomplete
            label="Cliente destinazione"
            placeholder="Cerca cliente..."
            value={cloneTargetCliente}
            onChange={(e) => setCloneTargetCliente(e.target.value)}
            options={clientiPerMaster}
          />
          <button
            type="button"
            onClick={handleCloneListino}
            disabled={cloningListino}
            className="mb-2 rounded-md border border-green-300 bg-green-50 px-3 py-2 text-sm font-semibold text-green-700 hover:bg-green-100 disabled:opacity-40"
          >
            {cloningListino ? "Clono..." : "Clona"}
          </button>
        </div>
        <div className="mt-2 text-xs text-gray-500">
          La copia da Master o da cliente crea il listino azienda senza modificare i prezzi in questa fase.
        </div>
      </div>
    </div>
  );

  const renderNuovaVoceModal = () => {
    if (!nuovaVoceOpen) return null;

    return (
      <div className="fixed inset-0 z-[350] flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-6 w-full max-w-5xl rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">
              {editingVoceCodice ? "Modifica voce listino" : "Nuova voce listino"}
            </div>
            <button
              type="button"
              onClick={closeVoceModal}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="grid grid-cols-1 gap-3 p-4 md:grid-cols-4">
            <Input
              label="Codice AGO"
              type="text"
              value={nuovaVoce.nuovo_codice_ago}
              onChange={(e) => setNuovaVoceField("nuovo_codice_ago", e.target.value)}
            />
            <Select
              label="Tipologia"
              placeholder="Seleziona..."
              value={nuovaVoce.tipologia_fatturazione}
              onChange={(e) => {
                const value = e.target.value;
                setNuovaVoceField("tipologia_fatturazione", value);
                if (value === "I" && !fasceStandardIipay.length) loadFasceIipayContext(nuovaVoce.codice || null);
                if (value !== "I") setNuovaVoceField("iipay_a_fascia", false);
              }}
              options={dettagliOptions.tipologia_fatturazione}
            />
            <Select
              label="Settore"
              placeholder="Seleziona..."
              value={nuovaVoce.settore}
              onChange={(e) => setNuovaVoceField("settore", e.target.value)}
              options={dettagliOptions.settore}
            />

            <Select
              label="Appartenenza"
              placeholder="Seleziona..."
              value={nuovaVoce.appartenenza}
              onChange={(e) => setNuovaVoceField("appartenenza", e.target.value)}
              options={dettagliOptions.appartenenza}
            />
            {nuovaVoce.tipologia_fatturazione === "I" ? (
              <div>
                <label className="px-1 text-xs font-medium uppercase tracking-wider text-gray-500">Metodo fatturazione</label>
                <div className="flex flex-wrap gap-1 pt-1">
                  {[
                    { key: "libera", label: "Libera", id: metodoIipayIds.libera, fascia: false },
                    { key: "fisso", label: "Fisso", id: metodoIipayIds.fisso, fascia: false },
                    { key: "tabella", label: "Tabella", id: metodoIipayIds.tabella, fascia: false },
                    { key: "fascia", label: "Fascia", id: metodoIipayIds.tabella, fascia: true },
                  ].map((opt) => {
                    const active =
                      String(nuovaVoce.metodo_fatturazione) === String(opt.id) &&
                      !!nuovaVoce.iipay_a_fascia === opt.fascia;
                    return (
                      <button
                        key={opt.key}
                        type="button"
                        disabled={opt.id == null}
                        onClick={() => {
                          setNuovaVoceField("metodo_fatturazione", opt.id);
                          setNuovaVoceField("iipay_a_fascia", opt.fascia);
                          if (opt.fascia && !fasceStandardIipay.length) {
                            loadFasceIipayContext(nuovaVoce.codice || null);
                          }
                        }}
                        className={`px-2.5 py-1.5 rounded text-xs font-semibold border transition-colors disabled:opacity-40 ${
                          active
                            ? "bg-blue-50 border-blue-300 text-blue-700"
                            : "bg-white border-gray-200 text-gray-600 hover:border-gray-300"
                        }`}
                      >
                        {opt.label}
                      </button>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div>
                <label className="px-1 text-xs font-medium uppercase tracking-wider text-gray-500">Metodo fatturazione</label>
                <div className="flex flex-wrap gap-1 pt-1">
                  {metodoStandardOptions.map((opt) => {
                    const active = String(nuovaVoce.metodo_fatturazione) === String(opt.id);
                    return (
                      <button
                        key={opt.key}
                        type="button"
                        disabled={opt.id == null}
                        onClick={() => {
                          setNuovaVoceField("metodo_fatturazione", opt.id);
                          setNuovaVoceField("iipay_a_fascia", false);
                        }}
                        className={`px-2.5 py-1.5 rounded text-xs font-semibold border transition-colors disabled:opacity-40 ${
                          active
                            ? "bg-blue-50 border-blue-300 text-blue-700"
                            : "bg-white border-gray-200 text-gray-600 hover:border-gray-300"
                        }`}
                      >
                        {opt.label}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
            <Input
              label="Sezione CRM"
              type="text"
              placeholder="3 oppure 3//6"
              value={nuovaVoce.sezione_crm}
              onChange={(e) => setNuovaVoceField("sezione_crm", e.target.value)}
            />
            {!(nuovaVoce.tipologia_fatturazione === "I" && nuovaVoce.iipay_a_fascia) && (
              <Input
                label="Importo default"
                type="text"
                placeholder="0,00"
                value={nuovaVoce.importo_default}
                onChange={(e) => setNuovaVoceField("importo_default", e.target.value)}
                inputMode="decimal"
              />
            )}
            {(() => {
              const isIipayRateCard =
                nuovaVoce.tipologia_fatturazione === "I" &&
                (Number(nuovaVoce.metodo_fatturazione) === metodoIipayIds.fisso || nuovaVoce.iipay_a_fascia);
              return (
                <div>
                  <Input
                    label="Decorrenza prezzo (mese)"
                    type="month"
                    value={nuovaVoce.prezzo_decorrenza ? nuovaVoce.prezzo_decorrenza.slice(0, 7) : ""}
                    onChange={(e) => setNuovaVoceField("prezzo_decorrenza", e.target.value ? `${e.target.value}-01` : "")}
                  />
                  {isIipayRateCard && !nuovaVoce.tutte_aziende && (
                    <div className="px-1 pt-1 text-xs text-amber-600">
                      Voce riservata a "solo alcune aziende": la decorrenza vale solo per il cliente/i a cui è
                      associata questa voce, il prezzo non viene salvato in rate card (condivisa da tutte le
                      aziende del listino).
                    </div>
                  )}
                </div>
              );
            })()}

            <div className="md:col-span-2">
              <Input
                label="Descrizione AGO"
                type="text"
                value={nuovaVoce.descrizione_voce_ago}
                onChange={(e) => setNuovaVoceField("descrizione_voce_ago", e.target.value)}
              />
            </div>
            <div className="md:col-span-2">
              <Input
                label="Descrizione CRM"
                type="text"
                value={nuovaVoce.descrizione_voce_crm}
                onChange={(e) => setNuovaVoceField("descrizione_voce_crm", e.target.value)}
              />
            </div>

            {isIntegrazioneSalariale(nuovaVoce) && (
              <div className={`md:col-span-4 rounded-md border p-3 ${isZucchetti1237(nuovaVoce) ? "border-blue-200 bg-blue-50/50" : "border-purple-200 bg-purple-50/50"}`}>
                <div className="mb-3">
                  <div className={`text-sm font-semibold ${isZucchetti1237(nuovaVoce) ? "text-blue-900" : "text-purple-900"}`}>Parametri calcolo {isZucchetti1237(nuovaVoce) ? 'Zucchetti 1237' : 'BPoint 1427'}</div>
                  <div className={`text-xs ${isZucchetti1237(nuovaVoce) ? "text-blue-700" : "text-purple-700"}`}>Valori generali applicati a tutti i clienti.</div>
                </div>
                <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                  <Input label="Quota base CIGO (€)" type="number" value={nuovaVoce.cigo_quota_base}
                    onChange={(e) => setNuovaVoceField("cigo_quota_base", e.target.value)} />
                  <Input label="Quota base CIGO Maltempo (€)" type="number" value={nuovaVoce.cigo_maltempo_quota_base}
                    onChange={(e) => setNuovaVoceField("cigo_maltempo_quota_base", e.target.value)} />
                  <Input label="Quota per dipendente/settimana (€)" type="number" value={nuovaVoce.quota_variabile}
                    onChange={(e) => setNuovaVoceField("quota_variabile", e.target.value)} />
                  <Input label="Coefficiente FSBA (€)" type="number" value={nuovaVoce.fsba_coefficiente}
                    onChange={(e) => setNuovaVoceField("fsba_coefficiente", e.target.value)} />
                  <Input label="Minimo FSBA (€)" type="number" value={nuovaVoce.fsba_minimo}
                    onChange={(e) => setNuovaVoceField("fsba_minimo", e.target.value)} />
                  <Input label="Tetto massimo (€)" type="number" value={nuovaVoce.tetto_massimo}
                    onChange={(e) => setNuovaVoceField("tetto_massimo", e.target.value)} />
                </div>
              </div>
            )}

            {isBpoint1439(nuovaVoce) && (
              <div className="md:col-span-4 rounded-md border border-purple-200 bg-purple-50/50 p-3">
                <div className="mb-3">
                  <div className="text-sm font-semibold text-purple-900">Parametri calcolo BPoint 1439</div>
                  <div className="text-xs text-purple-700">Valori generali applicati a tutti i clienti. Nessun tetto massimo.</div>
                </div>
                <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                  <Input label="Fino a 5.000 €" type="number" value={nuovaVoce.quota_fino_5000} onChange={(e) => setNuovaVoceField("quota_fino_5000", e.target.value)} />
                  <Input label="Da 5.001 a 10.000 €" type="number" value={nuovaVoce.quota_5001_10000} onChange={(e) => setNuovaVoceField("quota_5001_10000", e.target.value)} />
                  <Input label="Da 10.001 a 50.000 €" type="number" value={nuovaVoce.quota_10001_50000} onChange={(e) => setNuovaVoceField("quota_10001_50000", e.target.value)} />
                  <Input label="Oltre 50.000 €" type="number" value={nuovaVoce.quota_oltre_50000} onChange={(e) => setNuovaVoceField("quota_oltre_50000", e.target.value)} />
                  <Input label="Ogni domanda aggiuntiva (€)" type="number" value={nuovaVoce.quota_domanda_aggiuntiva} onChange={(e) => setNuovaVoceField("quota_domanda_aggiuntiva", e.target.value)} />
                  <Input label="Importo minimo (€)" type="number" value={nuovaVoce.importo_minimo} onChange={(e) => setNuovaVoceField("importo_minimo", e.target.value)} />
                </div>
              </div>
            )}

            {isBpoint442(nuovaVoce) && (
              <div className="md:col-span-4 rounded-md border border-purple-200 bg-purple-50/50 p-3">
                <div className="mb-3">
                  <div className="text-sm font-semibold text-purple-900">Parametri calcolo BPoint 442</div>
                  <div className="text-xs text-purple-700">Addebito trimestrale solo in presenza di cedolini edili.</div>
                </div>
                <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                  <Input label="Quota base trimestrale (€)" type="number" value={nuovaVoce.quota_base_trimestrale}
                    onChange={(e) => setNuovaVoceField('quota_base_trimestrale', e.target.value)} />
                  <Input label="Quota per cedolino edile (€)" type="number" value={nuovaVoce.quota_per_cedolino_edile}
                    onChange={(e) => setNuovaVoceField('quota_per_cedolino_edile', e.target.value)} />
                </div>
              </div>
            )}

            {isBpoint446(nuovaVoce) && (
              <div className="md:col-span-4 rounded-md border border-purple-200 bg-purple-50/50 p-3">
                <div className="mb-3">
                  <div className="text-sm font-semibold text-purple-900">Parametri calcolo BPoint 446</div>
                  <div className="text-xs text-purple-700">Addebito trimestrale solo in presenza di cedolini dirigenti.</div>
                </div>
                <Input label="Quota per cedolino dirigente (€)" type="number" value={nuovaVoce.quota_per_cedolino_dirigente}
                  onChange={(e) => setNuovaVoceField('quota_per_cedolino_dirigente', e.target.value)} />
              </div>
            )}

            <div className="md:col-span-2">
              <label className="px-1 text-xs font-medium uppercase tracking-wider text-gray-500">Note attuali</label>
              <textarea
                value={nuovaVoce.note}
                onChange={(e) => setNuovaVoceField("note", e.target.value)}
                className="h-24 w-full rounded-md border border-gray-300 p-2 focus:outline-success-200"
              />
            </div>
            <div className="md:col-span-2">
              <div className="mb-1 flex items-center justify-between gap-2 px-1">
                <label className="text-xs font-medium uppercase tracking-wider text-gray-500">Richiesta descrizione</label>
                <label className="inline-flex items-center gap-1.5 text-xs font-semibold text-gray-700">
                  <input
                    type="checkbox"
                    checked={isIntegrazioneSalariale(nuovaVoce) || !!nuovaVoce.descrizione_obbligatoria}
                    onChange={(e) => setDescrizioneObbligatoria(e.target.checked)}
                    disabled={isIntegrazioneSalariale(nuovaVoce)}
                    className="h-3.5 w-3.5 rounded border-gray-300 text-blue-600"
                  />
                  Descrizione obbligatoria
                </label>
              </div>
              <textarea
                value={nuovaVoce.richiesta}
                onChange={(e) => setNuovaVoceField("richiesta", e.target.value)}
                disabled={!isIntegrazioneSalariale(nuovaVoce) && !nuovaVoce.descrizione_obbligatoria}
                placeholder={isIntegrazioneSalariale(nuovaVoce) ? "Inserire periodo dal … al …" : nuovaVoce.descrizione_obbligatoria ? "Testo mostrato come richiesta..." : ""}
                className={`h-24 w-full rounded-md border border-gray-300 p-2 focus:outline-success-200 ${!isIntegrazioneSalariale(nuovaVoce) && !nuovaVoce.descrizione_obbligatoria ? "bg-gray-100 text-gray-400" : ""}`}
              />
            </div>

            <div className="md:col-span-4 flex flex-wrap gap-3 border-t pt-3">
              {[
                { field: "attivo", label: "Attiva" },
                { field: "quantita_obbligatoria", label: "Quantità obbligatoria" },
                { field: "solo_admin", label: "Solo ADMIN" },
              ].map((item) => (
                <label key={item.field} className="inline-flex items-center gap-2 rounded-md border bg-white px-3 py-2 text-sm text-gray-700">
                  <input
                    type="checkbox"
                    checked={!!nuovaVoce[item.field]}
                    onChange={(e) => setNuovaVoceField(item.field, e.target.checked)}
                    className="h-4 w-4 rounded border-gray-300 text-blue-600"
                  />
                  {item.label}
                </label>
              ))}
            </div>

            {nuovaVoce.tipologia_fatturazione === "I" && nuovaVoce.iipay_a_fascia && (
              <div className="md:col-span-4 border-t pt-3">
                <label className="text-xs font-medium uppercase tracking-wider text-gray-500">
                  Prezzo per fascia cedolini (listino base)
                </label>
                {loadingFasceIipay ? (
                  <div className="text-xs text-gray-500 pt-1">Carico fasce...</div>
                ) : fasceStandardIipay.length ? (
                  <div className="grid grid-cols-2 gap-2 pt-2 md:grid-cols-4">
                    {fasceStandardIipay.map((fascia) => (
                      <Input
                        key={fascia.key}
                        label={getFasciaLabel(fascia)}
                        type="text"
                        placeholder="0,00"
                        value={nuovaVoce.fasce_prezzi[fascia.key] ?? ""}
                        onChange={(e) =>
                          setNuovaVoceField("fasce_prezzi", {
                            ...nuovaVoce.fasce_prezzi,
                            [fascia.key]: e.target.value,
                          })
                        }
                        inputMode="decimal"
                      />
                    ))}
                  </div>
                ) : (
                  <div className="text-xs text-gray-500 pt-1">
                    Nessuna fascia definita sul listino iiPay base: creale da Parcellazione → IIpay → Rate card.
                  </div>
                )}
              </div>
            )}

            <div className="md:col-span-4 border-t pt-3">
              <div className="mb-2 flex items-center justify-between gap-2">
                <label className="text-xs font-medium uppercase tracking-wider text-gray-500">Aziende associate</label>
                <div className="flex gap-1">
                  {[
                    { value: true, label: "Tutte" },
                    { value: false, label: "Solo alcune" },
                  ].map((opt) => (
                    <button
                      key={String(opt.value)}
                      type="button"
                      onClick={() => setNuovaVoceField("tutte_aziende", opt.value)}
                      className={`px-2.5 py-1 rounded text-xs font-semibold border transition-colors ${
                        nuovaVoce.tutte_aziende === opt.value
                          ? "bg-blue-50 border-blue-300 text-blue-700"
                          : "bg-white border-gray-200 text-gray-600 hover:border-gray-300"
                      }`}
                    >
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>
              {nuovaVoce.tutte_aziende ? (
                <div className="text-xs text-gray-500">
                  La voce si applica a tutte le aziende di tipo {nuovaVoce.tipologia_fatturazione}.
                </div>
              ) : (
                <div className="flex flex-col gap-2">
                  <Input
                    type="text"
                    placeholder="Cerca azienda..."
                    value={aziendeAmmesseSearch}
                    onChange={(e) => setAziendeAmmesseSearch(e.target.value)}
                    showClear
                  />
                  <div className="max-h-48 overflow-auto rounded-md border border-gray-200 p-2">
                  {aziendeTipologiaNuovaVoceFiltrate.length ? (
                    aziendeTipologiaNuovaVoceFiltrate.map((a) => (
                      <label key={a.codice_univoco} className="flex items-center gap-2 px-1 py-1 text-sm text-gray-700 hover:bg-gray-50">
                        <input
                          type="checkbox"
                          checked={nuovaVoce.aziende_ammesse.map(String).includes(String(a.codice_univoco))}
                          onChange={() => toggleAziendaAmmessa(a.codice_univoco)}
                          className="h-4 w-4 rounded border-gray-300 text-blue-600"
                        />
                        {a.ragione_sociale}
                      </label>
                    ))
                  ) : (
                    <div className="px-1 py-1 text-xs text-gray-400">Nessuna azienda trovata</div>
                  )}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button
              type="button"
              onClick={closeVoceModal}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={handleSaveNuovaVoce}
              disabled={savingNuovaVoce}
              className="rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100 disabled:opacity-50"
            >
              {savingNuovaVoce ? "Salvo..." : editingVoceCodice ? "Aggiorna voce" : "Salva voce"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderListinoClienteEditModal = () => {
    const row = listinoClienteEdit.row;
    if (!row) return null;
    const hasQuantita = requiresQuantita(row);
    const isZucchettiEdit = !!listinoClienteEdit.zucchettiCodice;
    const zucchettiCodice = listinoClienteEdit.zucchettiCodice;
    const isZucchettiDualChoice = cliente?.tipologia_fatturazione === "Z" && !isZucchettiEdit && isVoceDoppiaOpzione(row);
    const selectedMetodoCliente = listinoClienteEdit.metodoFatturazioneCliente
      ? Number(listinoClienteEdit.metodoFatturazioneCliente)
      : getMetodoClienteDoppiaOpzione(row);
    const prezzoRichiestoEdit = String(row.codice) === "203" || !isMetodoSenzaImportoFisso(selectedMetodoCliente);
    const canSetAZero = !prezzoRichiestoEdit;

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-10 w-full max-w-2xl rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">Modifica voce cliente</div>
            <button
              type="button"
              onClick={closeEditListinoCliente}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="grid grid-cols-1 gap-3 p-4 md:grid-cols-2">
            <Info label="Codice" value={getCodiceAgoDisplay(row)} />
            <Info label="Cliente" value={cliente?.ragione_sociale || ""} />
            <div className="md:col-span-2">
              <Info label="Prestazione" value={row.descrizione || ""} />
            </div>
            {isZucchettiEdit ? (
              <>
                {listinoClienteEdit.zucchettiRows.length > 1 && (
                  <div className="md:col-span-2">
                    <Select
                      label="Configurazione da modificare"
                      value={listinoClienteEdit.zucchettiId || ""}
                      onChange={(e) => handleZucchettiConfigChange(e.target.value)}
                      options={listinoClienteEdit.zucchettiRows.map((config) => ({
                        id: config.id,
                        name: getZucchettiConfigLabel(config),
                      }))}
                    />
                  </div>
                )}
                {zucchettiCodice === "186" && (
                  <>
                    <div>
                      <Input
                        label="Importo forfait (186)"
                        type="text"
                        value={listinoClienteEdit.importo}
                        onChange={(e) => setListinoClienteEdit((prev) => ({ ...prev, importo: e.target.value, importoForfait: e.target.value }))}
                        inputMode="decimal"
                      />
                    </div>
                    <div>
                      <Input
                        label="Cedolini max inclusi"
                        type="number"
                        value={listinoClienteEdit.maxCedolini}
                        onChange={(e) => setListinoClienteEdit((prev) => ({ ...prev, maxCedolini: e.target.value }))}
                      />
                    </div>
                    <div className="md:col-span-2">
                      <Input
                        label="Costo extra/ced. (187)"
                        type="text"
                        value={listinoClienteEdit.costoExtra}
                        onChange={() => {}}
                        inputMode="decimal"
                        disabled
                      />
                    </div>
                  </>
                )}
                {zucchettiCodice === "187" && (
                  <>
                    <div>
                      <Input
                        label="Importo forfait (186)"
                        type="text"
                        value={listinoClienteEdit.importoForfait}
                        onChange={() => {}}
                        inputMode="decimal"
                        disabled
                      />
                    </div>
                    <div>
                      <Input
                        label="Cedolini max inclusi"
                        type="number"
                        value={listinoClienteEdit.maxCedolini}
                        onChange={() => {}}
                        disabled
                      />
                    </div>
                    <div className="md:col-span-2">
                      <Input
                        label="Costo extra/ced. (187)"
                        type="text"
                        value={listinoClienteEdit.costoExtra}
                        onChange={(e) => setListinoClienteEdit((prev) => ({ ...prev, costoExtra: e.target.value, importo: e.target.value }))}
                        inputMode="decimal"
                      />
                    </div>
                    {listinoClienteEdit.zucchettiId && renderAggiornamentoMassivoPanel(handleToggleAggiornamentoMassivoZucchetti)}
                  </>
                )}
                {zucchettiCodice === "189" && (
                  <>
                    <div className="md:col-span-2">
                      <Input
                        label="Costo cedolino (189)"
                        type="text"
                        value={listinoClienteEdit.importo}
                        onChange={(e) => setListinoClienteEdit((prev) => ({ ...prev, importo: e.target.value, costoExtra: e.target.value }))}
                        inputMode="decimal"
                      />
                    </div>
                    {listinoClienteEdit.zucchettiId && renderAggiornamentoMassivoPanel(handleToggleAggiornamentoMassivoZucchetti)}
                  </>
                )}
                {zucchettiCodice === "186" && (
                  <div className="md:col-span-2">
                    <div className="mb-1 text-xs font-semibold uppercase text-gray-500">
                      Mesi importo forfait
                    </div>
                    <div className="mb-2 flex gap-2">
                      <button
                        type="button"
                        onClick={() => handleZucchettiForfaitMode("all")}
                        className={`rounded border px-3 py-1 text-sm ${
                          listinoClienteEdit.periodicita !== "custom"
                            ? "border-blue-300 bg-blue-50 text-blue-700"
                            : "border-gray-200 bg-white text-gray-600"
                        }`}
                      >
                        Tutti i mesi
                      </button>
                      <button
                        type="button"
                        onClick={() => handleZucchettiForfaitMode("selected")}
                        className={`rounded border px-3 py-1 text-sm ${
                          listinoClienteEdit.periodicita === "custom"
                            ? "border-blue-300 bg-blue-50 text-blue-700"
                            : "border-gray-200 bg-white text-gray-600"
                        }`}
                      >
                        Solo mesi selezionati
                      </button>
                    </div>
                    {listinoClienteEdit.periodicita === "custom" && (
                      <div className="grid grid-cols-6 gap-2">
                        {MESI_FATTURAZIONE_OPTIONS.map((mese) => {
                          const selected = parseMesiFatturazione(listinoClienteEdit.mesiFatturazione).includes(mese.id);
                          return (
                            <button
                              key={mese.id}
                              type="button"
                              onClick={() => handleToggleZucchettiMese(mese.id)}
                              className={`h-8 rounded border text-xs font-medium ${
                                selected
                                  ? "border-blue-600 bg-blue-600 text-white"
                                  : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
                              }`}
                            >
                              {mese.name}
                            </button>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
                <div className="md:col-span-2">
                  <Input
                    label="Decorrenza prezzo (mese)"
                    type="month"
                    value={listinoClienteEdit.decorrenza ? listinoClienteEdit.decorrenza.slice(0, 7) : ""}
                    onChange={(e) => setListinoClienteEdit((prev) => ({ ...prev, decorrenza: e.target.value ? `${e.target.value}-01` : "" }))}
                  />
                </div>
              </>
            ) : (
              <>
                {isZucchettiDualChoice && (
                  <div className="md:col-span-2">
                    <Select
                      label="Tipologia cliente"
                      value={String(selectedMetodoCliente)}
                      onChange={(e) => setListinoClienteEdit((prev) => ({
                        ...prev,
                        metodoFatturazioneCliente: e.target.value,
                        aZero: isMetodoSenzaImportoFisso(e.target.value) ? prev.aZero : false,
                      }))}
                      options={getMetodoDoppiaOpzioneOptions(row)}
                    />
                    <div className="mt-1 inline-flex rounded border border-violet-200 bg-violet-50 px-2 py-0.5 text-xs font-semibold text-violet-700">
                      Voce a 2 scelte
                    </div>
                  </div>
                )}
                <div className="md:col-span-2">
                  {prezzoRichiestoEdit ? (
                    <Input
                      label={hasQuantita ? "Prezzo unitario" : "Prezzo totale"}
                      type="text"
                      value={listinoClienteEdit.importo}
                      onChange={(e) => setListinoClienteEdit((prev) => ({ ...prev, importo: e.target.value }))}
                      inputMode="decimal"
                    />
                  ) : (
                    <Info label="Importo" value={getMetodoSenzaImportoLabel(selectedMetodoCliente, row, metodoLabelById)} />
                  )}
                </div>
                {prezzoRichiestoEdit && ["Z", "B"].includes(cliente?.tipologia_fatturazione) &&
                  renderAggiornamentoMassivoPanel(handleToggleAggiornamentoMassivo)}
                {String(row.codice) === "447" ? (
                  <div className="md:col-span-2">
                    <Select
                      label="Applicazione"
                      value={listinoClienteEdit.applicato ? "applicato" : "non_applicato"}
                      onChange={(e) => setListinoClienteEdit((prev) => ({ ...prev, applicato: e.target.value === "applicato" }))}
                      options={[
                        { id: "applicato", name: "Applicato" },
                        { id: "non_applicato", name: "Non applicato" },
                      ]}
                    />
                  </div>
                ) : canSetAZero && (
                  <label className="md:col-span-2 flex items-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700">
                    <input
                      type="checkbox"
                      checked={Boolean(listinoClienteEdit.aZero)}
                      onChange={(e) => setListinoClienteEdit((prev) => ({ ...prev, aZero: e.target.checked }))}
                      className="h-4 w-4 rounded border-gray-300 text-blue-600"
                    />
                    <span className="font-medium">A zero</span>
                  </label>
                )}
                {prezzoRichiestoEdit && (
                  <div className="md:col-span-2">
                    <Input
                      label="Decorrenza prezzo (mese)"
                      type="month"
                      value={listinoClienteEdit.decorrenza ? listinoClienteEdit.decorrenza.slice(0, 7) : ""}
                      onChange={(e) => setListinoClienteEdit((prev) => ({ ...prev, decorrenza: e.target.value ? `${e.target.value}-01` : "" }))}
                    />
                  </div>
                )}
              </>
            )}
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button
              type="button"
              onClick={closeEditListinoCliente}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={handleSaveListinoCliente}
              disabled={savingListinoClienteEdit}
              className="rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100 disabled:opacity-50"
            >
              {savingListinoClienteEdit ? "Salvo..." : "Salva"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderFasceZucchettiEditModal = () => {
    if (!fasceZucchettiEdit) return null;
    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-10 w-full max-w-lg rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div>
              <div className="text-lg font-semibold text-gray-900">Modifica prezzi fasce</div>
              <div className="text-xs text-gray-500">{cliente?.ragione_sociale} · voce {getCodiceAgoDisplay(fasceZucchettiEdit.row)}</div>
            </div>
            <button type="button" onClick={() => setFasceZucchettiEdit(null)} className="rounded border px-2 py-1 text-sm text-gray-500">Chiudi</button>
          </div>
          <div className="space-y-3 p-4">
            <div className="rounded border border-blue-100 bg-blue-50 px-3 py-2 text-xs text-blue-700">
              Le soglie restano invariate. La nuova decorrenza conserva i prezzi dei mesi precedenti.
            </div>
            {fasceZucchettiEdit.fasce.map((fascia, index) => (
              <div key={fascia.label} className="grid grid-cols-[1fr_160px] items-end gap-3">
                <Info label="Fascia" value={fascia.label} />
                <Input
                  label="Prezzo (€)"
                  type="text"
                  inputMode="decimal"
                  value={fascia.importo}
                  onChange={(event) => setFasceZucchettiEdit((prev) => ({
                    ...prev,
                    fasce: prev.fasce.map((item, itemIndex) => itemIndex === index ? { ...item, importo: event.target.value } : item),
                  }))}
                />
              </div>
            ))}
            <Input
              label="Decorrenza"
              type="date"
              value={fasceZucchettiEdit.decorrenza}
              onChange={(event) => setFasceZucchettiEdit((prev) => ({ ...prev, decorrenza: event.target.value }))}
            />
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button type="button" onClick={() => setFasceZucchettiEdit(null)} className="rounded border px-3 py-2 text-sm font-semibold text-gray-600">Annulla</button>
            <button type="button" onClick={saveFasceZucchetti} disabled={savingFasceZucchetti || !fasceZucchettiEdit.decorrenza} className="rounded border border-blue-300 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-700 disabled:opacity-50">
              {savingFasceZucchetti ? "Salvo..." : "Salva prezzi"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Pannello inline "Aggiornamento massivo" usato dentro il form di modifica
  // voce cliente (sia standard che 187/189): mostra la checkbox e, se
  // spuntata, l'elenco con ricerca dei clienti che oggi hanno lo stesso
  // prezzo, cosi' la scelta di chi altro aggiornare avviene prima di
  // salvare, non in un passaggio successivo.
  const renderAggiornamentoMassivoPanel = (onToggle) => {
    const clienti = stessoPrezzoConfirm?.clienti || [];
    const clientiFiltrati = stessoPrezzoSearch.trim()
      ? clienti.filter((c) => c.ragione_sociale.toLowerCase().includes(stessoPrezzoSearch.trim().toLowerCase()))
      : clienti;
    const tuttiVisibiliSelezionati =
      clientiFiltrati.length > 0 && clientiFiltrati.every((c) => stessoPrezzoSelezionati.has(c.codice_univoco));
    return (
      <div className="md:col-span-2 rounded-md border border-gray-200 bg-gray-50 p-3">
        <label className="flex cursor-pointer items-center gap-2 text-sm font-semibold text-gray-700">
          <input
            type="checkbox"
            checked={massivoAttivo}
            onChange={(e) => onToggle(e.target.checked)}
            className="h-4 w-4 rounded border-gray-300 text-blue-600"
          />
          Aggiornamento massivo
        </label>
        {loadingStessoPrezzo && (
          <div className="mt-2 text-xs text-gray-500">Controllo altri clienti con lo stesso prezzo...</div>
        )}
        {massivoAttivo && !loadingStessoPrezzo && stessoPrezzoConfirm && (
          clienti.length ? (
            <div className="mt-3 space-y-2">
              <div className="text-xs text-gray-600">
                Altri <strong>{clienti.length}</strong> client{clienti.length === 1 ? "e" : "i"} Zucchetti ha
                {clienti.length === 1 ? "" : "nno"} oggi lo stesso prezzo (<strong>{fmt(stessoPrezzoConfirm.importoAttuale)}</strong>).
                Scegli a chi altro applicare il nuovo prezzo insieme a questo cliente:
              </div>
              <div className="flex items-center justify-between text-xs text-gray-500">
                <span>{stessoPrezzoSelezionati.size} selezionati su {clienti.length}</span>
                <button
                  type="button"
                  onClick={toggleStessoPrezzoSelezionaTutti}
                  className="font-semibold text-blue-700 hover:underline"
                >
                  {tuttiVisibiliSelezionati ? "Deseleziona tutti" : "Seleziona tutti"}
                </button>
              </div>
              <Input
                type="text"
                placeholder="Cerca cliente..."
                value={stessoPrezzoSearch}
                onChange={(e) => setStessoPrezzoSearch(e.target.value)}
                showClear
              />
              <div className="max-h-40 overflow-auto rounded-md border border-gray-200 bg-white">
                {!clientiFiltrati.length && (
                  <div className="px-3 py-2 text-xs text-gray-400">Nessun cliente trovato</div>
                )}
                {clientiFiltrati.map((c) => (
                  <label
                    key={c.codice_univoco}
                    className="flex cursor-pointer items-center gap-2 border-b border-gray-100 px-3 py-1.5 last:border-b-0 hover:bg-gray-50"
                  >
                    <input
                      type="checkbox"
                      checked={stessoPrezzoSelezionati.has(c.codice_univoco)}
                      onChange={() => toggleStessoPrezzoSelezionato(c.codice_univoco)}
                      className="h-4 w-4 rounded border-gray-300 text-blue-600"
                    />
                    {c.ragione_sociale}
                  </label>
                ))}
              </div>
            </div>
          ) : (
            <div className="mt-2 text-xs text-gray-500">Nessun altro cliente ha oggi lo stesso prezzo.</div>
          )
        )}
      </div>
    );
  };

  const renderTariffaClienteEditModal = () => {
    const row = editingTariffaCliente;
    if (!row) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-10 w-full max-w-2xl rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">Prezzo personalizzato cliente</div>
            <button
              type="button"
              onClick={closeEditTariffaCliente}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="grid grid-cols-1 gap-3 p-4 md:grid-cols-2">
            <Info label="Codice" value={getCodiceAgoDisplay(row)} />
            <Info label="Cliente" value={cliente?.ragione_sociale || ""} />
            <div className="md:col-span-2">
              <Info label="Prestazione" value={row.descrizione_prestazione || ""} />
            </div>
            <Info
              label="Fascia"
              value={isFasciaRow(row) ? getFasciaLabel(row) : "Fisso (nessuna fascia)"}
            />
            <Info label="Prezzo rate card" value={row.is_override ? "vedi Storico" : fmt(row.importo)} />
            <div className="md:col-span-2">
              <Input
                label="Prezzo personalizzato per questo cliente"
                type="text"
                value={tariffaClienteImporto}
                onChange={(e) => setTariffaClienteImporto(e.target.value)}
                inputMode="decimal"
              />
            </div>
            <div className="md:col-span-2">
              <Input
                label="Decorrenza prezzo (mese)"
                type="month"
                value={tariffaClienteDecorrenza ? tariffaClienteDecorrenza.slice(0, 7) : ""}
                onChange={(e) => setTariffaClienteDecorrenza(e.target.value ? `${e.target.value}-01` : "")}
              />
            </div>
            <div className="md:col-span-2 text-xs text-gray-500">
              Vale solo per {cliente?.ragione_sociale || "questo cliente"}, sulla fascia indicata sopra. Le altre
              fasce di questa voce continuano a prendere il prezzo dalla rate card condivisa finché non vengono
              personalizzate a loro volta.
            </div>
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button
              type="button"
              onClick={closeEditTariffaCliente}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={handleSaveTariffaCliente}
              disabled={savingTariffaCliente}
              className="rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100 disabled:opacity-50"
            >
              {savingTariffaCliente ? "Salvo..." : "Salva"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderTariffaClienteMultiEditModal = () => {
    const voce = editingTariffaClienteMulti;
    if (!voce) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-10 w-full max-w-2xl rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">Prezzi personalizzati per fascia</div>
            <button
              type="button"
              onClick={closeEditTariffaClienteMulti}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="flex flex-col gap-3 p-4">
            <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
              <Info label="Codice" value={getCodiceAgoDisplay(voce)} />
              <Info label="Cliente" value={cliente?.ragione_sociale || ""} />
              <div className="md:col-span-2">
                <Info label="Prestazione" value={voce.descrizione} />
              </div>
            </div>
            <div className="text-xs text-gray-500">
              Compila solo le fasce che vuoi personalizzare per {cliente?.ragione_sociale || "questo cliente"} — il
              placeholder mostra il prezzo di rate card corrente; le fasce lasciate vuote restano su quel prezzo.
            </div>
            {loadingFasceIipay ? (
              <div className="text-xs text-gray-500 pt-1">Carico fasce...</div>
            ) : (
              <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
                {fasceStandardIipay.map((fascia) => {
                  const rateCard = fasceClienteMultiRateCard[fascia.key];
                  const personalizzato = fasceClienteMultiPrezzi[fascia.key] || "";
                  const isOverride = personalizzato.trim() !== "";
                  return (
                    <div key={fascia.key} className={isOverride ? "rounded ring-1 ring-amber-300" : ""}>
                      <Input
                        label={getFasciaLabel(fascia)}
                        type="text"
                        placeholder={rateCard || "0,00"}
                        value={personalizzato}
                        onChange={(e) =>
                          setFasceClienteMultiPrezzi((prev) => ({ ...prev, [fascia.key]: e.target.value }))
                        }
                        inputMode="decimal"
                      />
                    </div>
                  );
                })}
              </div>
            )}
            <div className="md:w-1/2">
              <Input
                label="Decorrenza prezzo (mese)"
                type="month"
                value={fasceClienteMultiDecorrenza ? fasceClienteMultiDecorrenza.slice(0, 7) : ""}
                onChange={(e) => setFasceClienteMultiDecorrenza(e.target.value ? `${e.target.value}-01` : "")}
              />
            </div>
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button
              type="button"
              onClick={closeEditTariffaClienteMulti}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={handleSaveTariffaClienteMulti}
              disabled={savingTariffaClienteMulti}
              className="rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100 disabled:opacity-50"
            >
              {savingTariffaClienteMulti ? "Salvo..." : "Salva"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderNoteFatturazioneModal = () => {
    if (!noteFatturazioneOpen) return null;
    const close = () => {
      setNoteFatturazioneCliente(cliente?.note_fatturazione || "");
      setNoteFatturazioneOpen(false);
    };

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-10 w-full max-w-xl rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">Nota fatturazione</div>
            <button type="button" onClick={close}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50">
              Chiudi
            </button>
          </div>
          <div className="p-4">
            <div className="mb-3 text-sm font-medium text-gray-700">{cliente?.ragione_sociale}</div>
            <textarea value={noteFatturazioneCliente}
              onChange={(event) => setNoteFatturazioneCliente(event.target.value)} rows={5}
              placeholder="Inserisci particolarità di fatturazione visibili agli operatori..."
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-800" />
            <p className="mt-1 text-xs text-gray-500">Svuota il testo e salva per cancellare la nota.</p>
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button type="button" onClick={close}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50">
              Annulla
            </button>
            <button type="button" onClick={handleSaveNoteFatturazioneCliente}
              disabled={savingNoteFatturazioneCliente}
              className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm font-semibold text-amber-800 hover:bg-amber-100 disabled:opacity-50">
              {savingNoteFatturazioneCliente ? "Salvo..." : "Salva"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderReport186Modal = () => {
    if (!report186Open) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-10 w-full max-w-md rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">Report annuale voce 186</div>
            <button type="button" onClick={() => setReport186Open(false)}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50">
              Chiudi
            </button>
          </div>
          <div className="p-4">
            <label className="mb-1 block text-xs font-semibold uppercase text-gray-500">Anno</label>
            <input type="number" min="2000" max="2100" step="1" value={report186Anno}
              onChange={(event) => setReport186Anno(event.target.value)}
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm" />
            <p className="mt-2 text-xs text-gray-500">
              Il file conterrà una riga per cliente e le colonne da gennaio a dicembre; i mesi senza importo saranno valorizzati a zero.
            </p>
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button type="button" onClick={() => setReport186Open(false)}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50">
              Annulla
            </button>
            <button type="button" onClick={exportReportVoce186} disabled={exportingReport186}
              className="rounded-md border border-emerald-300 bg-emerald-50 px-3 py-2 text-sm font-semibold text-emerald-700 hover:bg-emerald-100 disabled:opacity-50">
              {exportingReport186 ? "Esporto..." : "Esporta Excel"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderPeriodicitaClienteEditModal = () => {
    if (!periodicitaClienteEdit.open) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-10 w-full max-w-lg rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">Modifica periodicità cliente</div>
            <button
              type="button"
              onClick={closeEditPeriodicitaCliente}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="grid grid-cols-1 gap-3 p-4">
            <Info label="Cliente" value={cliente?.ragione_sociale || ""} />
            <Select
              label="Periodicità fatturazione"
              placeholder="Seleziona..."
              value={periodicitaClienteEdit.periodicita}
              onChange={(e) => setPeriodicitaClienteEdit((prev) => ({ ...prev, periodicita: e.target.value }))}
              options={PERIODICITA_OPTIONS}
            />
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button
              type="button"
              onClick={closeEditPeriodicitaCliente}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={handleSavePeriodicitaCliente}
              disabled={savingPeriodicitaCliente}
              className="rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100 disabled:opacity-50"
            >
              {savingPeriodicitaCliente ? "Salvo..." : "Salva"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderTipoZucchettiEditModal = () => {
    if (!tipoZucchettiEdit.open) return null;

    const tipologieVolute = TIPOLOGIE_CLIENTE_ZUCCHETTI[tipoZucchettiEdit.tipo] || [];
    const daRimuovere = datiZucchetti.filter(
      (config) => !tipologieVolute.includes(Number(config.tipologia_cliente))
    );
    const presenti = new Set(datiZucchetti.map((config) => Number(config.tipologia_cliente)));
    const daCreare = tipologieVolute.filter((tipologia) => !presenti.has(tipologia));

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-10 w-full max-w-lg rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">Modifica tipo cliente</div>
            <button
              type="button"
              onClick={closeEditTipoZucchetti}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="grid grid-cols-1 gap-3 p-4">
            <Info label="Cliente" value={cliente?.ragione_sociale || ""} />
            <Select
              label="Tipo"
              placeholder="Seleziona..."
              value={tipoZucchettiEdit.tipo}
              onChange={(e) => setTipoZucchettiEdit((prev) => ({ ...prev, tipo: e.target.value }))}
              options={TIPO_ZUCCHETTI_OPTIONS}
            />
            {daCreare.length > 0 && (
              <Input
                label="Decorrenza (mese)"
                type="month"
                value={tipoZucchettiEdit.decorrenza}
                onChange={(e) => setTipoZucchettiEdit((prev) => ({ ...prev, decorrenza: e.target.value }))}
              />
            )}
            {daCreare.length > 0 && (
              <div className="rounded border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-800">
                Verrà creata la configurazione {daCreare.map((t) => (t === 1 ? "forfait" : "listino")).join(" e ")} senza
                importi: vanno poi valorizzati dalle voci {daCreare.includes(1) ? "186/187" : ""}
                {daCreare.length === 2 ? " e " : ""}{daCreare.includes(0) ? "189" : ""} del listino.
              </div>
            )}
            {daRimuovere.length > 0 && (
              <div className="rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">
                <div className="font-semibold">Verranno eliminate queste configurazioni:</div>
                <ul className="mt-1 list-inside list-disc">
                  {daRimuovere.map((config) => (
                    <li key={config.id}>
                      {Number(config.tipologia_cliente) === 1 ? "Forfait" : "Listino"}
                      {config.importo_forfait != null ? ` · forfait ${fmt(config.importo_forfait)} €` : ""}
                      {config.costo_extra != null ? ` · costo extra ${fmt(config.costo_extra)} €` : ""}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button
              type="button"
              onClick={closeEditTipoZucchetti}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={handleSaveTipoZucchetti}
              disabled={savingTipoZucchetti}
              className="rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100 disabled:opacity-50"
            >
              {savingTipoZucchetti ? "Salvo..." : "Salva"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderIstatClienteEditModal = () => {
    if (!istatClienteEdit.open) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-10 w-full max-w-lg rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">Modifica ISTAT cliente</div>
            <button
              type="button"
              onClick={closeEditIstatCliente}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="grid grid-cols-1 gap-3 p-4">
            <Info label="Cliente" value={cliente?.ragione_sociale || ""} />
            <label className="flex cursor-pointer items-center gap-2 text-sm font-semibold text-gray-700">
              <input
                type="checkbox"
                checked={istatClienteEdit.applicato}
                onChange={(e) => setIstatClienteEdit((prev) => ({ ...prev, applicato: e.target.checked }))}
                className="h-4 w-4 rounded border-gray-300 text-blue-600"
              />
              ISTAT applicato
            </label>
            {istatClienteEdit.applicato && (
              <Input
                label="Applicato da (anno, sempre 1° gennaio)"
                type="number"
                placeholder="es. 2027"
                value={istatClienteEdit.decorrenza}
                onChange={(e) => setIstatClienteEdit((prev) => ({ ...prev, decorrenza: e.target.value.slice(0, 4) }))}
              />
            )}
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button
              type="button"
              onClick={closeEditIstatCliente}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={handleSaveIstatCliente}
              disabled={savingIstatCliente}
              className="rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100 disabled:opacity-50"
            >
              {savingIstatCliente ? "Salvo..." : "Salva"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderScontoClienteEditModal = () => {
    if (!scontoClienteEdit.open) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-10 w-full max-w-lg rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">
              {scontoClienteEdit.id ? "Modifica sconto cliente" : "Applica sconto cliente"}
            </div>
            <button
              type="button"
              onClick={closeEditScontoCliente}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="grid grid-cols-1 gap-3 p-4 md:grid-cols-2">
            <div className="md:col-span-2">
              <Info label="Cliente" value={cliente?.ragione_sociale || ""} />
            </div>
            <Input
              label="Percentuale (%)"
              type="text"
              placeholder="es. 10,00"
              value={scontoClienteEdit.percentuale}
              onChange={(e) => setScontoClienteEdit((prev) => ({ ...prev, percentuale: e.target.value }))}
            />
            <Input
              label="Dal (mese)"
              type="month"
              value={scontoClienteEdit.meseInizio}
              onChange={(e) => setScontoClienteEdit((prev) => ({ ...prev, meseInizio: e.target.value }))}
            />
            <Input
              label="Al (mese, vuoto = indeterminato)"
              type="month"
              value={scontoClienteEdit.meseFine}
              onChange={(e) => setScontoClienteEdit((prev) => ({ ...prev, meseFine: e.target.value }))}
            />
            <div className="md:col-span-2">
              <Input
                label="Note"
                type="text"
                value={scontoClienteEdit.note}
                onChange={(e) => setScontoClienteEdit((prev) => ({ ...prev, note: e.target.value }))}
              />
            </div>
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button
              type="button"
              onClick={closeEditScontoCliente}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={handleSaveScontoCliente}
              disabled={savingScontoCliente}
              className="rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100 disabled:opacity-50"
            >
              {savingScontoCliente ? "Salvo..." : "Salva"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderStoricoScontoClienteModal = () => {
    if (!storicoScontoClienteOpen) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-8 w-full max-w-3xl rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div>
              <div className="text-lg font-semibold text-gray-900">Storico sconto cliente</div>
              <div className="text-xs text-gray-500">{cliente?.ragione_sociale || ""}</div>
            </div>
            <button
              type="button"
              onClick={closeStoricoScontoCliente}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="max-h-[60vh] overflow-auto p-4">
            {scontoClienteRows.length ? (
              <table className="min-w-full border-collapse text-sm">
                <thead className="text-gray-500">
                  <tr>
                    <th className="border-b px-2 py-1.5 text-right font-semibold">Percentuale</th>
                    <th className="border-b px-2 py-1.5 text-left font-semibold">Dal</th>
                    <th className="border-b px-2 py-1.5 text-left font-semibold">Al</th>
                    <th className="border-b px-2 py-1.5 text-left font-semibold">Note</th>
                    <th className="border-b px-2 py-1.5 text-left font-semibold">Utente</th>
                    <th className="border-b px-2 py-1.5 text-left font-semibold"></th>
                  </tr>
                </thead>
                <tbody>
                  {scontoClienteRows.map((row) => (
                    <tr key={row.id} className="border-b align-middle">
                      <td className="px-2 py-1.5 text-right font-semibold text-gray-800">{fmt(row.percentuale)}%</td>
                      <td className="px-2 py-1.5 text-gray-600">{formatMeseAnnoStr(row.data_inizio)}</td>
                      <td className="px-2 py-1.5 text-gray-600">{row.data_fine ? formatMeseAnnoStr(row.data_fine) : "indeterminato"}</td>
                      <td className="px-2 py-1.5 text-gray-600">{row.note || ""}</td>
                      <td className="px-2 py-1.5 text-gray-600">{row.created_by || ""}</td>
                      <td className="px-2 py-1.5 text-right">
                        <button
                          type="button"
                          onClick={() => handleEliminaScontoCliente(row)}
                          className="rounded border border-red-200 bg-red-50 px-2 py-0.5 text-xs font-semibold text-red-700 hover:bg-red-100"
                        >
                          Elimina
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="text-sm text-gray-400">Nessuno sconto configurato per questo cliente.</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderIstatApplicaModal = () => {
    if (!istatApplica.open) return null;
    const search = istatApplica.search.trim().toLowerCase();
    const visibili = search
      ? istatApplica.anteprima.filter((r) => r.ragione_sociale.toLowerCase().includes(search))
      : istatApplica.anteprima;
    const tuttiVisibiliSelezionati = visibili.length > 0 && visibili.every((r) => istatApplica.selezionati.has(r.codice_univoco));
    const pronto = istatApplica.voce && istatApplica.percentuale && istatApplica.decorrenza;

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-8 w-full max-w-2xl rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">Aumento ISTAT</div>
            <button
              type="button"
              onClick={closeIstatApplica}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="grid grid-cols-1 gap-3 p-4 md:grid-cols-2">
            <div className="md:col-span-2">
              <Autocomplete
                label="Voce"
                placeholder="Cerca voce..."
                value={istatApplica.voce?.id || ""}
                onChange={(e) => {
                  const opt = vociZIstatOptions.find((o) => String(o.id) === String(e.target.value));
                  setIstatApplica((prev) => ({ ...prev, voce: opt ? { ...opt } : null }));
                }}
                options={vociZIstatOptions}
              />
            </div>
            <Input
              label="Aumento (%)"
              type="text"
              placeholder="es. 5,00"
              value={istatApplica.percentuale}
              onChange={(e) => setIstatApplica((prev) => ({ ...prev, percentuale: e.target.value }))}
            />
            <Input
              label="Decorrenza (anno, sempre 1° gennaio)"
              type="number"
              placeholder="es. 2027"
              value={istatApplica.decorrenza}
              onChange={(e) => setIstatApplica((prev) => ({ ...prev, decorrenza: e.target.value.slice(0, 4) }))}
            />
            <div className="md:col-span-2 flex flex-wrap gap-4">
              <label className="flex cursor-pointer items-center gap-2 text-sm text-gray-700">
                <input
                  type="checkbox"
                  checked={istatApplica.arrotondamento === "euro5"}
                  onChange={(e) => setIstatApplica((prev) => ({ ...prev, arrotondamento: e.target.checked ? "euro5" : null }))}
                  className="h-4 w-4 rounded border-gray-300 text-blue-600"
                />
                Arrotonda ai prossimi 5 euro
              </label>
              <label className="flex cursor-pointer items-center gap-2 text-sm text-gray-700">
                <input
                  type="checkbox"
                  checked={istatApplica.arrotondamento === "centesimi10"}
                  onChange={(e) => setIstatApplica((prev) => ({ ...prev, arrotondamento: e.target.checked ? "centesimi10" : null }))}
                  className="h-4 w-4 rounded border-gray-300 text-blue-600"
                />
                Arrotonda ai 10 centesimi
              </label>
            </div>
            <div className="md:col-span-2 rounded-md border border-gray-200 bg-gray-50 p-3">
              {istatApplica.loadingAnteprima && (
                <div className="text-xs text-gray-500">Carico anteprima...</div>
              )}
              {!istatApplica.loadingAnteprima && pronto && (
                istatApplica.anteprima.length ? (
                  <div className="space-y-2">
                    <div className="flex items-center justify-between text-xs text-gray-500">
                      <span>{istatApplica.selezionati.size} selezionati su {istatApplica.anteprima.length}</span>
                      <button
                        type="button"
                        onClick={toggleIstatSelezionaTutti}
                        className="font-semibold text-blue-700 hover:underline"
                      >
                        {tuttiVisibiliSelezionati ? "Deseleziona tutti" : "Seleziona tutti"}
                      </button>
                    </div>
                    <Input
                      type="text"
                      placeholder="Cerca cliente..."
                      value={istatApplica.search}
                      onChange={(e) => setIstatApplica((prev) => ({ ...prev, search: e.target.value }))}
                      showClear
                    />
                    <div className="max-h-64 overflow-auto rounded-md border border-gray-200 bg-white">
                      {!visibili.length && (
                        <div className="px-3 py-2 text-xs text-gray-400">Nessun cliente trovato</div>
                      )}
                      {visibili.map((r) => (
                        <label
                          key={r.codice_univoco}
                          className="flex cursor-pointer items-center justify-between gap-2 border-b border-gray-100 px-3 py-1.5 last:border-b-0 hover:bg-gray-50"
                        >
                          <span className="flex items-center gap-2">
                            <input
                              type="checkbox"
                              checked={istatApplica.selezionati.has(r.codice_univoco)}
                              onChange={() => toggleIstatSelezionato(r.codice_univoco)}
                              className="h-4 w-4 rounded border-gray-300 text-blue-600"
                            />
                            {r.ragione_sociale}
                          </span>
                          <span className="text-xs tabular-nums text-gray-500">
                            {r.tariffe_fascia_voce_eccezionali?.length ? (
                              <>
                                {r.tariffe_fascia_voce_eccezionali.map((fascia, index) => {
                                  const intervallo = fascia.max_quantita == null
                                    ? `oltre ${Number(fascia.min_quantita) - 1}`
                                    : Number(fascia.min_quantita) === 0
                                      ? `fino a ${fascia.max_quantita}`
                                      : `${fascia.min_quantita}-${fascia.max_quantita}`;
                                  return (
                                    <React.Fragment key={`${fascia.min_quantita}-${fascia.max_quantita ?? "oltre"}`}>
                                      {index > 0 && " · "}{intervallo}: {fmt(fascia.importo_attuale)} → <strong className="text-gray-800">{fmt(fascia.importo_nuovo)}</strong>
                                    </React.Fragment>
                                  );
                                })}
                              </>
                            ) : r.tariffa_fascia_eccezionale ? (
                              <>
                                fino a {r.soglia}: {fmt(r.importo_attuale)} → <strong className="text-gray-800">{fmt(r.importo_nuovo)}</strong>
                                {" · oltre: "}{fmt(r.importo_oltre_soglia_attuale)} → <strong className="text-gray-800">{fmt(r.importo_oltre_soglia_nuovo)}</strong>
                              </>
                            ) : (
                              <>{fmt(r.importo_attuale)} → <strong className="text-gray-800">{fmt(r.importo_nuovo)}</strong></>
                            )}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="text-xs text-gray-500">
                    Nessun cliente Zucchetti con ISTAT applicato risulta attivo per questa voce/periodo.
                  </div>
                )
              )}
              {!pronto && (
                <div className="text-xs text-gray-500">Seleziona voce, percentuale e decorrenza per vedere l'anteprima.</div>
              )}
            </div>
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button
              type="button"
              onClick={closeIstatApplica}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={handleApplicaIstat}
              disabled={istatApplica.applying || !istatApplica.selezionati.size}
              className="rounded-md border border-orange-300 bg-orange-50 px-3 py-2 text-sm font-semibold text-orange-700 hover:bg-orange-100 disabled:opacity-50"
            >
              {istatApplica.applying ? "Applico..." : "Applica"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderIstatReportModal = () => {
    if (!istatReportModal.open) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-10 w-full max-w-md rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div className="text-lg font-semibold text-gray-900">Report ISTAT</div>
            <button
              type="button"
              onClick={closeIstatReport}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="grid grid-cols-2 gap-3 p-4">
            <Input
              label="Dall'anno"
              type="number"
              placeholder="es. 2024"
              value={istatReportModal.annoDa}
              onChange={(e) => setIstatReportModal((prev) => ({ ...prev, annoDa: e.target.value.slice(0, 4) }))}
            />
            <Input
              label="All'anno"
              type="number"
              placeholder="es. 2027"
              value={istatReportModal.annoA}
              onChange={(e) => setIstatReportModal((prev) => ({ ...prev, annoA: e.target.value.slice(0, 4) }))}
            />
          </div>
          <div className="px-4 pb-2 text-xs text-gray-500">
            Un foglio Excel per ogni anno, con tutti i clienti Zucchetti attivi: stato ISTAT e, per ogni voce interessata, percentuale applicata e nuovo valore.
          </div>
          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button
              type="button"
              onClick={closeIstatReport}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={handleExportIstatReport}
              disabled={exportingIstatReport}
              className={EXPORT_BUTTON_CLASS}
            >
              {exportingIstatReport ? "Esporto..." : "Esporta"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderStoricoPrezziModal = () => {
    if (!storicoPrezziOpen) return null;
    const voce = storicoPrezziVoce;
    const codiceStorico = getCodiceAgoDisplay(voce);

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-8 w-full max-w-3xl rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div>
              <div className="text-lg font-semibold text-gray-900">Storico prezzi</div>
              <div className="text-xs text-gray-500">
                {codiceStorico} — {voce?.descrizione_voce_crm || voce?.descrizione_voce_ago}
              </div>
            </div>
            <button
              type="button"
              onClick={closeStoricoPrezzi}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>
          <div className="max-h-[60vh] overflow-auto p-4">
            {loadingStoricoPrezzi ? (
              <div className="text-sm text-gray-500">Carico...</div>
            ) : storicoPrezziRows.length ? (
              (() => {
                const groups = groupStoricoRows(storicoPrezziRows);
                const conFasce = groups.some((g) => g.min_fascia != null || g.max_fascia != null);
                return (
                  <table className="min-w-full border-collapse text-sm">
                    <thead className="text-gray-500">
                      <tr>
                        <th className="border-b px-2 py-1.5 text-left font-semibold">Data</th>
                        {conFasce && <th className="border-b px-2 py-1.5 text-left font-semibold">Fascia</th>}
                        <th className="border-b px-2 py-1.5 text-right font-semibold">Prima</th>
                        <th className="border-b px-2 py-1.5 text-right font-semibold">Dopo</th>
                        <th className="border-b px-2 py-1.5 text-left font-semibold">Decorrenza</th>
                        <th className="border-b px-2 py-1.5 text-left font-semibold">Utente</th>
                        <th className="border-b px-2 py-1.5 text-left font-semibold"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {groups.map((group) => (
                        <tr key={group.ids.join("-")} className="border-b align-middle">
                          <td className="px-2 py-1.5 text-gray-600">{moment(group.data_modifica).format("DD/MM/YYYY HH:mm")}</td>
                          {conFasce && (
                            <td className="px-2 py-1.5 text-gray-600">
                              {group.min_fascia != null || group.max_fascia != null ? getFasciaLabel(group) : "—"}
                            </td>
                          )}
                          <td className="px-2 py-1.5 text-right text-gray-500">{group.importo_precedente == null ? "—" : fmt(group.importo_precedente)}</td>
                          <td className="px-2 py-1.5 text-right font-semibold text-gray-800">{group.importo_nuovo == null ? "—" : fmt(group.importo_nuovo)}</td>
                          <td className="px-2 py-1.5 text-gray-600">{group.data_decorrenza ? moment(group.data_decorrenza).format("DD/MM/YYYY") : "—"}</td>
                          <td className="px-2 py-1.5 text-gray-600">
                            <div className="flex items-center gap-1.5">
                              <span>{group.utente || ""}</span>
                              {group.origine === "istat" && <IstatBadge />}
                            </div>
                          </td>
                          <td className="px-2 py-1.5 text-right">
                            {!group.non_annullabile && (
                              <button
                                type="button"
                                onClick={() => handleDeleteStoricoRow(group)}
                                className="rounded border border-red-200 bg-red-50 px-2 py-0.5 text-xs font-semibold text-red-700 hover:bg-red-100"
                              >
                                Elimina
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                );
              })()
            ) : (
              <div className="text-sm text-gray-400">Nessuna variazione registrata per questa voce.</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderGestisciFasceModal = () => {
    if (!gestisciFasceOpen) return null;

    const precedenti = fasceSchemeData?.fasce_precedenti || [];

    return (
      <div className="fixed inset-0 z-50 flex items-start justify-center overflow-auto bg-black/30 p-4">
        <div className="mt-8 w-full max-w-3xl rounded-lg border bg-white shadow-xl">
          <div className="flex items-center justify-between border-b px-4 py-3">
            <div>
              <div className="text-lg font-semibold text-gray-900">Gestisci fasce iiPay (listino base)</div>
              {fasceSchemeData?.decorrenza_attuale && (
                <div className="text-xs text-gray-500">
                  Versione attuale in vigore dal {moment(fasceSchemeData.decorrenza_attuale).format("DD/MM/YYYY")}
                </div>
              )}
            </div>
            <button
              type="button"
              onClick={closeGestisciFasce}
              className="rounded-md border border-gray-200 px-2 py-1 text-sm text-gray-500 hover:bg-gray-50"
            >
              Chiudi
            </button>
          </div>

          {loadingGestisciFasce ? (
            <div className="p-4 text-sm text-gray-500">Carico...</div>
          ) : (
            <div className="p-4">
              <div className="mb-3 text-xs text-gray-500">
                {fasceEditMode ? (
                  <>
                    Stai modificando le bande della versione del {moment(fasceEditMode).format("DD/MM/YYYY")} senza
                    creare una nuova versione datata. I prezzi delle singole voci si modificano da "Voci listino".
                  </>
                ) : (
                  <>
                    Ogni modifica crea una nuova versione datata: i periodi già calcolati con le fasce precedenti non
                    cambiano. Solo i confini delle fasce vengono aggiornati — i prezzi delle singole voci si
                    modificano da "Voci listino".
                  </>
                )}
              </div>

              <div className="grid grid-cols-1 divide-y rounded-md border border-gray-200">
                <div className="grid grid-cols-[1fr_1fr_1fr_auto] gap-2 bg-gray-50 px-2 py-1.5 text-xs font-semibold uppercase text-gray-500">
                  <span>Da</span>
                  <span>A</span>
                  <span>Fascia precedente</span>
                  <span></span>
                </div>
                {fasceForm.map((row, index) => (
                  <div key={index} className="grid grid-cols-[1fr_1fr_1fr_auto] items-center gap-2 px-2 py-1">
                    <input
                      type="number"
                      value={row.min_fascia}
                      onChange={(e) => updateFasciaRow(index, "min_fascia", e.target.value)}
                      placeholder="da"
                      className="h-8 w-full rounded border border-gray-300 px-2 text-sm focus:outline-success-200"
                    />
                    <input
                      type="number"
                      value={row.max_fascia}
                      onChange={(e) => updateFasciaRow(index, "max_fascia", e.target.value)}
                      placeholder="illimitato"
                      className="h-8 w-full rounded border border-gray-300 px-2 text-sm focus:outline-success-200"
                    />
                    <div className="text-xs text-gray-400">
                      {precedenti[index] ? getFasciaLabel(precedenti[index]) : "—"}
                    </div>
                    <button
                      type="button"
                      onClick={() => removeFasciaRow(index)}
                      className="rounded border border-red-200 bg-red-50 px-2 py-1 text-xs font-semibold text-red-700 hover:bg-red-100"
                    >
                      Rimuovi
                    </button>
                  </div>
                ))}
              </div>

              <div className="mt-2 flex items-center justify-between gap-3">
                <button
                  type="button"
                  onClick={addFasciaRow}
                  className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs font-semibold text-gray-700 hover:bg-gray-50"
                >
                  + Aggiungi fascia
                </button>
                <div className="flex items-center gap-2">
                  <label className="text-xs font-semibold uppercase text-gray-500">
                    {fasceEditMode ? "Decorrenza versione (mese)" : "Decorrenza nuova versione (mese)"}
                  </label>
                  <input
                    type="month"
                    value={fasceDecorrenza ? fasceDecorrenza.slice(0, 7) : ""}
                    onChange={(e) => setFasceDecorrenza(e.target.value ? `${e.target.value}-01` : "")}
                    className="h-8 rounded border border-gray-300 px-2 text-sm focus:outline-success-200"
                  />
                  {fasceEditMode && (
                    <button
                      type="button"
                      onClick={annullaModificaVersione}
                      className="rounded-md border border-gray-300 bg-white px-2 py-1.5 text-xs font-semibold text-gray-600 hover:bg-gray-50"
                    >
                      Annulla modifica
                    </button>
                  )}
                </div>
              </div>

              <div className="mt-4 rounded-md border border-gray-200">
                <div className="border-b bg-gray-50 px-3 py-1.5 text-xs font-semibold uppercase text-gray-500">
                  Storico versioni ({fasceStorico.length})
                </div>
                <div className="max-h-40 overflow-auto divide-y">
                  {fasceStorico.map((v, idx) => {
                    const isAttuale = idx === 0;
                    return (
                      <div key={String(v.data_decorrenza)} className="flex items-start gap-2 px-3 py-1.5 text-xs">
                        <span
                          className={`shrink-0 rounded px-1.5 py-0.5 font-semibold ${
                            isAttuale
                              ? "bg-blue-50 text-blue-700 border border-blue-200"
                              : "bg-gray-50 text-gray-500 border border-gray-200"
                          }`}
                        >
                          {moment(v.data_decorrenza).format("DD/MM/YYYY")}
                        </span>
                        <span className="flex-1 text-gray-500">
                          {v.fasce.map((f) => getFasciaLabel(f)).join(", ")}
                        </span>
                        <div className="flex shrink-0 gap-1.5">
                          {isAttuale && (
                            <button
                              type="button"
                              onClick={() => startModificaVersione(v)}
                              className="rounded border border-blue-200 bg-blue-50 px-1.5 py-0.5 text-xs font-semibold text-blue-700 hover:bg-blue-100"
                            >
                              Modifica
                            </button>
                          )}
                          <button
                            type="button"
                            onClick={() => handleEliminaVersioneFasce(v)}
                            disabled={eliminandoVersioneFasce || fasceStorico.length <= 1}
                            className="rounded border border-red-200 bg-red-50 px-1.5 py-0.5 text-xs font-semibold text-red-700 hover:bg-red-100 disabled:opacity-40"
                          >
                            Elimina
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}

          <div className="flex justify-end gap-2 border-t px-4 py-3">
            <button
              type="button"
              onClick={closeGestisciFasce}
              className="rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600 hover:bg-gray-50"
            >
              Annulla
            </button>
            <button
              type="button"
              onClick={handleSaveFasce}
              disabled={savingFasce || loadingGestisciFasce}
              className="rounded-md border border-blue-300 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100 disabled:opacity-50"
            >
              {savingFasce ? "Salvo..." : fasceEditMode ? "Salva modifiche" : "Crea nuova versione"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="el-container flex flex-col gap-3">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b pb-2">
        <div className="flex flex-wrap gap-2">
          {visibleViews.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => handleViewChange(item.id)}
              className={`px-3 py-1.5 rounded-md text-sm font-medium border ${
                view === item.id
                  ? "bg-blue-50 border-blue-300 text-blue-700"
                  : "bg-white border-gray-200 text-gray-600 hover:bg-gray-50"
              }`}
            >
              {item.name}
            </button>
          ))}
        </div>
        {isAdmin && view === "rate_card" && (
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={exportVariazioniClientiIipay}
              disabled={exportingVariazioniIipay}
              className={EXPORT_BUTTON_CLASS}
            >
              {exportingVariazioniIipay ? "Export..." : "Excel variazioni"}
            </button>
            <ScontoGlobaleIIpay clienti={clientiIIpayAttivi} />
          </div>
        )}
      </div>

      {view === "cliente" && renderCliente()}
      {view === "rate_card" && renderRateCard()}
      {view === "extra" && renderExtra()}
      {view === "bpoint_listino" && renderBpointListino()}
      {view === "voci" && renderVociListino()}
      {view === "master" && renderMaster()}
      {renderNuovaVoceModal()}
      {renderListinoClienteEditModal()}
      {renderFasceZucchettiEditModal()}
      {renderTariffaClienteEditModal()}
      {renderTariffaClienteMultiEditModal()}
      {renderNoteFatturazioneModal()}
      {renderReport186Modal()}
      {renderPeriodicitaClienteEditModal()}
      {renderTipoZucchettiEditModal()}
      {renderIstatClienteEditModal()}
      {renderIstatApplicaModal()}
      {renderIstatReportModal()}
      {renderGestisciFasceModal()}
      {renderStoricoPrezziModal()}
      {renderScontoClienteEditModal()}
      {renderStoricoScontoClienteModal()}
      {bpointClienteEdit && (
        <Modal isOpen size="medium" closeButton={() => setBpointClienteEdit(null)} headerText="Prezzi personalizzati BPoint · voce 427">
          <div className="space-y-4 p-1">
            <div className="rounded border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
              <div className="font-semibold">{cliente?.ragione_sociale}</div>
              <div>Questi prezzi sostituiscono le Fasce BPoint generali solo per questo cliente.</div>
              <div className="mt-1 text-xs font-semibold">Listino applicato: BPoint {bpointClienteEdit.tipo === 'alfieri' ? 'Alfieri' : 'Standard'}</div>
            </div>
            <div>
              {[bpointClienteEdit.tipo || 'standard'].map((tipo) => <div key={tipo} className="rounded-lg border border-purple-200 bg-white p-3">
                <div className="mb-2 font-semibold text-purple-900">{tipo === 'standard' ? 'Standard BPoint' : 'Alfieri'}</div>
                <div className="mb-3 flex flex-wrap items-end gap-2 rounded border border-purple-100 bg-purple-50/50 p-2">
                  <label className="text-xs text-gray-600">
                    <span className="mb-1 block font-semibold">Stesso importo per tutte le fasce</span>
                    <input type="number" min="0" step="0.01" value={bpointClienteEdit.importoUnico ?? ''} onChange={(event) => setBpointClienteEdit((prev) => ({ ...prev, importoUnico: event.target.value }))} placeholder="es. 17,50" className="w-28 rounded border border-gray-300 p-1.5 text-sm" />
                  </label>
                  <button type="button" disabled={bpointClienteEdit.importoUnico === '' || bpointClienteEdit.importoUnico == null || !Number.isFinite(Number(bpointClienteEdit.importoUnico)) || Number(bpointClienteEdit.importoUnico) < 0} onClick={() => setBpointClienteEdit((prev) => ({ ...prev, fasce: prev.fasce.map((item) => item.tipo === tipo ? { ...item, importo_unitario: prev.importoUnico } : item) }))} className="rounded border border-purple-300 bg-white px-3 py-1.5 text-xs font-semibold text-purple-700 disabled:opacity-50">Applica a tutte le fasce</button>
                </div>
                <div className="max-h-[360px] overflow-auto"><table className="w-full text-sm"><thead className="sticky top-0 bg-purple-50"><tr><th className="p-2 text-left">Fascia</th><th className="p-2 text-left">€ / cedolino</th></tr></thead><tbody>
                  {bpointClienteEdit.fasce.map((fascia, index) => ({ fascia, index })).filter(({ fascia }) => fascia.tipo === tipo).map(({ fascia, index }) => <tr key={`${tipo}-${fascia.min_cedolini}`} className="border-t">
                    <td className="p-2 text-gray-600">{fascia.min_cedolini}–{fascia.max_cedolini ?? '∞'}</td>
                    <td className="p-1"><input type="number" min="0" step="0.01" value={fascia.importo_unitario} onChange={(event) => setBpointClienteEdit((prev) => ({ ...prev, fasce: prev.fasce.map((item, itemIndex) => itemIndex === index ? { ...item, importo_unitario: event.target.value } : item) }))} className="w-28 rounded border border-gray-300 p-1.5" /></td>
                  </tr>)}
                </tbody></table></div>
              </div>)}
            </div>
            <div className="grid items-end gap-3 md:grid-cols-2">
              <Input label="Decorrenza nuova versione (mese)" type="month" value={bpointClienteEdit.decorrenza.slice(0, 7)} onChange={(event) => changeBpointClienteDecorrenza(event.target.value ? `${event.target.value}-01` : '')} />
              <div className="text-xs text-gray-500">{bpointClienteEdit.personalizzato ? 'Il cliente ha già un listino personalizzato.' : 'Al salvataggio verrà creato il listino personalizzato.'}{bpointClienteEdit.storico.length ? ` Versioni presenti: ${bpointClienteEdit.storico.length}.` : ''} I prezzi valgono dal mese di decorrenza in avanti; i periodi precedenti mantengono i prezzi già in vigore.</div>
            </div>
            <div className="flex justify-end gap-2 border-t pt-3">
              <button type="button" onClick={() => setBpointClienteEdit(null)} className="rounded border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600">Annulla</button>
              <button type="button" onClick={saveBpointClienteEdit} disabled={savingBpointCliente || !bpointClienteEdit.decorrenza} className="rounded border border-purple-300 bg-purple-50 px-3 py-2 text-sm font-semibold text-purple-700 disabled:opacity-50">{savingBpointCliente ? 'Salvo...' : 'Salva prezzi personalizzati'}</button>
            </div>
          </div>
        </Modal>
      )}
      {bpointTipoEditOpen && (
        <Modal isOpen size="tiny" closeButton={() => setBpointTipoEditOpen(false)} headerText="Tipo fasce BPoint">
          <div className="space-y-3 p-1">
            <div className="text-sm text-gray-600">
              Seleziona il listino applicabile a <span className="font-semibold text-gray-900">{cliente?.ragione_sociale}</span>.
            </div>
            <div className="grid grid-cols-2 gap-3">
              {[{ tipo: false, label: 'Standard' }, { tipo: true, label: 'Alfieri' }].map((item) => {
                const selected = Number(datiBpointCliente?.alfieri || 0) === (item.tipo ? 1 : 0);
                return <button
                  key={item.label}
                  type="button"
                  disabled={savingBpointTipo}
                  onClick={() => saveBpointTipoCliente(item.tipo)}
                  className={`rounded-md border px-4 py-3 text-sm font-semibold disabled:opacity-50 ${selected ? 'border-purple-400 bg-purple-50 text-purple-800 ring-1 ring-purple-300' : 'border-gray-200 bg-white text-gray-700 hover:bg-gray-50'}`}
                >
                  BPoint {item.label}
                  {selected && <div className="mt-1 text-[10px] uppercase">Attuale</div>}
                </button>;
              })}
            </div>
          </div>
        </Modal>
      )}
      {bpoint427AssociationOpen && (
        <Modal isOpen size="tiny" closeButton={() => setBpoint427AssociationOpen(false)} headerText="Tariffa BPoint 427 ereditata">
          <div className="space-y-4 p-1">
            <div className="text-sm text-gray-600">
              Il cliente mantiene i propri cedolini e la propria esclusione delle mensilità aggiuntive. Per la voce 427 applica il prezzo unitario calcolato sulla sorgente nello stesso trimestre, in base alla media e al tipo Standard/Alfieri della sorgente, indipendentemente dalla propria fascia.
            </div>
            {bpoint427Association?.ha_clienti_associati ? (
              <div className="rounded border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
                Questo cliente è già sorgente tariffaria per altri clienti e non può essere collegato a un’altra azienda.
              </div>
            ) : (
              <Autocomplete
                label="Eredita i prezzi da"
                placeholder="Cerca cliente BPoint..."
                value={bpoint427AssociationSelected}
                onChange={(event) => setBpoint427AssociationSelected(event.target.value)}
                badgePosition="right"
                options={(bpoint427Association?.candidati || []).map((item) => ({
                  id: item.codice_univoco,
                  name: item.ragione_sociale,
                  badge: {
                    label: Number(item.alfieri) === 1 ? 'Alfieri' : 'Standard',
                    className: 'bg-purple-100 text-purple-700',
                  },
                }))}
              />
            )}
            <div className="flex justify-between gap-2 border-t pt-3">
              <div>{bpoint427Association?.associazione && <button type="button" disabled={savingBpoint427Association}
                onClick={deleteBpoint427Association} className="rounded border border-red-200 bg-red-50 px-3 py-2 text-sm font-semibold text-red-700 disabled:opacity-50">Rimuovi collegamento</button>}</div>
              <div className="flex gap-2">
                <button type="button" onClick={() => setBpoint427AssociationOpen(false)} className="rounded border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-600">Annulla</button>
                {!bpoint427Association?.ha_clienti_associati && <button type="button" onClick={saveBpoint427Association}
                  disabled={savingBpoint427Association || !bpoint427AssociationSelected}
                  className="rounded border border-purple-300 bg-purple-50 px-3 py-2 text-sm font-semibold text-purple-700 disabled:opacity-50">
                  {savingBpoint427Association ? 'Salvo...' : 'Salva collegamento'}
                </button>}
              </div>
            </div>
          </div>
        </Modal>
      )}
      {bpointClienteStorico && (
        <Modal isOpen size="medium" closeButton={() => setBpointClienteStorico(null)} headerText="Storico prezzi personalizzati BPoint · voce 427">
          <div className="max-h-[66vh] space-y-2 overflow-auto p-1">
            <div className="text-sm text-gray-600">
              {cliente?.ragione_sociale} · BPoint {bpointClienteStorico.tipo === 'alfieri' ? 'Alfieri' : 'Standard'}
            </div>
            {bpointClienteStorico.versioni.map((versione) => <div key={versione.data_decorrenza} className="rounded-md border border-purple-200 bg-white p-3">
              <div className="mb-2 flex items-center justify-between gap-2">
                <span className="font-semibold text-purple-900">Decorrenza {moment(versione.data_decorrenza).format('MM/YYYY')}</span>
                <div className="flex items-center gap-2"><span className="text-xs text-gray-500">{versione.updated_by ? `da ${versione.updated_by}` : ''}</span><button type="button" disabled={deletingBpointClienteStorico} onClick={() => deleteBpointClienteStorico(versione)} className="rounded border border-red-200 bg-red-50 px-2 py-1 text-xs font-semibold text-red-700 hover:bg-red-100 disabled:opacity-50">Elimina</button></div>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {!versione.fasce.length && <span className="text-xs text-gray-500">Prezzi uguali al listino generale in vigore a questa decorrenza.</span>}
                {versione.fasce.map((fascia) => <div key={`${fascia.tipo}-${fascia.min_cedolini}`} className="rounded border border-purple-100 bg-purple-50 px-2 py-1.5 text-xs text-purple-900">
                  <span className="font-semibold">{fascia.min_cedolini}–{fascia.max_cedolini ?? '∞'}</span>
                  <span className="ml-2 text-gray-500 line-through">{fmt(fascia.prezzo_originale)} €</span>
                  <span className="ml-1 font-semibold">→ {fmt(fascia.importo_unitario)} €</span>
                </div>)}
              </div>
            </div>)}
            {!bpointClienteStorico.versioni.length && <div className="rounded border border-gray-200 bg-gray-50 p-6 text-center text-sm text-gray-500">Nessuna versione personalizzata disponibile.</div>}
          </div>
        </Modal>
      )}
      {bpointClientiPersonalizzati !== null && (
        <Modal isOpen size="medium" closeButton={() => setBpointClientiPersonalizzati(null)} headerText="Clienti con personalizzazioni · Fasce BPoint 427">
          <div className="max-h-[72vh] divide-y overflow-auto rounded-md border border-gray-200 bg-white">
            {loadingBpointClientiPersonalizzati ? <div className="p-8 text-center text-sm text-gray-500">Caricamento...</div> : bpointClientiPersonalizzati.map((gruppo) => <div key={gruppo.codice_univoco_azienda} className="flex items-center justify-between gap-3 px-3 py-2.5">
              <span className="min-w-0 truncate text-sm font-medium text-gray-900">{gruppo.ragione_sociale}</span>
              <span className={`shrink-0 rounded border px-2 py-1 text-xs font-semibold ${gruppo.tipo === 'alfieri' ? 'border-purple-200 bg-purple-50 text-purple-700' : 'border-blue-200 bg-blue-50 text-blue-700'}`}>BPoint {gruppo.tipo === 'alfieri' ? 'Alfieri' : 'Standard'}</span>
            </div>)}
            {!loadingBpointClientiPersonalizzati && !bpointClientiPersonalizzati.length
              && <div className="p-8 text-center text-sm text-gray-500">Nessun cliente con personalizzazioni attive.</div>}
          </div>
        </Modal>
      )}
      {bpointClientiTariffaEreditata !== null && (
        <Modal isOpen size="medium" closeButton={() => setBpointClientiTariffaEreditata(null)} headerText="Tariffe ereditate · Fasce BPoint 427">
          <div className="max-h-[72vh] overflow-auto rounded-md border border-gray-200 bg-white">
            {loadingBpointClientiTariffaEreditata ? <div className="p-8 text-center text-sm text-gray-500">Caricamento...</div> : <table className="w-full text-sm">
              <thead className="sticky top-0 bg-gray-50 text-left text-xs uppercase text-gray-500"><tr>
                <th className="px-3 py-2">Cliente</th><th className="px-3 py-2">Tariffa ereditata da</th>
              </tr></thead>
              <tbody>{bpointClientiTariffaEreditata.map((row) => <tr key={row.codice_univoco_azienda} className="border-t">
                <td className="px-3 py-2.5"><div className="font-medium text-gray-900">{row.ragione_sociale}</div><div className="text-xs text-gray-500">{row.codice_univoco_azienda} · BPoint {Number(row.alfieri) === 1 ? 'Alfieri' : 'Standard'}{row.data_fine_elaborazioni ? ' · Cessato' : ''}</div></td>
                <td className="px-3 py-2.5"><div className="font-medium text-pink-800">{row.ragione_sociale_tariffa}</div><div className="text-xs text-gray-500">{row.codice_univoco_azienda_tariffa} · BPoint {Number(row.alfieri_tariffa) === 1 ? 'Alfieri' : 'Standard'}</div></td>
              </tr>)}</tbody>
            </table>}
            {!loadingBpointClientiTariffaEreditata && !bpointClientiTariffaEreditata.length && <div className="p-8 text-center text-sm text-gray-500">Nessun cliente con tariffa ereditata.</div>}
          </div>
        </Modal>
      )}
    </div>
  );
};

const Info = ({ label, value }) => (
  <div className="border rounded-md px-3 py-2 bg-gray-50 min-h-[58px]">
    <div className="text-[11px] uppercase font-medium text-gray-500">{label}</div>
    <div className="text-sm text-gray-800 truncate">{value || "-"}</div>
  </div>
);
